// This file is auto-generated by @hey-api/openapi-ts

export type UploadUrl = {
  fileName: string;
  fileType: string;
};

export type FindItemCommentQuery = {
  /**
   * Limit
   */
  limit?: number;
  /**
   * Cursor
   */
  cursor?: string;
  /**
   * Direction
   */
  direction?: 'asc' | 'desc';
  /**
   * Item Number
   */
  itemNumber: string;
};

export type FindImportJobsQuery = {
  /**
   * Limit
   */
  limit?: number;
  /**
   * Cursor
   */
  cursor?: string;
  /**
   * Direction
   */
  direction?: 'asc' | 'desc';
  type?: 'trello' | 'template';
};

export type CheckIfOrganizationExists = {
  name: string;
};

export type CustomFieldFormGroupQuery = {
  customFieldCollectionId?: string;
};

export type ItemRequestQuery = {
  parentNumber?: string;
  workTypeId?: string;
};

export enum NotificationUserRole {
  CREATOR = 'creator',
  MENTIONED = 'mentioned',
  ASSIGNEE = 'assignee',
  PARTICIPANT = 'participant',
  WATCHER = 'watcher',
  CUSTOM = 'custom',
}

export enum NotificationType {
  MESSAGE = 'message',
  ITEM = 'item',
  CUSTOM = 'custom',
}

export enum ItemNotificationAction {
  CREATE = 'create',
  ARCHIVE = 'archive',
  UNARCHIVE = 'unarchive',
  ITEM_DESCRIPTION_MENTION = 'item_description_mention',
  PARENT_MODIFIED = 'parent_modified',
  CUSTOM_FIELD_MODIFIED = 'custom_field_modified',
  TAGS_MODIFIED = 'tags_modified',
  TEAM_MODIFIED = 'team_modified',
  ASSIGNEE_MODIFIED = 'assignee_modified',
  SUB_ITEM_ASSIGNEE_MODIFIED = 'sub_item_assignee_modified',
  ESTIMATE_MODIFIED = 'estimate_modified',
  POINT_EFFORT_MODIFIED = 'point_effort_modified',
  PARTICIPANT_MODIFIED = 'participant_modified',
  BOARD_MODIFIED = 'board_modified',
  LANE_MODIFIED = 'lane_modified',
  RELATIONSHIPS_MODIFIED = 'relationships_modified',
  DESCRIPTION_MODIFIED = 'description_modified',
  ASSETS_MODIFIED = 'assets_modified',
  PULL_REQUEST_MODIFIED = 'pull_request_modified',
  TITLE_MODIFIED = 'title_modified',
  START_DATE_MODIFIED = 'start_date_modified',
  DUE_DATE_MODIFIED = 'due_date_modified',
  TIME_SPENT_SECONDS_MODIFIED = 'time_spent_seconds_modified',
  PRIORITY_MODIFIED = 'priority_modified',
  WORK_TYPE_MODIFIED = 'work_type_modified',
  SUB_ITEM_CREATED = 'sub_item_created',
  SUB_ITEM_DELETED = 'sub_item_deleted',
  SUB_ITEM_TITLE_MODIFIED = 'sub_item_title_modified',
  SUB_ITEM_COMPLETED_MODIFIED = 'sub_item_completed_modified',
  SUB_ITEM_START_DATE_MODIFIED = 'sub_item_start_date_modified',
  SUB_ITEM_DUE_DATE_MODIFIED = 'sub_item_due_date_modified',
  PERMISSIONS_GRANTED = 'permissions_granted',
}

export enum MessageNotificationAction {
  ITEM_COMMENT = 'item_comment',
  REPLY = 'reply',
  MENTION = 'mention',
}

export enum NotificationChannel {
  IN_APP = 'in_app',
  EMAIL = 'email',
  SLACK = 'slack',
}

export type Notification = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  userId: string;
  groupId: string;
  referenceId: string;
  summary: string;
  role: NotificationUserRole;
  saved: boolean;
  read: boolean;
  data: {
    [key: string]:
      | {
          [key: string]: unknown;
        }
      | string
      | number
      | boolean
      | null
      | unknown
      | Array<
          | {
              [key: string]: unknown;
            }
          | string
          | number
          | boolean
          | null
          | unknown
        >;
  };
  type: NotificationType;
  action: ItemNotificationAction | MessageNotificationAction | 'custom';
  triggerUserId: string;
  teamId?: string;
  channel: NotificationChannel;
};

export enum ActivityLogType {
  WORK_ITEM = 'work_item',
  FOLDER = 'folder',
  FIELD_CHANGED = 'field_changed',
  ASSET_GROUP = 'asset_group',
  ASSET_ITEM = 'asset_item',
  BRANCH = 'branch',
  COMMIT = 'commit',
  REVIEW = 'review',
  CHECK = 'check',
  PULL_REQUEST = 'pull_request',
}

export enum ActivityLogActionType {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
  ARCHIVED = 'archived',
  UNARCHIVED = 'unarchived',
}

export type ActivityLog = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  referenceId: string;
  type: ActivityLogType;
  action: ActivityLogActionType;
  transactionDate: string;
  data: {
    [key: string]:
      | {
          [key: string]: unknown;
        }
      | string
      | number
      | boolean
      | null
      | unknown
      | Array<
          | {
              [key: string]: unknown;
            }
          | string
          | number
          | boolean
          | null
          | unknown
        >;
  };
  userId: string;
};

export type ChatMessage = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  userId: string;
  chatId: string;
  message: string;
  response: string;
  progress: Array<string>;
  references: Array<{
    title: string;
    url: string;
  }>;
  finished: boolean;
};

/**
 * ChatMessage Response
 */
export type ChatMessageResponse = {
  data: ChatMessage;
};

export type CreateChatMessageRequest = {
  message: string;
};

export type Chat = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  userId: string;
};

/**
 * Chat Response
 */
export type ChatResponse = {
  data: Chat;
};

export type GenerateItemDescription = {
  html: string;
};

/**
 * Generate Item Description Response
 */
export type GenerateItemDescriptionResponse = {
  data: GenerateItemDescription;
};

export type GenerateItemDescriptionRequest = {
  title: string;
  description?: {
    html: string;
  };
  template: string;
  additionalInstructions: string;
};

/**
 * Proxy Ai Request Response
 */
export type ProxyAiRequestResponse = {
  data: {
    status: number;
    headers: {
      [key: string]: string;
    };
    output?: unknown;
  };
};

export type ProxyAiRequest = {
  method: 'GET' | 'POST' | 'PUT' | 'DELETE';
  url: string;
  headers?: {
    [key: string]: string;
  };
  body?: unknown;
  queryParams?: {
    [key: string]: string;
  };
};

export enum ExportJobType {
  ITEMS = 'items',
}

export enum ExportJobStatus {
  CREATED = 'created',
  RUNNING = 'running',
  FINISHED = 'finished',
  FAILED = 'failed',
}

export type ExportJob = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  userId: string;
  name: string;
  type: ExportJobType;
  options: {
    [key: string]:
      | {
          [key: string]: unknown;
        }
      | string
      | number
      | boolean
      | null
      | unknown
      | Array<
          | {
              [key: string]: unknown;
            }
          | string
          | number
          | boolean
          | null
          | unknown
        >;
  };
  errors: Array<string>;
  status: ExportJobStatus;
};

/**
 * Export Job Response
 */
export type ExportJobResponse = {
  data: ExportJob;
};

export enum ConditionOperator {
  EQUAL = 'equal',
  NOT_EQUAL = 'notEqual',
  IN = 'in',
  NOT_SET = 'notSet',
  IS_SET = 'isSet',
  NOT_IN = 'notIn',
  CONTAINS = 'contains',
  DOES_NOT_CONTAIN = 'doesNotContain',
  LESS_THAN = 'lessThan',
  LESS_THAN_INCLUSIVE = 'lessThanInclusive',
  GREATER_THAN = 'greaterThan',
  GREATER_THAN_INCLUSIVE = 'greaterThanInclusive',
  ASSIGNEE_IN_SUB_ITEMS = 'assigneeInSubItems',
}

export type Condition = {
  operator: ConditionOperator;
  value?: string | number | boolean | Array<string | number | boolean>;
};

export type ConditionSet = {
  all?: Array<Condition>;
  any?: Array<Condition>;
};

export type CustomFieldConditions = {
  [key: string]: ConditionSet;
};

export type CreateExportItemsJob = {
  name: string;
  columns: Array<
    | '*'
    | 'id'
    | 'dateAdded'
    | 'dateUpdated'
    | 'organization'
    | 'workType'
    | 'number'
    | 'title'
    | 'parentNumber'
    | 'startDate'
    | 'dueDate'
    | 'hierarchy'
    | 'priority'
    | 'author'
    | 'team'
    | 'lane'
    | 'color'
    | 'optimisticEstimate'
    | 'likelyEstimate'
    | 'pessimisticEstimate'
    | 'pointEffort'
    | 'childrenPointEffortAggregations'
    | 'timeSpentSeconds'
    | 'estimate'
    | 'childrenEstimateAggregations'
    | 'estimateSd'
    | 'isBug'
    | 'blocker'
    | 'description_text'
    | 'description_html'
    | 'participants'
    | 'commentCount'
    | 'archived'
    | 'customFields'
    | 'labels'
    | 'completedBy'
    | 'assignee'
    | 'board'
    | 'assignedAt'
    | 'completedAt'
    | 'timeEntriesTotalSeconds'
    | 'organizationId'
    | 'workTypeId'
    | 'laneId'
    | 'priorityId'
    | 'numericItemNumber'
    | 'teamId'
    | 'boardId'
    | 'authorUsername'
    | 'assigneeUsername'
    | 'completedByUser'
  >;
  filters: {
    parentNumber?: Array<string>;
    rootFolderNumber?: Array<string>;
    workTypeId?: Array<string>;
    boardId?: Array<string>;
    teamId?: Array<string>;
    laneId?: Array<string>;
    isBacklog?: boolean;
    cycleRange?: Array<number>;
    startDate?: string;
    dueDate?: string;
    q?: string;
    isBug?: boolean;
    hasBlocker?: boolean;
    labels?: Array<string>;
    hierarchy?: Array<string>;
    isUnassigned?: boolean;
    hasNoTeam?: boolean;
    hasNoBoard?: boolean;
    assigneeUsername?: Array<string>;
    number?: Array<string>;
    color?: Array<string>;
    priority?: Array<string>;
    isDone?: boolean;
    startDateGTE?: string;
    startDateLTE?: string;
    dueDateGTE?: string;
    dueDateLTE?: string;
    timeSpentSecondsGTE?: number;
    timeSpentSecondsLTE?: number;
    direction?: 'asc' | 'desc';
    sort?:
      | 'title'
      | 'assigneeUsername'
      | 'priority'
      | 'lane'
      | 'dateAdded'
      | 'estimate';
    customFields?: CustomFieldConditions;
    itemType: 'workitem';
  };
};

/**
 * Export Job List Response
 */
export type ExportJobListResponse = {
  data: Array<ExportJob>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

/**
 * Cube token Response
 */
export type CubeToken = {
  data: {
    token: string;
  };
};

export enum AssetGroupType {
  DESCRIPTION_ASSETS = 'description_assets',
  CUSTOM = 'custom',
}

export type AssetItem = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  itemNumber: string;
  name?: string;
  url: string;
  groupId: string;
  createdBy: string;
  rank: string;
  metadata: {
    type?: string;
    title?: string;
    description?: string;
    favicon?: string;
    author?: string;
    thumbnail?: string;
  };
};

export type AssetGroup = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  itemNumber: string;
  name: string;
  type: AssetGroupType;
  createdBy: string;
  rank: string;
  items: Array<AssetItem>;
};

/**
 * Asset Group Response
 */
export type AssetGroupResponse = {
  data: AssetGroup;
};

export type CreateAssetGroup = {
  name: string;
};

/**
 * Asset Item Response
 */
export type AssetItemResponse = {
  data: AssetItem;
};

export type CreateAssetItem = {
  name: string;
  groupId: string;
  url: string;
};

export type UpdateAssetItem = {
  name?: string;
  groupId?: string;
  rankAbove?: string;
  rankBelow?: string;
};

export type UpdateAssetGroup = {
  name?: string;
  rankAbove?: string;
  rankBelow?: string;
};

/**
 * Asset Group List Response
 */
export type AssetGroupListResponse = {
  data: Array<AssetGroup>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

/**
 * Asset Download URL Response
 */
export type AssetDownloadUrlResponse = {
  data: {
    downloadUrl: string;
  };
};

/**
 * Pre Signed Url Response
 */
export type PreSignedUrlResponse = {
  url: string;
  fields: {
    [key: string]: string;
  };
};

export enum Colors {
  GRAY_MEDIUM_DARK = 'gray-medium-dark',
  RED = 'red',
  PINK = 'pink',
  ORANGE = 'orange',
  YELLOW = 'yellow',
  LIME = 'lime',
  GREEN = 'green',
  TEAL = 'teal',
  BLUE = 'blue',
  BLUE_MEDIUM = 'blue-medium',
  PURPLE = 'purple',
}

export enum CadenceUnit {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  QUARTER = 'quarter',
  YEAR = 'year',
}

export type CadenceIntegrations = {
  ado?: {
    projectId: string;
    installationId: string;
  };
  jira?: {
    projectId: string;
    installationId: string;
  };
};

export type Cadence = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  label: string;
  color: Colors;
  every: {
    value: number;
    unit: CadenceUnit;
  };
  parentId?: string;
  allowOverlappingTimeBoxes: boolean;
  timeBoxCount: number;
  timeBoxLabelTemplate: string;
  archived: boolean;
  integrations?: CadenceIntegrations;
};

/**
 * Cadence Response
 */
export type CadenceResponse = {
  data: Cadence;
};

export type CreateCadence = {
  label: string;
  color: Colors;
  every: {
    value: number;
    unit: CadenceUnit;
  };
  parentId?: string;
  timeBoxCount?: number;
  timeBoxLabelTemplate: string;
};

export type UpdateCadence = {
  parentId?: string | null;
  label?: string;
  color?: Colors;
  every?: {
    value: number;
    unit: CadenceUnit;
  };
  timeBoxCount?: number;
  timeBoxLabelTemplate?: string;
};

export type TimeBoxIntegrations = {
  ado?: {
    projectId: string;
    iterationId: number;
    installationId: string;
  };
  jira?: {
    projectId: string;
    sprintId: number;
    installationId: string;
  };
};

export type BaseTimeBox = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  cadenceId: string;
  parentTimeBoxId?: string;
  label: string;
  startDate: string;
  endDate: string;
  integrations?: TimeBoxIntegrations;
};

export type TimeBox = BaseTimeBox & {
  children: Array<TimeBox>;
};

export type CreateTimeBoxRoot = {
  cadenceId: string;
  label: string;
  startDate: string;
  endDate: string;
  parentTimeBoxId?: string;
};

export type CreateTimeBox = CreateTimeBoxRoot & {
  children: Array<CreateTimeBox>;
};

export type UpdateTimeBox = {
  cadenceId: string;
  label: string;
  startDate: string;
  endDate: string;
  children: Array<UpdateTimeBox>;
};

export type DeleteTimeBox = {
  moveToTimeBoxId: string | null;
};

export enum BoardHierarchyType {
  BOARD_FOLDER = 'board-folder',
  BOARD = 'board',
}

export type BoardHierarchy = {
  id: string;
  type: BoardHierarchyType;
  label: string;
  archived: boolean;
};

export type BoardFolderIntegrations = {
  ado?: {
    projectId: string;
    installationId: string;
  };
  jira?: {
    projectId: string;
    installationId: string;
  };
};

export enum PermissionLevel {
  VIEWER = 'viewer',
  COMMENTER = 'commenter',
  EDITOR = 'editor',
  OWNER = 'owner',
  INHERITED_OWNER = 'inherited_owner',
  DENIED = 'denied',
}

export type BoardFolder = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  label: string;
  parentId?: string;
  hierarchy: Array<BoardHierarchy>;
  canHaveFolders: boolean;
  canHaveBoards: boolean;
  canHaveCycles: boolean;
  laneCollectionId?: string;
  defaultTeamId?: string;
  cadenceId?: string;
  folderCount: number;
  boardCount: number;
  cycleCount: number;
  archived: boolean;
  integrations?: BoardFolderIntegrations;
  createdBy: string;
  userPermissions: {
    [key: string]: PermissionLevel;
  };
  teamPermissions: {
    [key: string]: PermissionLevel;
  };
  organizationPermissions?: PermissionLevel & (string | null);
  permissions?: {
    canRead: boolean;
    canUpdate: boolean;
    canDelete: boolean;
  };
};

/**
 * Board Folder Response
 */
export type BoardFolderResponse = {
  data: BoardFolder;
};

export type CreateBoardFolder = {
  label: string;
  parentId?: string;
  canHaveFolders: boolean;
  canHaveBoards: boolean;
  canHaveCycles: boolean;
  laneCollectionId?: string;
  defaultTeamId?: string;
  cadenceId?: string;
};

export type UserPermissions = {
  [key: string]: PermissionLevel;
};

export type TeamPermissions = {
  [key: string]: PermissionLevel;
};

export type UpdateBoardFolder = {
  label?: string;
  parentId?: string | null;
  canHaveFolders?: boolean;
  canHaveBoards?: boolean;
  canHaveCycles?: boolean;
  laneCollectionId?: string;
  defaultTeamId?: string | null;
  cadenceId?: string;
  customUserPermissions?: UserPermissions;
  customTeamPermissions?: TeamPermissions;
  customOrganizationPermissions?: PermissionLevel;
  changeUserOwnership?: string;
  changeTeamOwnership?: string;
};

export type BoardIntegrations = {
  ado?: {
    projectId: string;
    iterationId: number;
    installationId: string;
  };
  jira?: {
    projectId: string;
    sprintId?: number;
    installationId: string;
  };
};

export type Board = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  label: string;
  description?: string;
  boardFolderId: string;
  hierarchy: Array<BoardHierarchy>;
  timeBased: boolean;
  startDate?: string;
  endDate?: string;
  timeBoxId?: string;
  laneCollectionId?: string;
  defaultTeamId?: string;
  aggregations: {
    [key: string]: {
      itemCount: number;
      optimisticEstimate: number;
      likelyEstimate: number;
      pessimisticEstimate: number;
      pointEffort: number;
      timeSpentSeconds: number;
    };
  };
  archivedAggregations: {
    [key: string]: {
      itemCount: number;
      optimisticEstimate: number;
      likelyEstimate: number;
      pessimisticEstimate: number;
      pointEffort: number;
      timeSpentSeconds: number;
    };
  };
  archived: boolean;
  integrations?: BoardIntegrations;
  createdBy?: string;
  permissions?: {
    canRead: boolean;
    canUpdate: boolean;
    canDelete: boolean;
  };
  userPermissions: {
    [key: string]: PermissionLevel;
  };
  teamPermissions: {
    [key: string]: PermissionLevel;
  };
  organizationPermissions?: PermissionLevel & (string | null);
};

/**
 * Board Response
 */
export type BoardResponse = {
  data: Board;
};

export type CreateBoard = {
  label: string;
  boardFolderId: string;
  description?: string;
  laneCollectionId: string;
  defaultTeamId?: string;
};

export type UpdateBoard = {
  label?: string;
  boardFolderId?: string;
  description?: string;
  laneCollectionId?: string;
  defaultTeamId?: string | null;
  customUserPermissions?: UserPermissions;
  customTeamPermissions?: TeamPermissions;
  customOrganizationPermissions?: PermissionLevel;
  changeUserOwnership?: string;
  changeTeamOwnership?: string;
};

export type ArchiveBoard = {
  moveToBoardId: string | null;
};

export type FavoriteBoard = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  userId: string;
  boardFolders: Array<string>;
  boards: Array<string>;
};

export type UpdateFavoriteBoards = {
  boardFolders?: Array<string>;
  addBoardFolders?: Array<string>;
  removeBoardFolders?: Array<string>;
  boards?: Array<string>;
  addBoards?: Array<string>;
  removeBoards?: Array<string>;
};

/**
 * Cadence List Response
 */
export type CadenceListResponse = {
  data: Array<Cadence>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

/**
 * Board Folder List Response
 */
export type BoardFolderListResponse = {
  data: Array<BoardFolder>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

/**
 * Board List Response
 */
export type BoardListResponse = {
  data: Array<Board>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

export enum CommentType {
  ITEM = 'item',
  REPLY = 'reply',
}

export type Comment = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  referenceId: string;
  authorUsername: string;
  type: CommentType;
  message: {
    html: string;
  };
  reactions: Array<{
    reaction: string;
    users: Array<{
      username: string;
      dateAdded: string;
    }>;
    dateAdded: string;
  }>;
  favorites: Array<string>;
  replyCount: number;
  replyUsers: Array<{
    username: string;
    replyCount: number;
  }>;
  mentionUsers: Array<{
    username: string;
    mentionCount: number;
  }>;
  archived: boolean;
  edited: boolean;
};

/**
 * Comment Response
 */
export type CommentResponse = {
  data: Comment;
};

export type AddCommentReaction = {
  reaction: string;
};

export type CreateComment = {
  message: {
    html: string;
  };
};

export type CreateItemComment = {
  message: {
    html: string;
  };
  itemNumber: string;
};

export type UpdateComment = {
  message: {
    html: string;
  };
};

/**
 * Comment List Response
 */
export type CommentListResponse = {
  data: Array<Comment>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

export type CommentMessageHistory = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  commentId: string;
  message: {
    html: string;
  };
};

/**
 * Comment Message History List Response
 */
export type CommentMessageHistoryListResponse = {
  data: Array<CommentMessageHistory>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

export enum GithubInstallationTypes {
  ORGANIZATION = 'organization',
  USER = 'user',
}

export type GithubInstallation = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  installationId: number;
  type: GithubInstallationTypes;
  login: string;
  company?: string;
  name?: string;
  description?: string;
  avatarUrl: string;
};

/**
 * Github Installation  Response
 */
export type GithubInstallationResponse = {
  data: GithubInstallation;
};

export type CreateGithubInstallation = {
  installationId: string;
};

export type Branch = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  name: string;
  owner: string;
  repo: string;
  authorLogin: string;
  authorAvatarUrl: string;
  compareUrl: string;
  items: Array<string>;
};

/**
 * Branch List Response
 */
export type BranchListResponse = {
  data: Array<Branch>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

export type Commit = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  commitId: string;
  message: string;
  owner: string;
  repo: string;
  branch: string;
  authorLogin: string;
  authorAvatarUrl: string;
  url: string;
  items: Array<string>;
};

/**
 * Commit List Response
 */
export type CommitListResponse = {
  data: Array<Commit>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

export enum PullRequestStatus {
  OPEN = 'open',
  CLOSED = 'closed',
  MERGED = 'merged',
  DRAFT = 'draft',
}

export enum PullRequestReviewStatus {
  CHANGES_REQUESTED = 'changes_requested',
  DISMISSED = 'dismissed',
  APPROVED = 'approved',
  COMMENTED = 'commented',
  PENDING = 'pending',
}

export enum PullRequestCheckRunConclusion {
  SUCCESS = 'success',
  FAILURE = 'failure',
  NEUTRAL = 'neutral',
  CANCELLED = 'cancelled',
  TIMED_OUT = 'timed_out',
  ACTION_REQUIRED = 'action_required',
  STALE = 'stale',
  SKIPPED = 'skipped',
  PENDING = 'pending',
}

export type PullRequestReview = {
  pullRequestReviewGithubId: number;
  authorLogin: string;
  authorAvatarUrl: string;
  body: string;
  status: PullRequestReviewStatus;
  dateAdded: string;
};

export type PullRequestCheckRun = {
  pullRequestCheckRunGithubId: number;
  title: string;
  summary: string;
  url: string;
  conclusion: PullRequestCheckRunConclusion;
  appOwnerLogin: string;
  appOwnerAvatarUrl: string;
  dateAdded: string;
};

export type PullRequest = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  pullRequestGithubId: number;
  number: number;
  title: string;
  body: string;
  authorLogin: string;
  authorAvatarUrl: string;
  baseBranch: string;
  headBranch: string;
  additions: number;
  deletions: number;
  status: PullRequestStatus;
  items: Array<string>;
  repositoryFullName: string;
  owner: string;
  repo: string;
  repositoryId: number;
  dateOpened: string;
  dateMerged?: string;
  dateClosed?: string;
  url: string;
  mergedByLogin?: string;
  mergedByAvatarUrl?: string;
  closedByLogin?: string;
  closedByAvatarUrl?: string;
  reviewStatus?: PullRequestReviewStatus;
  checkStatus?: PullRequestCheckRunConclusion;
  commentCount: number;
  reviewCommentCount: number;
  reviewsCount?: number;
  commitCount: number;
  checkCount?: number;
  filesChangedCount: number;
  reviews: Array<PullRequestReview>;
  checks: Array<PullRequestCheckRun>;
};

/**
 * Pull Request List Response
 */
export type PullRequestListResponse = {
  data: Array<PullRequest>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

export enum ImportJobType {
  TRELLO = 'trello',
  TEMPLATE = 'template',
}

export enum ImportVariableType {
  DATE = 'date',
  NUMBER = 'number',
  STRING = 'string',
  USER = 'user',
  BOARD = 'board',
}

export type ImportVariable = {
  name: string;
  type: ImportVariableType;
};

export type ImportJobCount = {
  labelCount: number;
  labelCollectionsCount: number;
  laneCount: number;
  laneCollectionsCount: number;
  priorityCount: number;
  priorityCollectionsCount: number;
  customFieldCount: number;
  folderCustomFieldCount: number;
  customFieldCollectionsCount: number;
  estimateOptionCount: number;
  estimateOptionCollectionsCount: number;
  userLabelGroupCount: number;
  memberCount: number;
  teamCount: number;
  workTypeCount: number;
  folderCount: number;
  workItemCount: number;
  boardCount: number;
};

export type ImportJob = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  authorUsername: string;
  type: ImportJobType;
  delimiter: string;
  variables: Array<ImportVariable>;
  importCount: ImportJobCount;
  importDataUrl: string;
  convertedDataUrl: string;
};

/**
 * Import Job Response
 */
export type ImportJobResponse = {
  data: ImportJob;
};

export type CreateImportJob = {
  type: 'trello' | 'template';
  importDataUrl: string;
  delimiter?: string;
};

export type ImportError = {
  entity: string;
  data?: {
    [key: string]: unknown;
  };
  message: string;
};

export enum ImportEntity {
  LABEL_ENTITY = 'LabelEntity',
  LABEL_COLLECTION_ENTITY = 'LabelCollectionEntity',
  LANE_ENTITY = 'LaneEntity',
  LANE_COLLECTION_ENTITY = 'LaneCollectionEntity',
  PRIORITY_ENTITY = 'PriorityEntity',
  PRIORITY_COLLECTION_ENTITY = 'PriorityCollectionEntity',
  CUSTOM_FIELD_ENTITY = 'CustomFieldEntity',
  CUSTOM_FIELD_COLLECTION_ENTITY = 'CustomFieldCollectionEntity',
  ESTIMATE_OPTION_ENTITY = 'EstimateOptionEntity',
  ESTIMATE_OPTION_COLLECTION_ENTITY = 'EstimateOptionCollectionEntity',
  USER_LABEL_GROUP_ENTITY = 'UserLabelGroupEntity',
  USER_ENTITY = 'UserEntity',
  ROLE_ENTITY = 'RoleEntity',
  TEAM_ENTITY = 'TeamEntity',
  ORGANIZATION_ENTITY = 'OrganizationEntity',
  ORGANIZATION_MEMBERSHIP_ENTITY = 'OrganizationMembershipEntity',
  WORK_TYPE_ENTITY = 'WorkTypeEntity',
  FOLDER_ENTITY = 'FolderEntity',
  WORK_ITEM_ENTITY = 'WorkItemEntity',
  SUB_ITEM_ENTITY = 'SubItemEntity',
  STORAGE_ENTITY = 'StorageEntity',
  BOARD_ENTITY = 'BoardEntity',
  UNKNOWN = 'Unknown',
}

export type CreatedImportResultItem = {
  entity: ImportEntity;
  data?: {
    [key: string]: unknown;
  };
};

export type UpdatedImportResultItem = {
  entity: ImportEntity;
  data: {
    before?: {
      [key: string]: unknown;
    };
    after?: {
      [key: string]: unknown;
    };
  };
};

export type FailedImportResultItem = {
  entity: ImportEntity;
  message: string;
  data?: {
    [key: string]: unknown;
  };
};

export type ImportResult = {
  created: Array<CreatedImportResultItem>;
  updated: Array<UpdatedImportResultItem>;
  existing: Array<CreatedImportResultItem>;
  failed: Array<FailedImportResultItem>;
};

export type ImportJobRun = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  importJobId: string;
  parentNumber?: string;
  authorUsername: string;
  status: 'running' | 'finished' | 'failed';
  variables?: {
    [key: string]: string | number | boolean;
  };
  errors: Array<ImportError>;
  dryRun: boolean;
  importResult: ImportResult;
};

/**
 * Import Job Run Response
 */
export type ImportJobRunResponse = {
  data: ImportJobRun;
};

export type CreateImportJobRun = {
  parentNumber?: string;
  variables?: {
    [key: string]: string | number | boolean;
  };
};

export type ExportVariable = {
  name: string;
  value?: unknown;
  isExcelFormula?: boolean;
};

export type GenerateExportFile = {
  number?: string;
  assignees?: Array<ExportVariable>;
  boards?: Array<ExportVariable>;
  startDate?: ExportVariable;
  delimiter?: string;
};

/**
 * Import Job Run List Response
 */
export type ImportJobRunListResponse = {
  data: Array<ImportJobRun>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

/**
 * Import Job List Response
 */
export type ImportJobListResponse = {
  data: Array<ImportJob>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

export enum IntegrationProvider {
  JIRA = 'jira',
  ADO = 'ado',
}

export enum ItemDisconnectBehavior {
  DETACH = 'detach',
  DELETE = 'delete',
}

export type AdoTeamMappings = {
  [key: string]: {
    id: string;
  };
};

export type AdoStatusMappings = {
  [key: string]: string;
};

export type AdoLabelMappings = {
  [key: string]: string;
};

export type AdoPriorityMappings = {
  [key: string]: string;
};

export type AdoWorkItemTypeMappingValue = {
  workTypeId: string;
  hierarchyLevel: number;
  laneMappings: AdoStatusMappings;
  tagMappings: AdoLabelMappings;
  priorityMappings: AdoPriorityMappings;
};

export type AdoWorkItemTypeMappings = {
  [key: string]: AdoWorkItemTypeMappingValue;
};

export type AdoProjectMappingValue = {
  isEnabled: boolean;
  name: string;
  itemDisconnectBehavior?: ItemDisconnectBehavior;
  parentNumber?: string;
  laneCollectionId?: string;
  teamMappings: AdoTeamMappings;
  workTypeMappings: AdoWorkItemTypeMappings;
};

export type AdoProjectMappings = {
  [key: string]: AdoProjectMappingValue;
};

export type AdoMappings = {
  projectMappings: AdoProjectMappings;
  type: 'ado';
};

export type JiraStatusMappings = {
  [key: string]: string;
};

export type JiraOptionMappings = {
  [key: string]: string;
};

export type JiraFieldMappings = {
  [key: string]: {
    customFieldId: string;
    optionMappings?: JiraOptionMappings;
  };
};

export type JiraLabelMappings = {
  [key: string]: string;
};

export type JiraPriorityMappings = {
  [key: string]: string;
};

export type JiraWorkItemTypeMappingValue = {
  workTypeId: string;
  boardId?: string;
  laneMappings: JiraStatusMappings;
  fieldMappings: JiraFieldMappings;
  tagMappings: JiraLabelMappings;
  priorityMappings: JiraPriorityMappings;
};

export type JiraWorkItemTypeMappings = {
  [key: string]: JiraWorkItemTypeMappingValue;
};

export type JiraProjectMappingValue = {
  isEnabled: boolean;
  itemDisconnectBehavior?: ItemDisconnectBehavior;
  name: string;
  boardFolderId?: string;
  cadenceId?: string;
  parentNumber?: string;
  laneCollectionId?: string;
  workTypeMappings: JiraWorkItemTypeMappings;
};

export type JiraProjectMappings = {
  [key: string]: JiraProjectMappingValue;
};

export type JiraUserMappings = {
  [key: string]: string;
};

export type JiraMappings = {
  projectMappings: JiraProjectMappings;
  userMappings: JiraUserMappings;
  type: 'jira';
};

export type AdoIntegrationMetadata = {
  type: 'ado';
  adoOrganizationName: string;
};

export type JiraIntegrationMetadata = {
  type: 'jira';
  jiraAccountId: string;
  jiraAccountName: string;
};

export type IntegrationMetadata =
  | AdoIntegrationMetadata
  | JiraIntegrationMetadata;

export type IntegrationInstallation = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  credentialsId: string;
  accountId: string;
  provider: IntegrationProvider;
  config?: AdoMappings | JiraMappings;
  metadata?: IntegrationMetadata;
};

export type IntegrationInstallationResponse = {
  data: IntegrationInstallation;
};

export type CreateIntegrationInstallation = {
  credentialsId: string;
  accountId: string;
  provider: 'jira' | 'ado';
  metadata: IntegrationMetadata;
};

export type ProxyInstallationRequestResponse = {
  data: {
    status: number;
    headers: {
      [key: string]: string;
    };
    output?: unknown;
  };
};

export type IntegrationCredential = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  provider: IntegrationProvider;
  externalId: string;
  name: string;
};

export type IntegrationCredentialsResponse = {
  data: IntegrationCredential;
};

export type CredentialAccount = {
  id: string;
  name: string;
};

export type CredentialsAccountsListResponse = {
  data: Array<CredentialAccount>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

export type IntegrationCredentialsListResponse = {
  data: Array<IntegrationCredential>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

export type IntegrationInstallationListResponse = {
  data: Array<IntegrationInstallation>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

export type ItemHierarchy = {
  title: string;
  itemNumber: string;
};

export enum RelationshipType {
  BLOCKED_BY = 'blocked_by',
  BLOCKS = 'blocks',
  RELATED_TO = 'related_to',
}

export enum RelationshipEntity {
  WORKITEM = 'workitem',
  FOLDER = 'folder',
  MILESTONE = 'milestone',
}

export type Relationship = {
  type: RelationshipType;
  entity: RelationshipEntity;
  referenceId: string;
};

export type ConfidenceObject = {
  percentage: string;
  sd: number;
};

export type ItemAggregations = {
  totalOptimisticEstimate: number;
  totalLikelyEstimate: number;
  totalPessimisticEstimate: number;
  totalEstimate: number;
  totalEstimateSd: number;
  totalEstimateConfidenceTable: Array<ConfidenceObject>;
  totalPointEffort: number;
  totalTimeSpentSeconds: number;
  totalOptimisticEstimateCompleted: number;
  totalLikelyEstimateCompleted: number;
  totalPessimisticEstimateCompleted: number;
  totalEstimateCompleted: number;
  totalEstimateSdCompleted: number;
  totalEstimateCompletedConfidenceTable: Array<ConfidenceObject>;
  totalPointEffortCompleted: number;
  totalTimeSpentSecondsCompleted: number;
  totalItemCount: number;
  totalPlannedItemCount: number;
  totalCompletedItemCount: number;
};

export type FolderIntegrations = {
  ado?: Array<{
    project: {
      id: string;
      name: string;
    };
    installationId: string;
  }>;
  jira?: Array<{
    project: {
      id: string;
      name: string;
    };
    installationId: string;
  }>;
};

export type PermissionAccess = {
  canRead: boolean;
  canComment: boolean;
  canUpdate: boolean;
  canDelete: boolean;
};

export type Folder = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  number: string;
  itemType: 'folder';
  title: string;
  priorityId?: string;
  authorUsername: string;
  color: Colors;
  description: {
    html: string;
  };
  participants: Array<string>;
  commentCount: number;
  archived: boolean;
  folderCount: number;
  archivedFolderCount: number;
  itemCount: number;
  archivedItemCount: number;
  hierarchy: Array<ItemHierarchy>;
  startDate?: string | null;
  dueDate?: string | null;
  minDate?: string;
  maxDate?: string;
  manualPercentCompleted?: number;
  relationships: Array<Relationship>;
  parentNumber?: string;
  parentRank?: string;
  commentLastAdded?: string;
  aggregations: {
    [key: string]: ItemAggregations;
  };
  archivedAggregations: {
    [key: string]: ItemAggregations;
  };
  integrations: FolderIntegrations;
  userPermissions: {
    [key: string]: PermissionLevel;
  };
  teamPermissions: {
    [key: string]: PermissionLevel;
  };
  organizationPermissions?: PermissionLevel;
  permissions?: PermissionAccess;
};

/**
 * Folder Response
 */
export type FolderResponse = {
  data: Folder;
};

export type CreateFolder = {
  title: string;
  description?: {
    html: string;
  };
  parentNumber?: string;
  priorityId?: string;
  color?: Colors;
  startDate?: string | null;
  dueDate?: string | null;
  manualPercentCompleted?: number;
  relationships?: Array<Relationship>;
  staticMode?: boolean;
  rankPosition?: 'top' | 'bottom';
};

export type UpdateFolder = {
  title?: string;
  description?: {
    html: string;
  };
  parentNumber?: string | null;
  priorityId?: string;
  color?: Colors;
  parentRankAbove?: string;
  parentRankBelow?: string;
  startDate?: string | null;
  dueDate?: string | null;
  manualPercentCompleted?: number | null;
  staticMode?: boolean;
  customUserPermissions?: UserPermissions;
  customTeamPermissions?: TeamPermissions;
  customOrganizationPermissions?: PermissionLevel;
  changeUserOwnership?: string;
  changeTeamOwnership?: string;
};

export type UnarchiveFolder = {
  unarchiveChildren?: boolean;
};

/**
 * Folder List Response
 */
export type FolderListResponse = {
  data: Array<Folder>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

export type ArchiveFolders = {
  numbers: Array<string>;
};

export type UpdateFolderRelationships = {
  relationships?: Array<Relationship>;
  addedRelationships?: Array<Relationship>;
  removedRelationships?: Array<Relationship>;
  staticMode?: boolean;
};

export type AssetCustomFieldValue = {
  fileName: string;
  fileUrl: string;
};

export type CustomFields = {
  [key: string]:
    | string
    | number
    | boolean
    | Array<string | number | boolean>
    | Array<AssetCustomFieldValue>
    | null;
};

export type GithubPullRequestIntegrationData = {
  pullRequestGithubId: number;
  branch: string;
  number: number;
  owner: string;
  repo: string;
  title: string;
  status: PullRequestStatus;
  authorLogin: string;
  authorAvatarUrl: string;
  mergedByLogin?: string;
  mergedByAvatarUrl?: string;
  closedByLogin?: string;
  closedByAvatarUrl?: string;
  reviews: Array<{
    authorLogin: string;
    authorAvatarUrl: string;
    status: PullRequestReviewStatus;
  }>;
  checks: Array<{
    pullRequestCheckRunGithubId: number;
    title: string;
    conclusion: PullRequestCheckRunConclusion;
    appOwnerLogin: string;
    appOwnerAvatarUrl: string;
  }>;
};

export type GithubBranchIntegrationData = {
  name: string;
  owner: string;
  repo: string;
  authorLogin: string;
  authorAvatarUrl: string;
};

export type GithubCommitIntegrationData = {
  message: string;
  commitId: string;
  owner: string;
  repo: string;
  branch: string;
  authorLogin: string;
  authorAvatarUrl: string;
};

export type WorkItemIntegrations = {
  github?: {
    pullRequests: Array<GithubPullRequestIntegrationData>;
    branches: Array<GithubBranchIntegrationData>;
    commits: Array<GithubCommitIntegrationData>;
  };
  ado?: {
    id: number;
    project: {
      id: string;
      name: string;
    };
    installationId: string;
    revision: number;
    parent: {
      number: string;
      externalId?: number;
    };
  };
  jira?: {
    id: string;
    project: {
      id: string;
      name: string;
    };
    installationId: string;
    revisionId: string;
    parent: {
      number: string;
      externalId?: string;
    };
  };
};

export enum SubItemStatus {
  NEW = 'new',
  IN_PROGRESS = 'in_progress',
  DONE = 'done',
}

export type SubItemSimple = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  parentNumber: string;
  title: string;
  authorUsername: string;
  commentCount: number;
  parentRank?: string;
  teamId?: string;
  assigneeUsername?: string;
  assignedAt?: string;
  startDate?: string | null;
  dueDate?: string | null;
  optimisticEstimate: number;
  likelyEstimate: number;
  pessimisticEstimate: number;
  pointEffort: number;
  timeSpentSeconds: number;
  commentLastAdded?: string;
  completedAt?: string;
  completedByUser?: string;
  status: SubItemStatus;
};

export type WorkItem = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  workTypeId: string;
  number: string;
  itemType: 'workitem';
  parentNumber: string;
  title: string;
  priorityId: string;
  authorUsername: string;
  color: Colors;
  description: {
    html: string;
  };
  blocker: string;
  participants: Array<string>;
  labels: Array<string>;
  commentCount: number;
  optimisticEstimate: number;
  likelyEstimate: number;
  pessimisticEstimate: number;
  pointEffort: number;
  estimate: number;
  estimateSd: number;
  estimateConfidenceTable: Array<ConfidenceObject>;
  isBug: boolean;
  archived: boolean;
  customFields: CustomFields;
  hierarchy: Array<ItemHierarchy>;
  timeEntriesSecondsByUser: {
    [key: string]: number;
  };
  timeEntriesTotalSeconds: number;
  integrations: WorkItemIntegrations;
  laneId?: string;
  laneRank?: string;
  boardId?: string;
  teamId?: string;
  boardRank?: string;
  parentRank?: string;
  assigneeUsername?: string;
  assignedAt?: string;
  completedByUser?: string;
  completedAt?: string;
  startDate?: string | null;
  dueDate?: string | null;
  commentLastAdded?: string;
  importJobRunId?: string;
  timeSpentSeconds: number;
  relationships: Array<Relationship>;
  isSubItemEstimation: boolean;
  isSubItemTimeSpent: boolean;
  subItems: Array<SubItemSimple>;
  watchers: Array<string>;
  itemCount: number;
  archivedItemCount: number;
  minDate?: string;
  maxDate?: string;
  aggregations: {
    [key: string]: ItemAggregations;
  };
  archivedAggregations: {
    [key: string]: ItemAggregations;
  };
  manualPercentCompleted?: number;
  userPermissions: {
    [key: string]: PermissionLevel;
  };
  teamPermissions: {
    [key: string]: PermissionLevel;
  };
  organizationPermissions?: PermissionLevel;
  permissions?: PermissionAccess;
};

/**
 * Work Item Response
 */
export type WorkItemResponse = {
  data: WorkItem;
};

export type CreateWorkItem = {
  workTypeId?: string;
  title: string;
  parentNumber: string;
  description?: {
    html: string;
  };
  priorityId?: string;
  laneId?: string | null;
  assigneeUsername?: string | null;
  boardId?: string | null;
  teamId?: string | null;
  optimisticEstimate?: number;
  likelyEstimate?: number;
  pessimisticEstimate?: number;
  pointEffort?: number;
  isBug?: boolean;
  blocker?: string;
  color?: Colors;
  customFields?: CustomFields;
  startDate?: string | null;
  dueDate?: string | null;
  labels?: Array<string>;
  relationships?: Array<Relationship>;
  staticMode?: boolean;
  watchers?: Array<string>;
  manualPercentCompleted?: number;
  rankPosition?: 'top' | 'bottom';
};

export type UpdateWorkItem = {
  title?: string;
  parentNumber?: string;
  description?: {
    html: string;
  };
  priorityId?: string;
  laneId?: string | null;
  assigneeUsername?: string | null;
  boardId?: string | null;
  teamId?: string | null;
  workTypeId?: string;
  optimisticEstimate?: number;
  likelyEstimate?: number;
  pessimisticEstimate?: number;
  pointEffort?: number;
  isBug?: boolean;
  blocker?: string;
  color?: Colors;
  customFields?: CustomFields;
  startDate?: string | null;
  dueDate?: string | null;
  labels?: Array<string>;
  boardRankAbove?: string;
  boardRankBelow?: string;
  laneRankAbove?: string;
  laneRankBelow?: string;
  parentRankAbove?: string;
  parentRankBelow?: string;
  addLabels?: Array<string>;
  removeLabels?: Array<string>;
  staticMode?: boolean;
  isSubItemEstimation?: boolean;
  isSubItemTimeSpent?: boolean;
  watchers?: Array<string>;
  addWatchers?: Array<string>;
  removeWatchers?: Array<string>;
  manualPercentCompleted?: number | null;
  customUserPermissions?: UserPermissions;
  customTeamPermissions?: TeamPermissions;
  customOrganizationPermissions?: PermissionLevel;
  changeUserOwnership?: string;
  changeTeamOwnership?: string;
};

export type UnarchiveWorkItem = {
  unarchiveChildren?: boolean;
};

/**
 * Work Item List Response
 */
export type WorkItemListResponse = {
  data: Array<WorkItem>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

export type ArchiveWorkItems = {
  numbers: Array<string>;
};

export type UpdateWorkItemRelationships = {
  relationships?: Array<Relationship>;
  addedRelationships?: Array<Relationship>;
  removedRelationships?: Array<Relationship>;
  staticMode?: boolean;
};

export type BulkUpdateItems = {
  workItems: Array<{
    title?: string;
    parentNumber?: string;
    description?: {
      html: string;
    };
    priorityId?: string;
    laneId?: string | null;
    assigneeUsername?: string | null;
    boardId?: string | null;
    teamId?: string | null;
    workTypeId?: string;
    optimisticEstimate?: number;
    likelyEstimate?: number;
    pessimisticEstimate?: number;
    pointEffort?: number;
    isBug?: boolean;
    blocker?: string;
    color?: Colors;
    customFields?: CustomFields;
    startDate?: string | null;
    dueDate?: string | null;
    labels?: Array<string>;
    boardRankAbove?: string;
    boardRankBelow?: string;
    laneRankAbove?: string;
    laneRankBelow?: string;
    parentRankAbove?: string;
    parentRankBelow?: string;
    addLabels?: Array<string>;
    removeLabels?: Array<string>;
    staticMode?: boolean;
    isSubItemEstimation?: boolean;
    isSubItemTimeSpent?: boolean;
    watchers?: Array<string>;
    addWatchers?: Array<string>;
    removeWatchers?: Array<string>;
    manualPercentCompleted?: number | null;
    customUserPermissions?: UserPermissions;
    customTeamPermissions?: TeamPermissions;
    customOrganizationPermissions?: PermissionLevel;
    changeUserOwnership?: string;
    changeTeamOwnership?: string;
    number: string;
  }>;
  folders: Array<{
    title?: string;
    description?: {
      html: string;
    };
    parentNumber?: string | null;
    priorityId?: string;
    color?: Colors;
    parentRankAbove?: string;
    parentRankBelow?: string;
    startDate?: string | null;
    dueDate?: string | null;
    manualPercentCompleted?: number | null;
    staticMode?: boolean;
    customUserPermissions?: UserPermissions;
    customTeamPermissions?: TeamPermissions;
    customOrganizationPermissions?: PermissionLevel;
    changeUserOwnership?: string;
    changeTeamOwnership?: string;
    number: string;
  }>;
  workItemRelationships?: Array<{
    relationships?: Array<Relationship>;
    addedRelationships?: Array<Relationship>;
    removedRelationships?: Array<Relationship>;
    staticMode?: boolean;
    number: string;
  }>;
};

export enum CopyFields {
  '*' = '*',
  PRIORITY_ID = 'priorityId',
  ASSIGNEE_USERNAME = 'assigneeUsername',
  TEAM_ID = 'teamId',
  OPTIMISTIC_ESTIMATE = 'optimisticEstimate',
  LIKELY_ESTIMATE = 'likelyEstimate',
  PESSIMISTIC_ESTIMATE = 'pessimisticEstimate',
  POINT_EFFORT = 'pointEffort',
  IS_BUG = 'isBug',
  BLOCKER = 'blocker',
  COLOR = 'color',
  DESCRIPTION = 'description',
  CUSTOM_FIELDS = 'customFields',
  LABELS = 'labels',
  RELATIONSHIPS = 'relationships',
  SUB_ITEMS = 'subItems',
  ASSETS = 'assets',
  CHILDREN = 'children',
}

export type CopyWorkItem = {
  newTitle?: string;
  fields: Array<CopyFields>;
};

export type BroadcastWorkItemDraftResponse = {
  success: boolean;
};

export type BroadcastWorkItemDraft = {
  draftDescription: {
    html: string;
  };
};

export type SubItem = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  parentNumber: string;
  title: string;
  authorUsername: string;
  description?: {
    html: string;
  };
  commentCount: number;
  parentRank?: string;
  teamId?: string;
  assigneeUsername?: string;
  assignedAt?: string;
  startDate?: string | null;
  dueDate?: string | null;
  optimisticEstimate: number;
  likelyEstimate: number;
  pessimisticEstimate: number;
  pointEffort: number;
  estimate: number;
  estimateSd: number;
  estimateConfidenceTable: Array<ConfidenceObject>;
  timeSpentSeconds: number;
  commentLastAdded?: string;
  completedAt?: string;
  completedByUser?: string;
  status: SubItemStatus;
};

/**
 * Sub Item Response
 */
export type SubItemResponse = {
  data: SubItem;
};

export type CreateSubItem = {
  title: string;
  description?: {
    html: string;
  };
  assigneeUsername?: string | null;
  startDate?: string | null;
  dueDate?: string | null;
  optimisticEstimate?: number;
  likelyEstimate?: number;
  pessimisticEstimate?: number;
  pointEffort?: number;
  timeSpentSeconds?: number;
  parentRankBelow?: string;
  parentRankAbove?: string;
  status?: SubItemStatus;
};

export type UpdateSubItem = {
  title?: string;
  description?: {
    html: string;
  };
  assigneeUsername?: string | null;
  startDate?: string | null;
  dueDate?: string | null;
  optimisticEstimate?: number;
  likelyEstimate?: number;
  pessimisticEstimate?: number;
  pointEffort?: number;
  timeSpentSeconds?: number;
  parentRankAbove?: string;
  parentRankBelow?: string;
  status?: SubItemStatus;
};

/**
 * Item List Response
 */
export type ItemListResponse = {
  data: Array<Folder | WorkItem>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

export type AdvancedFilterGroup = {
  type: 'group';
  operator: 'all' | 'any';
  children: Array<
    | {
        type: 'rule';
        field: string;
        value: unknown;
      }
    | AdvancedFilterGroup
  >;
};

export enum ItemType {
  FOLDER = 'folder',
  WORKITEM = 'workitem',
}

export type PublicStoredViewItemsResponse = {
  data: Array<
    WorkItem & {
      team?: {
        id: string;
        name: string;
      };
      assignee?: {
        id: string;
        firstName: string;
        lastName: string;
      };
      author?: {
        id: string;
        firstName: string;
        lastName: string;
      };
      board?: {
        id: string;
        label: string;
      };
      lane?: {
        id: string;
        name: string;
      };
      priority?: {
        id: string;
        name: string;
      };
      workType?: {
        id: string;
        title: string;
      };
      parent?: {
        title: string;
        itemNumber: string;
      };
      hierarchyNumbers?: Array<string>;
      customFieldValues?: {
        [key: string]: {
          label: string;
          value: string;
        };
      };
      rootFolder?: {
        title: string;
        itemNumber: string;
      };
      labelsWithNames?: Array<{
        id: string;
        name: string;
      }>;
      boardType?: 'past' | 'current' | 'future';
      titleMarkdown?: string;
      hierarchyMarkdown?: string;
    }
  >;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

export enum JobStatus {
  PENDING = 'pending',
  RUNNING = 'running',
  COMPLETED = 'completed',
  COMPLETED_WITH_ERRORS = 'completed_with_errors',
  FAILED = 'failed',
}

export enum JobType {
  COPY_STREAM = 'copy-stream',
  COPY_ITEM = 'copy-item',
  UPDATE_FILTERED_ITEMS = 'update-filtered-items',
  UPDATE_ITEMS = 'update-items',
  SHIFT_START_DUE_DATE = 'shift-start-due-date',
  CREATE_IMPORT_RUN = 'create-import-run',
  INTEGRATION = 'integration',
  BULK_CREATE_ITEMS = 'bulk-create-items',
}

export type SubmitSmartStreamsJob = {
  title: string;
  instructions: string;
  parentNumber: string;
};

export type CreateCopyStreamJob = {
  folderNumber: string;
  newTitle?: string;
  toParentFolderNumber: string;
};

export type BulkUpdateFilteredItems = {
  filter: {
    parentNumber?: Array<string>;
    rootFolderNumber?: Array<string>;
    workTypeId?: Array<string>;
    boardId?: Array<string>;
    teamId?: Array<string>;
    laneId?: Array<string>;
    isBacklog?: boolean;
    cycleRange?: Array<number>;
    startDate?: string;
    dueDate?: string;
    q?: string;
    isBug?: boolean;
    hasBlocker?: boolean;
    labels?: Array<string>;
    hierarchy?: Array<string>;
    isUnassigned?: boolean;
    hasNoTeam?: boolean;
    hasNoBoard?: boolean;
    assigneeUsername?: Array<string>;
    number?: Array<string>;
    color?: Array<string>;
    priority?: Array<string>;
    isDone?: boolean;
    startDateGTE?: string;
    startDateLTE?: string;
    dueDateGTE?: string;
    dueDateLTE?: string;
    timeSpentSecondsGTE?: number;
    timeSpentSecondsLTE?: number;
    customFields?: CustomFieldConditions;
  };
  update: UpdateWorkItem;
};

export type SingleUpdateWorkItem = Array<
  UpdateWorkItem & {
    number: string;
  }
>;

export type SingleUpdateFolder = Array<
  UpdateFolder & {
    number: string;
  }
>;

export type UpdateItemsJob = {
  workItems: SingleUpdateWorkItem;
  folders: SingleUpdateFolder;
  workItemRelationships?: Array<UpdateWorkItemRelationships>;
};

export type CreateWorkItemArray = Array<CreateWorkItem>;

export type CreateFolderArray = Array<CreateFolder>;

export type BulkCreateItemsJob = {
  workItems: CreateWorkItemArray;
  folders: CreateFolderArray;
};

export type CreateShiftStartDueDateJob = {
  entity: RelationshipEntity;
  referenceId: string;
  newDueDate?: string;
  oldDueDate?: string;
};

export type CreateCopyItemJob = {
  number: string;
  fields: Array<CopyFields>;
  newParentNumber?: string;
  newTitle?: string;
};

export type CreateImportRunJob = {
  importJobId: string;
  parentNumber?: string;
  variables?: {
    [key: string]: string | number | boolean;
  };
  dryRun: boolean;
};

export enum IntegrationJobType {
  ADO_IMPORT = 'ado_import',
  JIRA_IMPORT = 'jira_import',
  ADO_DISABLE_PROJECT = 'ado_disable_project',
  JIRA_DISABLE_PROJECT = 'jira_disable_project',
  ADO_DISABLE_INSTALLATION = 'ado_disable_installation',
  JIRA_DISABLE_INSTALLATION = 'jira_disable_installation',
  ADO_DISABLE_CREDENTIAL = 'ado_disable_credential',
  JIRA_DISABLE_CREDENTIAL = 'jira_disable_credential',
}

export type CreateIntegrationJob = {
  installationId: string;
  projectId: string;
  type: IntegrationJobType;
};

export type DisableProjectIntegrationJob = {
  projectId: string;
  installationId: string;
  itemDisconnectBehavior: ItemDisconnectBehavior;
};

export type DisableInstallationIntegrationJob = {
  installationId: string;
  itemDisconnectBehavior: ItemDisconnectBehavior;
};

export type DisableCredentialIntegrationJob = {
  credentialId: string;
  itemDisconnectBehavior: ItemDisconnectBehavior;
  installationIds?: Array<string>;
};

export enum ImportJobRunStatus {
  RUNNING = 'running',
  FINISHED = 'finished',
  FAILED = 'failed',
}

export type ImportRunJobOutput = {
  importJobRunId: string;
  authorUsername: string;
  importResult: ImportResult;
  errors: Array<ImportError>;
  status: ImportJobRunStatus;
};

export type Job = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  correlationId: string;
  status: JobStatus;
  authUserId: string;
  isFifo: boolean;
  messages?: Array<string>;
  errors: Array<{
    message: string;
    meta?: unknown;
  }>;
  type: JobType;
  input:
    | SubmitSmartStreamsJob
    | CreateCopyStreamJob
    | BulkUpdateFilteredItems
    | UpdateItemsJob
    | BulkCreateItemsJob
    | CreateShiftStartDueDateJob
    | CreateCopyItemJob
    | CreateImportRunJob
    | CreateIntegrationJob
    | DisableProjectIntegrationJob
    | DisableInstallationIntegrationJob
    | DisableCredentialIntegrationJob;
  output?:
    | {
        rootStreamNumber: string;
      }
    | {
        newFolderNumber: string;
      }
    | {
        errors: Array<{
          itemId: string;
          error: string;
        }>;
      }
    | {
        workItems: Array<string>;
        folders: Array<string>;
        errors: Array<{
          itemId: string;
          error: string;
        }>;
      }
    | {
        success: boolean;
      }
    | {
        newItemNumber: string;
      }
    | ImportRunJobOutput;
};

/**
 * Job Response
 */
export type JobResponse = {
  data: Job;
};

export type SubmitBulkCreateItemsJob = {
  input: {
    workItems?: CreateWorkItemArray & unknown;
    folders?: CreateFolderArray & unknown;
  };
};

export type SubmitCopyStreamJob = {
  input: {
    folderNumber: string;
    newTitle?: string;
    toParentFolderNumber: string;
  };
};

export type SubmitCopyItemJob = {
  input: {
    number: string;
    fields: Array<CopyFields>;
    newParentNumber?: string;
    newTitle?: string;
  };
};

export type SubmitShiftStartDueDateJob = {
  input: {
    entity: RelationshipEntity;
    referenceId: string;
    oldDueDate?: string;
    newDueDate?: string;
  };
};

export type UpdateWorkItemExtended = Array<
  UpdateWorkItem & {
    number: string;
  }
>;

export type UpdateFolderExtended = Array<
  UpdateFolder & {
    number: string;
  }
>;

export type UpdateWorkItemRelationshipsExtended = Array<
  UpdateWorkItemRelationships & {
    number: string;
  }
>;

export type SubmitUpdateItemsJob = {
  input: {
    workItems: UpdateWorkItemExtended;
    folders: UpdateFolderExtended;
    workItemRelationships?: UpdateWorkItemRelationshipsExtended;
  };
};

export type SubmitUpdateFilteredItemsJob = {
  input: {
    filter: {
      parentNumber?: Array<string> | Array<string>;
      workTypeId?: Array<string> | Array<string>;
      boardId?: Array<string> | Array<string>;
      rootFolderNumber?: Array<string> | Array<string>;
      teamId?: Array<string> | Array<string>;
      laneId?: Array<string> | Array<string>;
      laneCollectionId?: Array<string> | Array<string>;
      isBacklog?: boolean;
      cycleRange?: Array<number> | Array<number>;
      q?: string;
      isBug?: boolean;
      hasBlocker?: boolean;
      labels?: Array<string> | Array<string>;
      hierarchy?: Array<string> | Array<string>;
      isUnassigned?: boolean;
      hasNoParent?: boolean;
      hasNoTeam?: boolean;
      teamConditions?: ConditionSet;
      hasNoBoard?: boolean;
      boardConditions?: ConditionSet;
      assigneeUsername?: Array<string>;
      assigneeConditions?: ConditionSet;
      authorUsername?: Array<string>;
      assigneeSubItems?: boolean;
      number?: Array<string> | Array<string>;
      color?: Array<string> | Array<string>;
      priority?: Array<string> | Array<string>;
      isDone?: boolean;
      checkChildren?: boolean;
      startDateGTE?: string;
      startDateLTE?: string;
      startDateConditions?: ConditionSet;
      dueDateGTE?: string;
      dueDateLTE?: string;
      dueDateConditions?: ConditionSet;
      timeSpentSecondsGTE?: number | number;
      timeSpentSecondsLTE?: number | number;
      watchers?: Array<string> | Array<string>;
      completedAtGTE?: string;
      completedAtLTE?: string;
      completedAtConditions?: ConditionSet;
      customFields?: CustomFieldConditions | string;
      customFieldExists?: Array<string> | Array<string>;
      advancedFilters?: AdvancedFilterGroup | string;
      itemType?: ItemType;
      includeArchived?: boolean;
      withDescription?: boolean;
    };
    update: UpdateWorkItem & unknown;
  };
};

export type SubmitImportRunJob = {
  input: {
    importJobId: string;
    parentNumber?: string;
    variables?: {
      [key: string]: string | number | boolean;
    };
    dryRun: boolean;
  };
};

export type SubmitDisableInstallationIntegrationJob = {
  input: {
    installationId: string;
    type: IntegrationJobType;
    itemDisconnectBehavior: ItemDisconnectBehavior;
  };
};

export type SubmitIntegrationJob = {
  input: {
    installationId: string;
    projectId: string;
    type: IntegrationJobType;
  };
};

export type SubmitDisableCredentialIntegrationJob = {
  input: {
    credentialId: string;
    type: IntegrationJobType;
    itemDisconnectBehavior: ItemDisconnectBehavior;
  };
};

/**
 * Job List Response
 */
export type JobListResponse = {
  data: Array<Job>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

export type OrganizationDatabaseCredential = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  roleName: string;
  status:
    | 'pending'
    | 'active'
    | 'failed'
    | 'syncing'
    | 'deleting'
    | 'deactivated';
  grantedTables: Array<string>;
  errorMessage: string | null;
};

export type ProductLimits = {
  storage: number;
  smartSuggestions: number;
  actions: number;
};

export type SubscriptionStatus =
  | 'active'
  | 'canceled'
  | 'incomplete'
  | 'incomplete_expired'
  | 'past_due'
  | 'paused'
  | 'trialing'
  | 'unpaid';

export enum LabelType {
  BUG = 'bug',
  BLOCKED = 'blocked',
  CUSTOM = 'custom',
}

export type Label = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  name: string;
  description: string;
  icon: string;
  type: LabelType;
  color: Colors;
};

export enum LaneType {
  NEW = 'new',
  DONE = 'done',
  CUSTOM = 'custom',
}

export type Lane = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  name: string;
  description: string;
  type: LaneType;
  color: Colors;
};

export type Priority = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  name: string;
  description: string;
  color: Colors;
};

export enum CustomFieldType {
  NUMBER = 'number',
  TEXT = 'text',
  CHOICE = 'choice',
  BOOLEAN = 'boolean',
  DATE = 'date',
  ENTITY = 'entity',
  ASSET = 'asset',
  CALCULATED = 'calculated',
}

export enum CustomFieldTextSubType {
  SHORT_TEXT = 'short_text',
  LONG_TEXT = 'long_text',
  EMAIL = 'email',
  PHONE_NUMBER = 'phone_number',
  URL = 'url',
}

export enum CustomFieldNumberSubType {
  INTEGER = 'integer',
  DECIMAL = 'decimal',
  PERCENTAGE = 'percentage',
}

export enum CustomFieldChoiceSubType {
  DROPDOWN = 'dropdown',
}

export enum CustomFieldBooleanSubType {
  CHECKBOX = 'checkbox',
  SWITCH = 'switch',
}

export enum CustomFieldDateSubType {
  DATE = 'date',
  DATETIME = 'datetime',
}

export enum CustomFieldEntitySubType {
  USER = 'user',
}

export enum CustomFieldCalculatedSubType {
  TEXT = 'text',
  NUMBER = 'number',
  DATE = 'date',
  BOOLEAN = 'boolean',
}

export type CustomFieldSubType =
  | CustomFieldTextSubType
  | CustomFieldNumberSubType
  | CustomFieldChoiceSubType
  | CustomFieldBooleanSubType
  | CustomFieldDateSubType
  | CustomFieldEntitySubType
  | CustomFieldCalculatedSubType;

export enum CustomFieldOptionType {
  STRING = 'string',
  NUMBER = 'number',
}

export type CustomFieldOption = {
  id: string;
  label: string;
};

export type CustomFieldEntityFilters = {
  userId?: Array<string>;
  teamId?: Array<string>;
  label?: Array<string>;
  role?: Array<string>;
};

export enum CustomFieldFileType {
  IMAGE = 'image',
  VIDEO = 'video',
  AUDIO = 'audio',
  DOCUMENT = 'document',
}

export type CustomField = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  name: string;
  description: string;
  type: CustomFieldType;
  subType?: CustomFieldSubType;
  maxLength?: number;
  minLength?: number;
  numberRange?: {
    min: number;
    max: number;
    step: number;
  };
  optionType?: CustomFieldOptionType;
  options?: Array<CustomFieldOption>;
  filters?: CustomFieldEntityFilters;
  fileTypes?: Array<CustomFieldFileType>;
  mimeTypes?: Array<string>;
  isMultiSelect?: boolean;
  formula?: string;
  variables?: Array<string>;
};

export type EstimateOption = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  name: string;
  optimisticEstimate: number;
  likelyEstimate: number;
  pessimisticEstimate: number;
};

export type UserLabelGroupLabel = {
  id: string;
  name: string;
};

export type UserLabelGroup = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  name: string;
  labels: Array<UserLabelGroupLabel>;
};

export type LabelCollection = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  name: string;
  default: boolean;
  labelIds: Array<string>;
};

export type PriorityCollection = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  name: string;
  default: boolean;
  priorityIds: Array<string>;
  defaultPriorityId?: string;
};

export type LaneCollectionLane = {
  laneId: string;
  wipLimit?: number;
  workTypeIds?: Array<string>;
};

export type LaneCollection = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  name: string;
  default: boolean;
  lanes: Array<LaneCollectionLane>;
};

export enum EstimateOptionConfidence {
  _68 = '68',
  _95 = '95',
  _99 = '99',
}

export type EstimateOptionCollection = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  name: string;
  default: boolean;
  confidence: EstimateOptionConfidence;
  estimateOptionIds?: Array<string>;
};

export type CustomFieldCollection = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  name: string;
  default: boolean;
  customFields: Array<{
    customFieldId: string;
    required?: boolean;
  }>;
};

export type CustomFieldFormGroup = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  label: string;
  description: string;
  default: boolean;
  fieldIds: Array<string>;
  rank: string;
  customFieldCollectionId?: string;
};

export type PointEffort = {
  type: 'decimal' | 'integer' | 'fixed_list';
  options?: Array<number>;
};

export enum ItemDrawerTabName {
  DISCUSSION = 'discussion',
  SUBTASKS = 'subtasks',
  CHILD_ITEMS = 'childItems',
  TIME_TRACKING = 'timeTracking',
  FORMS_TAB = 'formsTab',
  ASSETS = 'assets',
  GITHUB = 'github',
  ACTIVITY = 'activity',
}

export type TabOrderItem = {
  tabName: ItemDrawerTabName;
  hidden?: boolean;
};

export enum SidebarFieldName {
  TEAM = 'team',
  ASSIGNED_TO = 'assignedTo',
  CYCLE_BOARD = 'cycleBoard',
  STATUS = 'status',
  PRIORITY = 'priority',
  POINT_ESTIMATE = 'pointEstimate',
  TIME_ESTIMATE = 'timeEstimate',
  TIME_SPENT = 'timeSpent',
  START_DATE = 'startDate',
  DUE_DATE = 'dueDate',
  PROGRESS_TRACKER = 'progressTracker',
  CUSTOM_FIELDS = 'customFields',
}

export type CustomFieldReference = string;

export type SidebarFieldNameOrCustomField =
  | SidebarFieldName
  | CustomFieldReference;

export type SidebarFieldOrderItem = {
  fieldName: SidebarFieldNameOrCustomField;
  hidden?: boolean;
};

export type WorkType = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  parentWorkTypeId?: string;
  title: string;
  color: Colors;
  default: boolean;
  customFieldCollectionId?: string;
  labelCollectionId?: string;
  priorityCollectionId?: string;
  estimateOptionCollectionId?: string;
  enableTimeEstimates: boolean;
  enablePointEffort: boolean;
  pointEffort?: PointEffort;
  archived: boolean;
  itemCount: number;
  archivedItemCount: number;
  children: Array<string>;
  tabOrders: Array<TabOrderItem>;
  sidebarFieldOrders: Array<SidebarFieldOrderItem>;
};

export enum VariableType {
  STRING = 'string',
  NUMBER = 'number',
  BOOLEAN = 'boolean',
  DATE = 'date',
  DATETIME = 'datetime',
}

export type Organization = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  label: string;
  name: string;
  domain: string;
  avatarUrl: string;
  estimateInPoints: boolean;
  timezone: string;
  storageUsed: number;
  industries?: Array<string>;
  methodologies?: Array<string>;
  size?: string;
  devStrideUsersSupport: boolean;
  syncCycleDates: boolean;
  automateLanes: boolean;
  enableStaticMode: boolean;
  subscription?: {
    id: string;
    customerId: string;
    productId: string;
    priceId: string;
    interval: 'month' | 'year' | 'week' | 'day';
    intervalCount?: number;
    trialStart?: string;
    trialEnd?: string;
    startDate: string;
    endDate: string;
    cancelAt?: string;
    canceledAt?: string;
    quantity: number;
    schedule?: {
      priceId: string;
      quantity: number;
      startDate: string;
      endDate: string;
    };
    updatedAt: string;
    limits: ProductLimits;
    status: SubscriptionStatus;
  };
  labels: Array<Label>;
  lanes: Array<Lane>;
  priorities: Array<Priority>;
  customFields: Array<CustomField>;
  folderCustomFields: Array<CustomField>;
  estimateOptions: Array<EstimateOption>;
  userLabelGroups: Array<UserLabelGroup>;
  labelCollections: Array<LabelCollection>;
  priorityCollections: Array<PriorityCollection>;
  laneCollections: Array<LaneCollection>;
  estimateOptionCollections: Array<EstimateOptionCollection>;
  customFieldCollections: Array<CustomFieldCollection>;
  customFieldFormGroups: Array<CustomFieldFormGroup>;
  workTypes: Array<WorkType>;
  variables?: {
    [key: string]: {
      type: VariableType;
      entity: string;
      referencePath: string;
      referenceId?: string;
    };
  };
};

/**
 * Organization Response
 */
export type OrganizationResponse = {
  data: Organization;
};

export type AdminUpdateOrganization = {
  limits?: ProductLimits;
  devStrideUsersSupport?: boolean;
};

export type ConnectionDetails = {
  databaseType: 'postgresql';
  displayName: string;
  host: string;
  port: number;
  databaseName: string;
  username: string;
  password: string;
  connectionString: string;
  schema: 'public';
  sslEnabled: boolean;
};

export type GeneratedCredentialsResponse = {
  credential: OrganizationDatabaseCredential;
  connectionDetails: ConnectionDetails;
};

export type RotatedPasswordResponse = {
  connectionDetails: ConnectionDetails;
};

export type SyncAccessResponse = {
  credential: OrganizationDatabaseCredential;
  availableTables: Array<string>;
};

export type CreateOrganization = {
  label: string;
  avatarUrl: string;
  estimateInPoints?: boolean;
  domain?: string;
  requireMultiFactorAuth?: boolean;
  inviteUsers?: Array<string>;
  industries?: Array<string>;
  methodologies?: Array<string>;
  size?: string;
};

export type UpdateOrganization = {
  label?: string;
  avatarUrl?: string;
  domain?: string;
  requireMultiFactorAuth?: boolean;
  industries?: Array<string>;
  methodologies?: Array<string>;
  size?: string;
  timezone?: string;
  syncCycleDates?: boolean;
  automateLanes?: boolean;
  enableStaticMode?: boolean;
};

/**
 * User Label Group Response
 */
export type UserLabelGroupResponse = {
  data: UserLabelGroup;
};

export type CreateUserLabelGroup = {
  name: string;
  labels: Array<{
    id: string;
    name: string;
  }>;
};

export type UpdateUserLabelGroup = {
  name?: string;
  labels?: Array<{
    id: string;
    name: string;
  }>;
};

/**
 * Work Type Response
 */
export type WorkTypeResponse = {
  data: WorkType;
};

export enum PointEffortType {
  DECIMAL = 'decimal',
  INTEGER = 'integer',
  FIXED_LIST = 'fixed_list',
}

export type CreateWorkType = {
  title: string;
  parentWorkTypeId?: string;
  color: Colors;
  customFieldCollectionId?: string;
  labelCollectionId?: string;
  priorityCollectionId?: string;
  estimateOptionCollectionId?: string;
  enableTimeEstimates?: boolean;
  enablePointEffort?: boolean;
  pointEffort?: {
    type: PointEffortType;
    options?: Array<number>;
  };
};

export type UpdateWorkType = {
  title?: string;
  color?: Colors;
  parentWorkTypeId?: string;
  customFieldCollectionId?: string | null;
  labelCollectionId?: string;
  priorityCollectionId?: string;
  enableTimeEstimates?: boolean;
  estimateOptionCollectionId?: string | null;
  enablePointEffort?: boolean;
  pointEffort?: {
    type: PointEffortType;
    options?: Array<number>;
  };
  tabOrders?: Array<TabOrderItem>;
  sidebarFieldOrders?: Array<SidebarFieldOrderItem>;
};

export type HeadingComponent = {
  type: 'heading';
  label: string;
};

export type HeadingComponentExtended = HeadingComponent & {
  options?: Array<{
    id: string;
    label: string;
    color?: string;
  }>;
};

export type ItemFieldComponent = {
  type: 'field';
  subtype: 'itemField';
  field: string;
  defaultValue?: unknown;
  required: boolean;
  hidden: boolean;
  label: string;
};

export type ItemFieldComponentExtended = ItemFieldComponent & {
  options?: Array<{
    id: string;
    label: string;
    color?: string;
  }>;
};

export type CustomFieldComponent = {
  type: 'field';
  subtype: 'customField';
  field: string;
  defaultValue?: unknown;
  required: boolean;
  hidden: boolean;
  label: string;
};

export type CustomFieldComponentExtended = CustomFieldComponent & {
  options?: Array<{
    id: string;
    label: string;
    color?: string;
  }>;
  customField?: CustomField;
};

export type ItemRequestComponentExtended =
  | HeadingComponentExtended
  | ItemFieldComponentExtended
  | CustomFieldComponentExtended;

export type ItemRequest = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  parentNumber: string;
  workTypeId: string;
  title: string;
  organizationLabel: string;
  organizationAvatarUrl: string;
  components: Array<ItemRequestComponentExtended>;
  public: boolean;
  enabled: boolean;
  itemRequestGroupId?: string;
};

/**
 * ItemRequest Response
 */
export type ItemRequestResponse = {
  data: ItemRequest;
};

export type ItemRequestComponent =
  | HeadingComponent
  | ItemFieldComponent
  | CustomFieldComponent;

export type CreateItemRequest = {
  parentNumber: string;
  workTypeId: string;
  title: string;
  components: Array<ItemRequestComponent>;
  public: boolean;
  enabled: boolean;
  itemRequestGroupId?: string | null;
};

export enum StoredViewLocations {
  'APP:BOARD' = 'app:board',
  'APP:ITEM' = 'app:item',
  CURRENT_PROGRESS = 'current-progress',
  TRENDING_PROGRESS = 'trending-progress',
  THROUGHPUT = 'throughput',
  CUMULATIVE_FLOW = 'cumulative-flow',
  BURNDOWN = 'burndown',
  BURNUP = 'burnup',
  CHURN = 'churn',
  VELOCITY = 'velocity',
  CUSTOM_LEAD_TIME = 'custom-lead-time',
  USER_TIME_TRACKING = 'user-time-tracking',
  MAP = 'map',
  GANTT = 'gantt',
  WORK = 'work',
}

export enum StoredViewVisibility {
  PERSONAL = 'personal',
  INTERNAL = 'internal',
  EXTERNAL = 'external',
}

export type StoredView = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  label: string;
  userId: string;
  location: StoredViewLocations;
  visibility: StoredViewVisibility;
  data: string;
  description: string;
};

/**
 * StoredView Response
 */
export type StoredViewResponse = {
  data: StoredView;
};

export type CreateStoredView = {
  label: string;
  location: StoredViewLocations;
  visibility: StoredViewVisibility;
  data: string;
  description: string;
};

export type UpdateStoredView = {
  label?: string;
  location?: StoredViewLocations;
  visibility?: StoredViewVisibility;
  data?: string;
  description?: string;
};

export type BulkItemTemplate = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  label: string;
  description?: string;
  additionalInstructions: string;
};

/**
 * BulkItemTemplate Response
 */
export type BulkItemTemplateResponse = {
  data: BulkItemTemplate;
};

export type CreateBulkItemTemplate = {
  label: string;
  description?: string;
  additionalInstructions: string;
};

export type UpdateBulkItemTemplate = {
  label?: string;
  description?: string;
  additionalInstructions?: string;
};

export type DescriptionTemplate = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  label: string;
  description: string;
  prompt: string;
  /**
   * This can be left empty
   */
  template: string;
};

/**
 * DescriptionTemplate Response
 */
export type DescriptionTemplateResponse = {
  data: DescriptionTemplate;
};

export type CreateDescriptionTemplate = {
  label: string;
  description: string;
  prompt: string;
  template: string;
};

export type UpdateDescriptionTemplate = {
  label?: string;
  description?: string;
  prompt?: string;
  template?: string;
};

export type ItemRequestGroup = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  label: string;
  color: Colors;
};

/**
 * ItemRequestGroup Response
 */
export type ItemRequestGroupResponse = {
  data: ItemRequestGroup;
};

export type CreateItemRequestGroup = {
  label: string;
  color?: Colors;
  itemRequestIds?: Array<string>;
};

export type UpdateItemRequestGroup = {
  itemRequestIds?: Array<string>;
  color?: Colors;
  label?: string;
};

export type SubmitItemRequest = {
  title: string;
  description?: {
    html: string;
  };
  priorityId?: string;
  customFields?: CustomFields;
  dueDate?: string | null;
  relationships?: Array<Relationship>;
};

export type UpdateItemRequest = {
  parentNumber?: string;
  workTypeId?: string;
  title?: string;
  components?: Array<ItemRequestComponent>;
  public?: boolean;
  enabled?: boolean;
  itemRequestGroupId?: string | null;
};

/**
 * Custom Field Response
 */
export type CustomFieldResponse = {
  data: CustomField;
};

export type CreateCustomField = {
  name: string;
  type: CustomFieldType;
  subType?: CustomFieldSubType;
  description?: string;
  maxLength?: number;
  minLength?: number;
  numberRange?: {
    min: number;
    max: number;
    step: number;
  };
  optionType?: CustomFieldOptionType;
  options?: Array<CustomFieldOption>;
  filters?: CustomFieldEntityFilters;
  fileTypes?: Array<CustomFieldFileType>;
  isMultiSelect?: boolean;
  formula?: string;
};

/**
 * Custom Field Collection Response
 */
export type CustomFieldCollectionResponse = {
  data: CustomFieldCollection;
};

export type CreateCustomFieldCollection = {
  name: string;
  customFields?: Array<{
    customFieldId: string;
    required?: boolean;
  }>;
};

/**
 * CustomFieldFormGroup Response
 */
export type CustomFieldFormGroupResponse = {
  data: CustomFieldFormGroup;
};

export type CreateCustomFieldFromGroup = {
  label: string;
  description?: string;
  customFieldCollectionId: string;
};

/**
 * Label Collection Response
 */
export type LabelCollectionResponse = {
  data: LabelCollection;
};

export type CreateLabelCollection = {
  name: string;
  labelIds?: Array<string>;
};

/**
 * Label Response
 */
export type LabelResponse = {
  data: Label;
};

export type CreateLabel = {
  name: string;
  color: Colors;
  description?: string;
};

/**
 * Lane Collection Response
 */
export type LaneCollectionResponse = {
  data: LaneCollection;
};

export type CreateLaneCollection = {
  name: string;
  lanes?: Array<{
    laneId: string;
    wipLimit?: number;
    workTypeIds?: Array<string>;
  }>;
};

/**
 * Lane Response
 */
export type LaneResponse = {
  data: Lane;
};

export type CreateLane = {
  name: string;
  color: Colors;
  description?: string;
};

/**
 * Estimate Option Collection Response
 */
export type EstimateOptionCollectionResponse = {
  data: EstimateOptionCollection;
};

export type CreateEstimateOptionCollection = {
  name: string;
  confidence: EstimateOptionConfidence;
  estimateOptionIds?: Array<string>;
};

/**
 * Estimate Option Response
 */
export type EstimateOptionResponse = {
  data: EstimateOption;
};

export type CreateEstimateOption = {
  name: string;
  optimisticEstimate: number;
  likelyEstimate: number;
  pessimisticEstimate: number;
};

/**
 * Priority Response
 */
export type PriorityResponse = {
  data: Priority;
};

export type CreatePriority = {
  name: string;
  color: Colors;
  description?: string;
};

/**
 * Priority Collection Response
 */
export type PriorityCollectionResponse = {
  data: PriorityCollection;
};

export type CreatePriorityCollection = {
  name: string;
  priorityIds?: Array<string>;
  defaultPriorityId?: string;
};

export type UpdateCustomField = {
  name?: string;
  description?: string;
  maxLength?: number;
  minLength?: number;
  numberRange?: {
    min: number;
    max: number;
    step: number;
  };
  options?: Array<CustomFieldOption>;
  filters?: CustomFieldEntityFilters;
  fileTypes?: Array<CustomFieldFileType>;
  formula?: string;
};

export type UpdateCustomFieldCollection = {
  name?: string;
  customFields?: Array<{
    customFieldId: string;
    required?: boolean;
  }>;
  inFormGroupId?: string;
};

export type UpdateCustomFieldFormGroup = {
  label?: string;
  description?: string;
  customFieldCollectionId?: string;
  fieldIds?: Array<string>;
  rankAbove?: string;
  rankBelow?: string;
};

export type UpdateEstimateOption = {
  name?: string;
  optimisticEstimate?: number;
  likelyEstimate?: number;
  pessimisticEstimate?: number;
};

export type UpdateEstimateOptionCollection = {
  name?: string;
  confidence?: EstimateOptionConfidence;
  estimateOptionIds?: Array<string>;
};

export type UpdateLabel = {
  name?: string;
  color?: Colors;
  description?: string;
};

export type UpdateLabelCollection = {
  name?: string;
  labelIds?: Array<string>;
};

export type UpdateLane = {
  name?: string;
  color?: Colors;
  description?: string;
};

export type UpdateLaneCollection = {
  name?: string;
  lanes?: Array<{
    laneId: string;
    wipLimit?: number;
    workTypeIds?: Array<string>;
  }>;
};

export type UpdatePriority = {
  name?: string;
  color?: Colors;
  description?: string;
};

export type UpdatePriorityCollection = {
  name?: string;
  priorityIds?: Array<string>;
  defaultPriorityId?: string;
};

/**
 * Organization List Response
 */
export type OrganizationListResponse = {
  data: Array<Organization>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

/**
 * Organization Simple List Response
 */
export type OrganizationSimpleListResponse = {
  data: Array<{
    id: string;
    dateAdded: string;
    dateUpdated: string;
    label: string;
    name: string;
    domain: string;
    avatarUrl: string;
    timezone: string;
  }>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

/**
 * ItemRequest List Response
 */
export type ItemRequestListResponse = {
  data: Array<ItemRequest>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

/**
 * StoredView List Response
 */
export type StoredViewListResponse = {
  data: Array<StoredView>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

/**
 * BulkItemTemplate List Response
 */
export type BulkItemTemplateListResponse = {
  data: Array<BulkItemTemplate>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

/**
 * DescriptionTemplate List Response
 */
export type DescriptionTemplateListResponse = {
  data: Array<DescriptionTemplate>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

/**
 * ItemRequestGroup List Response
 */
export type ItemRequestGroupListResponse = {
  data: Array<ItemRequestGroup>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

/**
 * CustomFieldFormGroup List Response
 */
export type CustomFieldFormGroupListResponse = {
  data: Array<CustomFieldFormGroup>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

export type StoredViewExtended = StoredView & {
  customFields: {
    [key: string]: string;
  };
  organization?: {
    id: string;
    label: string;
    avatarUrl?: string;
  };
};

export type StoredViewExtendedResponse = {
  data: Array<StoredViewExtended>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

export type ReadOnlyCredentialsResponse = {
  credential: OrganizationDatabaseCredential &
    ({
      [key: string]: unknown;
    } | null);
  availableTables: Array<string>;
};

/**
 * Pusher Auth Response
 */
export type PusherAuthResponse = {
  auth: string;
  channel_data?: string;
  shared_secret?: string;
};

/**
 * Initiative DTO
 */
export type Initiative = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  name: string;
  organizationId: string;
  roadmapId: string;
  description?: string;
  color: Colors;
  rank: string;
  minDate?: string;
  maxDate?: string;
  /**
   * Top level children
   */
  itemNumbers: Array<string>;
};

/**
 * Milestone DTO
 */
export type Milestone = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  name: string;
  roadmapId: string;
  description?: string;
  dueDate: string;
  color: Colors;
  rank: string;
  relationships: Array<Relationship>;
};

/**
 * Roadmap Item DTO
 */
export type RoadmapItem = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  roadmapId: string;
  initiativeId: string;
  itemNumber: string;
  rank: string;
};

/**
 * Keys should be WorkItem['number'] | Folder['number'] | Milestone['id']
 */
export type ScenarioSnapshot = {
  [key: string]: {
    /**
     * null for milestones
     */
    startDate: string | null;
    dueDate: string;
  };
};

/**
 * Scenario DTO
 */
export type Scenario = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  roadmapId: string;
  name: string;
  snapshot: ScenarioSnapshot;
};

/**
 * All array properties are empty when fetched from the list endpoint. Only the detail endpoint populates them.
 */
export type Roadmap = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  name: string;
  description?: string;
  organizationId: string;
  initiatives: Array<Initiative>;
  milestones: Array<Milestone>;
  roadmapItems: Array<RoadmapItem>;
  scenarios: Array<Scenario>;
  /**
   * All FIRST LEVEL work items across all the initiatives in the roadmap
   */
  workItems: Array<WorkItem>;
  /**
   * All FIRST LEVEL folders across all the initiatives in the roadmap
   */
  folders: Array<Folder>;
  roadmapGroupId?: string;
};

/**
 * Roadmap Response
 */
export type RoadmapResponse = {
  data: Roadmap;
};

export type CreateRoadmap = {
  name: string;
  description?: string;
  roadmapGroupId?: string;
};

/**
 * Update Roadmap DTO
 */
export type UpdateRoadmap = {
  name?: string;
  description?: string;
  roadmapGroupId?: string | null;
};

/**
 * Initiative Response
 */
export type InitiativeResponse = {
  data: Initiative;
};

/**
 * Create Initiative DTO
 */
export type CreateInitiative = {
  name: string;
  roadmapId: string;
  description?: string;
  color?: Colors & unknown;
  itemNumbers?: Array<string>;
};

export enum RankEntity {
  INITIATIVE = 'initiative',
  MILESTONE = 'milestone',
}

/**
 * Update Initiative DTO
 */
export type UpdateInitiative = {
  name?: string;
  description?: string;
  color?: Colors;
  rankEntity?: RankEntity;
  rankAbove?: string;
  rankBelow?: string;
  itemNumbers?: Array<string>;
};

/**
 * Milestone Response
 */
export type MilestoneResponse = {
  data: Milestone;
};

/**
 * Create Milestone DTO
 */
export type CreateMilestone = {
  name: string;
  roadmapId: string;
  description?: string;
  dueDate: string;
  color?: Colors & unknown;
  relationships?: Array<Relationship>;
  staticMode?: boolean;
  initiativeId?: string;
};

/**
 * Update Milestone DTO
 */
export type UpdateMilestone = {
  name?: string;
  description?: string;
  dueDate?: string;
  color?: Colors;
  rankEntity?: RankEntity;
  rankAbove?: string;
  rankBelow?: string;
  relationships?: Array<Relationship>;
  staticMode?: boolean;
  initiativeId?: string;
};

/**
 * Scenario Response
 */
export type ScenarioResponse = {
  data: Scenario;
};

/**
 * Create Scenario DTO
 */
export type CreateScenario = {
  roadmapId: string;
  name: string;
  snapshot: {
    [key: string]: {
      startDate: string | null;
      dueDate: string;
    };
  };
};

/**
 * Update Scenario DTO
 */
export type UpdateScenario = {
  name?: string;
  snapshot?: {
    [key: string]: {
      startDate: string | null;
      dueDate: string;
    };
  };
};

/**
 * Roadmap Group DTO
 */
export type RoadmapGroup = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  label: string;
  color: Colors & unknown;
};

/**
 * RoadmapGroup Response
 */
export type RoadmapGroupResponse = {
  data: RoadmapGroup;
};

/**
 * Create Roadmap Group DTO
 */
export type CreateRoadmapGroup = {
  label: string;
  color?: Colors;
  roadmapIds?: Array<string>;
};

/**
 * Update Roadmap Group DTO
 */
export type UpdateRoadmapGroup = {
  roadmapIds?: Array<string>;
  color?: Colors;
  label?: string;
};

/**
 * Roadmap Item Response
 */
export type RoadmapItemResponse = {
  data: RoadmapItem;
};

/**
 * Update Roadmap Item DTO
 */
export type UpdateRoadmapItem = {
  initiativeId: string;
  rankAbove?: string;
  rankBelow?: string;
};

/**
 * Roadmap List Response
 */
export type RoadmapListResponse = {
  data: Array<Roadmap>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

/**
 * RoadmapGroup List Response
 */
export type RoadmapGroupListResponse = {
  data: Array<RoadmapGroup>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

export type SlackInstallation = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  workspaceId: string;
  workspaceName: string;
  avatarUrl: string;
};

export type PaymentMethod = {
  id: string;
  card: {
    brand: string;
    expMonth: number;
    expYear: number;
    funding: string;
    last4: string;
  };
  default: boolean;
  billingDetails: {
    address: {
      city: string | null;
      country: string | null;
      line1: string | null;
      line2: string | null;
      postalCode: string | null;
      state: string | null;
    } | null;
    email: string | null;
    name: string | null;
    phone: string | null;
  } | null;
};

/**
 * Payment Method List Response
 */
export type PaymentMethodListResponse = {
  data: Array<PaymentMethod>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

export type Invoice = {
  id: string;
  amount: number;
  discount: boolean;
  appliedAmount: boolean;
  currency: string;
  status:
    | 'deleted'
    | 'draft'
    | 'open'
    | 'paid'
    | 'uncollectible'
    | 'void'
    | null;
  number: string | null;
  dueDate?: string;
  createdDate: string;
  documentPdf: string | null;
  payment: {
    id: string;
    amount: number;
    currency: string;
    status:
      | 'canceled'
      | 'processing'
      | 'requires_action'
      | 'requires_capture'
      | 'requires_confirmation'
      | 'requires_payment_method'
      | 'succeeded';
    message: string;
    charge: {
      id: string;
      amount: number;
      currency: string;
      status: 'failed' | 'pending' | 'succeeded';
      refund: {
        id: string;
        amount: number;
        currency: string;
      } | null;
    } | null;
    createdDate: string;
  } | null;
};

/**
 * Subscription Invoice List Response
 */
export type InvoiceListResponse = {
  data: Array<Invoice>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

export type SubscriptionPrice = {
  stripePriceId: string;
  interval?: 'month' | 'year' | 'week' | 'day';
  intervalCount?: number;
  currency: string;
  amount: number;
};

export type Product = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  name: string;
  description?: string;
  stripeProductId: string;
  isDefault: boolean;
  isCustom: boolean;
  defaultLimits: ProductLimits;
  prices: Array<SubscriptionPrice>;
};

/**
 * Subscription Products List Response
 */
export type ProductListResponse = {
  data: Array<Product>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

export type Customer = {
  id: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  address?: {
    line1?: string;
    line2?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    country?: string;
  };
};

export type SetupPaymentMethod = {
  clientSecret: string;
};

/**
 * Setup Payment Method Response
 */
export type SetupPaymentMethodResponse = {
  data: SetupPaymentMethod;
};

export type SetDefaultPaymentMethod = {
  paymentMethodId: string;
};

/**
 * Subscription Response
 */
export type SubscriptionResponse = {
  data: {
    id: string;
    customerId: string;
    productId: string;
    priceId: string;
    interval: 'month' | 'year' | 'week' | 'day';
    intervalCount?: number;
    trialStart?: string;
    trialEnd?: string;
    startDate: string;
    endDate: string;
    cancelAt?: string;
    canceledAt?: string;
    quantity: number;
    schedule?: {
      priceId: string;
      quantity: number;
      startDate: string;
      endDate: string;
    };
    updatedAt: string;
    limits: ProductLimits;
    status: SubscriptionStatus;
  };
};

export type CreateSubscription = {
  subscriptionPriceId: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  address?: {
    line1?: string;
    line2?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    country?: string;
  };
};

export type UpdateSubscription = {
  priceId?: string;
  cancel?: boolean;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  address?: {
    line1?: string;
    line2?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    country?: string;
  };
};

export type CreateProduct = {
  name: string;
  description?: string;
  stripeProductId: string;
  isDefault: boolean;
  isCustom: boolean;
  defaultLimits: ProductLimits;
};

export type UpdateProduct = {
  name?: string;
  description?: string;
  isDefault?: boolean;
  isCustom?: boolean;
  defaultLimits?: ProductLimits;
};

export type TimeEntry = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  authorUsername: string;
  itemNumber?: string;
  description: string;
  startDate: string;
  endDate?: string;
  edited: boolean;
  manual: boolean;
  lengthSeconds: number;
  completed: boolean;
  metadata: {
    [key: string]:
      | string
      | number
      | boolean
      | Array<string>
      | Array<number>
      | Array<boolean>;
  };
};

/**
 * Time Entry Response
 */
export type TimeEntryResponse = {
  data: TimeEntry;
};

export type CreateTimeEntry = {
  startDate?: string;
  endDate?: string;
  itemNumber?: string;
  description?: string;
  userId?: string;
  metadata?: {
    [key: string]:
      | string
      | number
      | boolean
      | Array<string>
      | Array<number>
      | Array<boolean>;
  };
};

export type UpdateTimeEntry = {
  startDate?: string;
  endDate?: string;
  stop?: boolean;
  itemNumber?: string;
  description?: string;
  userId?: string;
  metadata?: {
    [key: string]:
      | string
      | number
      | boolean
      | Array<string>
      | Array<number>
      | Array<boolean>;
  };
};

/**
 * Time Entry List Response
 */
export type TimeEntryListResponse = {
  data: Array<TimeEntry>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

export enum WorkflowType {
  SYSTEM = 'system',
  SYSTEM_NOTIFICATION = 'system_notification',
  CUSTOM = 'custom',
}

export enum WorkflowTrigger {
  SCHEDULE = 'schedule',
  DUE_DATE_ARRIVED = 'due_date_arrived',
  WEBHOOK = 'webhook',
  ITEM_CREATED = 'item_created',
  ITEM_UPDATED = 'item_updated',
  ITEM_ARCHIVED = 'item_archived',
  FOLDER_CREATED = 'folder_created',
  FOLDER_UPDATED = 'folder_updated',
  FOLDER_ARCHIVED = 'folder_archived',
  ITEM_REQUEST_SUBMITTED = 'item_request_submitted',
}

export enum WorkflowOperator {
  EQUAL = 'equal',
  NOT_EQUAL = 'notEqual',
  IN = 'in',
  NOT_SET = 'notSet',
  IS_SET = 'isSet',
  NOT_IN = 'notIn',
  CONTAINS = 'contains',
  DOES_NOT_CONTAIN = 'doesNotContain',
  LESS_THAN = 'lessThan',
  LESS_THAN_INCLUSIVE = 'lessThanInclusive',
  GREATER_THAN = 'greaterThan',
  GREATER_THAN_INCLUSIVE = 'greaterThanInclusive',
  DIVISIBLE_BY = 'divisibleBy',
  PATHS_NOT_EQUAL = 'pathsNotEqual',
  IS_IN_DATE_RANGE = 'isInDateRange',
  PULL_REQUEST_OPENED = 'pullRequestOpened',
  BRANCH_CREATED = 'branchCreated',
  COMMIT_CREATED = 'commitCreated',
  ALL_CHECKS_PASSED = 'allChecksPassed',
  CHECK_FAILED = 'checkFailed',
  REVIEW_REQUESTED = 'reviewRequested',
  CHANGES_REQUESTED = 'changesRequested',
  ALL_REVIEWS_APPROVED = 'allReviewsApproved',
  ALL_PULL_REQUESTS_MERGED_CLOSED = 'allPullRequestsMergedClosed',
  OVERLAPS = 'overlaps',
  DOES_NOT_OVERLAP = 'doesNotOverlap',
  STRING_CONTAINS = 'stringContains',
  STRING_DOES_NOT_CONTAIN = 'stringDoesNotContain',
}

export type WorkflowConditionProperties = {
  operator: WorkflowOperator;
  value?: unknown;
  path?: unknown;
  priority?: number;
};

export type WorkflowAllConditions = {
  all: Array<WorkflowNestedCondition>;
};

export type WorkflowAnyConditions = {
  any: Array<WorkflowNestedCondition>;
};

export type WorkflowNestedCondition =
  | WorkflowConditionProperties
  | WorkflowAllConditions
  | WorkflowAnyConditions;

export type WorkflowActionReference = unknown;

export type ActionDataValue =
  | {
      type: 'value';
      value?:
        | string
        | number
        | boolean
        | Array<unknown>
        | {
            [key: string]: unknown;
          }
        | null;
    }
  | {
      type: 'reference';
      reference?: WorkflowActionReference;
    }
  | {
      type: 'template';
      template: string;
      variables: {
        [key: string]: ActionDataValue;
      };
    }
  | {
      type: 'data';
      data: {
        [key: string]: ActionDataValue;
      };
    }
  | {
      type: 'date';
      format?: string;
      timezone?: string;
      addDays?: number;
      endOfDay?: boolean;
      value?: string;
    }
  | {
      type: 'board';
      boardNumber: number;
      organizationId: ActionDataValue;
      boardFolderId: ActionDataValue;
    };

export type CreateWorkItemActionData = {
  title: ActionDataValue;
  parentNumber: ActionDataValue;
  workTypeId: ActionDataValue;
  description?: ActionDataValue;
  priorityId?: ActionDataValue;
  laneId?: ActionDataValue;
  assigneeUsername?: ActionDataValue;
  boardId?: ActionDataValue;
  teamId?: ActionDataValue;
  optimisticEstimate?: ActionDataValue;
  likelyEstimate?: ActionDataValue;
  pessimisticEstimate?: ActionDataValue;
  pointEffort?: ActionDataValue;
  isBug?: ActionDataValue;
  blocker?: ActionDataValue;
  color?: ActionDataValue;
  customFields?: ActionDataValue;
  labels?: ActionDataValue;
  authorUsername?: ActionDataValue;
  startDate?: ActionDataValue;
  dueDate?: ActionDataValue;
  timeSpentSeconds?: ActionDataValue;
  addWatchers?: Array<ActionDataValue>;
};

export type UpdateWorkItemActionData = {
  number: ActionDataValue;
  title?: ActionDataValue;
  parentNumber?: ActionDataValue;
  workTypeId?: ActionDataValue;
  description?: ActionDataValue;
  priorityId?: ActionDataValue;
  laneId?: ActionDataValue;
  assigneeUsername?: ActionDataValue;
  boardId?: ActionDataValue;
  teamId?: ActionDataValue;
  optimisticEstimate?: ActionDataValue;
  likelyEstimate?: ActionDataValue;
  pessimisticEstimate?: ActionDataValue;
  pointEffort?: ActionDataValue;
  isBug?: ActionDataValue;
  blocker?: ActionDataValue;
  color?: ActionDataValue;
  customFields?: ActionDataValue;
  labels?: ActionDataValue;
  startDate?: ActionDataValue;
  dueDate?: ActionDataValue;
  addLabels?: ActionDataValue;
  removeLabels?: ActionDataValue;
  timeSpentSeconds?: ActionDataValue;
  addWatchers?: Array<ActionDataValue>;
};

export type ArchiveWorkItemActionData = {
  number: ActionDataValue;
};

export type CreateSubItemActionData = {
  title: ActionDataValue;
  parentNumber: ActionDataValue;
  assigneeUsername?: ActionDataValue;
  teamId?: ActionDataValue;
  description?: ActionDataValue;
  startDate?: ActionDataValue;
  dueDate?: ActionDataValue;
  optimisticEstimate?: ActionDataValue;
  likelyEstimate?: ActionDataValue;
  pessimisticEstimate?: ActionDataValue;
  pointEffort?: ActionDataValue;
  timeSpentSeconds?: ActionDataValue;
  completedByUser?: ActionDataValue;
  status?: ActionDataValue;
};

export type CreateFolderActionData = {
  title: ActionDataValue;
  description?: ActionDataValue;
  parentNumber?: ActionDataValue;
  priorityId?: ActionDataValue;
  customFieldCollectionId?: ActionDataValue;
  labelCollectionId?: ActionDataValue;
  priorityCollectionId?: ActionDataValue;
  color?: ActionDataValue;
  authorUsername?: ActionDataValue;
};

export type UpdateFolderActionData = {
  number: ActionDataValue;
  title?: ActionDataValue;
  description?: ActionDataValue;
  parentNumber?: ActionDataValue;
  customFieldCollectionId?: ActionDataValue;
  labelCollectionId?: ActionDataValue;
  priorityCollectionId?: ActionDataValue;
  priorityId?: ActionDataValue;
  color?: ActionDataValue;
};

export type ArchiveFolderActionData = {
  number: ActionDataValue;
};

export type AddRelationshipsActionData = {
  number: ActionDataValue;
  type: 'blocked_by' | 'blocks' | 'related_to';
  dependentNumbers: Array<ActionDataValue>;
};

export type SendNotificationActionData = {
  channels: Array<NotificationChannel>;
  recipients: Array<ActionDataValue>;
  summary: ActionDataValue;
  description?: ActionDataValue;
};

export type SendApiRequestActionData = {
  url: ActionDataValue;
  method: ActionDataValue;
  headers?: ActionDataValue;
  payload?: ActionDataValue;
};

export type WorkflowAction =
  | {
      type: 'create-workitem';
      data: CreateWorkItemActionData;
    }
  | {
      type: 'update-workitem';
      data: UpdateWorkItemActionData;
    }
  | {
      type: 'archive-workitem';
      data: ArchiveWorkItemActionData;
    }
  | {
      type: 'create-subitem';
      data: CreateSubItemActionData;
    }
  | {
      type: 'create-folder';
      data: CreateFolderActionData;
    }
  | {
      type: 'update-folder';
      data: UpdateFolderActionData;
    }
  | {
      type: 'archive-folder';
      data: ArchiveFolderActionData;
    }
  | {
      type: 'add-relationships';
      data: AddRelationshipsActionData;
    }
  | {
      type: 'send-notification';
      data: SendNotificationActionData;
    }
  | {
      type: 'send-api-request';
      data: SendApiRequestActionData;
    };

/**
 * Workflow
 */
export type Workflow = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  description?: string;
  type: WorkflowType;
  trigger: WorkflowTrigger;
  referenceId?: string;
  inputParams?: unknown;
  required: boolean;
  disabled: boolean;
  disabledReason?: string;
  triggerConditions: Array<WorkflowNestedCondition>;
  nestedConditions: Array<WorkflowNestedCondition>;
  actions: Array<WorkflowAction>;
  createdById: string;
  workflowGroupId?: string | null;
};

/**
 * WorkflowGroup
 */
export type WorkflowGroup = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  label: string;
  color: Colors;
};

export type WorkflowRunInput = unknown;

export enum WorkflowRunStatus {
  STARTED = 'started',
  SKIPPED = 'skipped',
  RUNNING = 'running',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

/**
 * WorkflowRun
 */
export type WorkflowRun = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  workflowId: string;
  input?: WorkflowRunInput;
  actionsRun: number;
  status: WorkflowRunStatus;
  errors?: Array<string>;
};

/**
 * WorkflowRun List Response
 */
export type WorkflowRunListResponse = {
  data: Array<WorkflowRun>;
  meta: {
    cursor?: string;
    aggregations?: {
      [key: string]: {
        [key: string]: unknown;
      };
    };
    total?: number;
    hasMoreData: boolean;
  };
};

/**
 * Workflow Response
 */
export type WorkflowResponse = {
  data: Workflow;
};

/**
 * Create a new workflow
 */
export type CreateWorkflow = {
  description?: string;
  trigger: WorkflowTrigger;
  referenceId?: string;
  inputParams?: unknown;
  actions: Array<WorkflowAction>;
  triggerConditions: Array<WorkflowNestedCondition>;
  nestedConditions: Array<WorkflowNestedCondition>;
  workflowGroupId?: string | null;
};

/**
 * Update a workflow
 */
export type UpdateWorkflow = {
  description?: string;
  disabled?: boolean;
  inputParams?: unknown;
  actions?: Array<WorkflowAction>;
  triggerConditions?: Array<WorkflowNestedCondition>;
  nestedConditions?: Array<WorkflowNestedCondition>;
  trigger?: WorkflowTrigger;
  workflowGroupId?: string | null;
};

/**
 * WorkflowGroup Response
 */
export type WorkflowGroupResponse = {
  data: WorkflowGroup;
};

/**
 * Create a new workflow group
 */
export type CreateWorkflowGroup = {
  label: string;
  color?: Colors;
  workflowIds?: Array<string>;
};

/**
 * Update a workflow group
 */
export type UpdateWorkflowGroup = {
  workflowIds?: Array<string>;
  color?: Colors;
  label?: string;
};

/**
 * Webhook
 */
export type Webhook = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
  organizationId: string;
  label: string;
};

/**
 * Webhook Response
 */
export type WebhookResponse = {
  data: Webhook;
};

/**
 * Create a new webhook
 */
export type CreateWebhook = {
  label: string;
};

export type UpdateNotificationData = {
  body?: {
    /**
     * Mark notification as read
     */
    read?: boolean;
    /**
     * Mark notification as bookmarked
     */
    saved?: boolean;
  };
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Notification ID
     */
    notificationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/notifications/{notificationId}';
};

export type UpdateNotificationResponses = {
  /**
   * Notification Response
   */
  200: {
    data: Notification;
  };
};

export type UpdateNotificationResponse =
  UpdateNotificationResponses[keyof UpdateNotificationResponses];

export type FindNotificationsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: {
    dateAddedGte?: string;
    dateAddedLte?: string;
    read?: boolean;
    saved?: boolean;
    action?: Array<string>;
    teamId?: Array<string>;
    rootFolderNumber?: Array<string>;
    triggerUserId?: Array<string>;
    role?: Array<string>;
    /**
     * Limit
     */
    limit?: number;
    /**
     * Cursor
     */
    cursor?: string;
    /**
     * Direction
     */
    direction?: 'asc' | 'desc';
  };
  url: '/v1/organizations/{organizationId}/notifications';
};

export type FindNotificationsResponses = {
  /**
   * Notification List Response
   */
  200: {
    data: Array<Notification>;
    meta: {
      cursor?: string;
      aggregations?: {
        [key: string]: {
          [key: string]: unknown;
        };
      };
      total?: number;
      hasMoreData: boolean;
    };
  };
};

export type FindNotificationsResponse =
  FindNotificationsResponses[keyof FindNotificationsResponses];

export type GetActivityLogByIdData = {
  body?: never;
  path: {
    organizationId: string;
    activityLogId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/activity-logs/log/{activityLogId}';
};

export type GetActivityLogByIdResponses = {
  /**
   * Activity Log Response
   */
  200: {
    data: ActivityLog;
  };
};

export type GetActivityLogByIdResponse =
  GetActivityLogByIdResponses[keyof GetActivityLogByIdResponses];

export type FindActivityLogsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Reference ID, e.x an item id
     */
    referenceId: string;
  };
  query?: {
    /**
     * Limit
     */
    limit?: number;
    /**
     * Cursor
     */
    cursor?: string;
    /**
     * Direction
     */
    direction?: 'asc' | 'desc';
    /**
     * Activity log type
     */
    type?:
      | 'work_item'
      | 'folder'
      | 'field_changed'
      | 'asset_group'
      | 'asset_item'
      | 'branch'
      | 'commit'
      | 'review'
      | 'check'
      | 'pull_request';
    /**
     * Activity log action
     */
    action?: 'create' | 'update' | 'delete' | 'archived' | 'unarchived';
    /**
     * Transaction date greater than or equal to, e.x 2021-01-01T00:00:00.000Z
     */
    transactionDateGte?: string;
    /**
     * Transaction date less than or equal to, e.x 2021-01-01T00:00:00.000Z
     */
    transactionDateLte?: string;
  };
  url: '/v1/organizations/{organizationId}/activity-logs/{referenceId}';
};

export type FindActivityLogsResponses = {
  /**
   * Activity Log List Response
   */
  200: {
    data: Array<ActivityLog>;
    meta: {
      cursor?: string;
      aggregations?: {
        [key: string]: {
          [key: string]: unknown;
        };
      };
      total?: number;
      hasMoreData: boolean;
    };
  };
};

export type FindActivityLogsResponse =
  FindActivityLogsResponses[keyof FindActivityLogsResponses];

export type CreateChatMessageData = {
  body?: CreateChatMessageRequest;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    chatId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/ai/chats/{chatId}/messages';
};

export type CreateChatMessageResponses = {
  /**
   * Create Chat Message response
   */
  200: ChatMessageResponse;
};

export type CreateChatMessageResponse =
  CreateChatMessageResponses[keyof CreateChatMessageResponses];

export type CreateChatData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/ai/chats';
};

export type CreateChatResponses = {
  /**
   * Create Chat response
   */
  200: ChatResponse;
};

export type CreateChatResponse = CreateChatResponses[keyof CreateChatResponses];

export type GenerateItemDescriptionData = {
  body?: GenerateItemDescriptionRequest;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/ai/generate-item-description';
};

export type GenerateItemDescriptionResponses = {
  /**
   * Generate Item Description response
   */
  200: GenerateItemDescriptionResponse;
};

export type GenerateItemDescriptionResponse2 =
  GenerateItemDescriptionResponses[keyof GenerateItemDescriptionResponses];

export type ProxyAiRequestData = {
  body?: ProxyAiRequest;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/ai/proxy';
};

export type ProxyAiRequestResponses = {
  /**
   * Proxy AI Request response
   */
  200: ProxyAiRequestResponse;
};

export type ProxyAiRequestResponse2 =
  ProxyAiRequestResponses[keyof ProxyAiRequestResponses];

export type CreateExportItemsJobData = {
  body?: CreateExportItemsJob;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/analytics/exports/items';
};

export type CreateExportItemsJobResponses = {
  /**
   * Create Export Items Job response
   */
  200: ExportJobResponse;
};

export type CreateExportItemsJobResponse =
  CreateExportItemsJobResponses[keyof CreateExportItemsJobResponses];

export type DeleteExportJobData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Export ID
     */
    exportJobId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/analytics/exports/items/{exportJobId}';
};

export type DeleteExportJobResponses = {
  /**
   * Delete Export Job response
   */
  200: ExportJobResponse;
};

export type DeleteExportJobResponse =
  DeleteExportJobResponses[keyof DeleteExportJobResponses];

export type GetExportJobByIdData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Export ID
     */
    exportJobId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/analytics/exports/items/{exportJobId}';
};

export type GetExportJobByIdResponses = {
  /**
   * Get Export Job By Id response
   */
  200: ExportJobResponse;
};

export type GetExportJobByIdResponse =
  GetExportJobByIdResponses[keyof GetExportJobByIdResponses];

export type FindExportJobsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: {
    /**
     * Limit
     */
    limit?: number;
    /**
     * Cursor
     */
    cursor?: string;
    /**
     * Direction
     */
    direction?: 'asc' | 'desc';
  };
  url: '/v1/organizations/{organizationId}/analytics/exports';
};

export type FindExportJobsResponses = {
  /**
   * Find Export Jobs response
   */
  200: ExportJobListResponse;
};

export type FindExportJobsResponse =
  FindExportJobsResponses[keyof FindExportJobsResponses];

export type GetCubeAuthTokenData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/analytics/cube-auth';
};

export type GetCubeAuthTokenResponses = {
  /**
   * Get Cube AuthToken response
   */
  200: CubeToken;
};

export type GetCubeAuthTokenResponse =
  GetCubeAuthTokenResponses[keyof GetCubeAuthTokenResponses];

export type GetReportByExportJobIdData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Export ID
     */
    exportJobId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/analytics/exports/items/{exportJobId}/download';
};

export type GetReportByExportJobIdResponses = {
  /**
   * The url of the report
   */
  200: {
    url: string;
  };
};

export type GetReportByExportJobIdResponse =
  GetReportByExportJobIdResponses[keyof GetReportByExportJobIdResponses];

export type CreateAssetGroupData = {
  body: CreateAssetGroup;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
    type: 'work-items' | 'folders';
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/{type}/{itemNumber}/asset-groups';
};

export type CreateAssetGroupResponses = {
  /**
   * Asset group response
   */
  200: AssetGroupResponse;
};

export type CreateAssetGroupResponse =
  CreateAssetGroupResponses[keyof CreateAssetGroupResponses];

export type CreateAssetItemData = {
  body: CreateAssetItem;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
    type: 'work-items' | 'folders';
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/{type}/{itemNumber}/asset-items';
};

export type CreateAssetItemResponses = {
  /**
   * Asset item response
   */
  200: AssetItemResponse;
};

export type CreateAssetItemResponse =
  CreateAssetItemResponses[keyof CreateAssetItemResponses];

export type DeleteAssetGroupData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
    /**
     * Asset Group ID
     */
    assetGroupId: string;
    type: 'work-items' | 'folders';
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/{type}/{itemNumber}/asset-groups/{assetGroupId}';
};

export type DeleteAssetGroupResponses = {
  /**
   * Asset group response
   */
  200: {
    success: boolean;
  };
};

export type DeleteAssetGroupResponse =
  DeleteAssetGroupResponses[keyof DeleteAssetGroupResponses];

export type UpdateAssetGroupData = {
  body: UpdateAssetGroup;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
    /**
     * Asset Group ID
     */
    assetGroupId: string;
    type: 'work-items' | 'folders';
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/{type}/{itemNumber}/asset-groups/{assetGroupId}';
};

export type UpdateAssetGroupResponses = {
  /**
   * Asset group response
   */
  200: AssetGroupResponse;
};

export type UpdateAssetGroupResponse =
  UpdateAssetGroupResponses[keyof UpdateAssetGroupResponses];

export type DeleteAssetItemData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
    /**
     * Asset Item ID
     */
    assetItemId: string;
    type: 'work-items' | 'folders';
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/{type}/{itemNumber}/asset-items/{assetItemId}';
};

export type DeleteAssetItemResponses = {
  /**
   * Asset item response
   */
  200: AssetItemResponse;
};

export type DeleteAssetItemResponse =
  DeleteAssetItemResponses[keyof DeleteAssetItemResponses];

export type UpdateAssetItemData = {
  body: UpdateAssetItem;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
    /**
     * Asset Item ID
     */
    assetItemId: string;
    type: 'work-items' | 'folders';
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/{type}/{itemNumber}/asset-items/{assetItemId}';
};

export type UpdateAssetItemResponses = {
  /**
   * Asset item response
   */
  200: AssetItemResponse;
};

export type UpdateAssetItemResponse =
  UpdateAssetItemResponses[keyof UpdateAssetItemResponses];

export type FindItemAssetsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
    type: 'work-items' | 'folders';
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/{type}/{itemNumber}/assets';
};

export type FindItemAssetsResponses = {
  /**
   * Asset group list response
   */
  200: AssetGroupListResponse;
};

export type FindItemAssetsResponse =
  FindItemAssetsResponses[keyof FindItemAssetsResponses];

export type GetAssetDownloadUrlData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
    /**
     * Asset Item ID
     */
    assetItemId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/items/{itemNumber}/assets/{assetItemId}/download-url';
};

export type GetAssetDownloadUrlResponses = {
  /**
   * Asset Download URL Response
   */
  200: AssetDownloadUrlResponse;
};

export type GetAssetDownloadUrlResponse =
  GetAssetDownloadUrlResponses[keyof GetAssetDownloadUrlResponses];

export type GetOrganizationUploadUrlData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query: {
    fileName: string;
    fileType: string;
  };
  url: '/v1/organizations/{organizationId}/assets/upload-url';
};

export type GetOrganizationUploadUrlResponses = {
  /**
   * Pre Signed Url Response
   */
  200: PreSignedUrlResponse;
};

export type GetOrganizationUploadUrlResponse =
  GetOrganizationUploadUrlResponses[keyof GetOrganizationUploadUrlResponses];

export type GetUserUploadUrlData = {
  body?: never;
  path?: never;
  query: {
    fileName: string;
    fileType: string;
  };
  url: '/v1/assets/user-upload-url';
};

export type GetUserUploadUrlResponses = {
  /**
   * Pre Signed Url Response
   */
  200: PreSignedUrlResponse;
};

export type GetUserUploadUrlResponse =
  GetUserUploadUrlResponses[keyof GetUserUploadUrlResponses];

export type FindCadencesData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: {
    /**
     * Limit
     */
    limit?: number;
    /**
     * Cursor
     */
    cursor?: string;
    /**
     * Direction
     */
    direction?: 'asc' | 'desc';
    parentId?: string;
    includeArchived?: boolean;
  };
  url: '/v1/organizations/{organizationId}/cadences';
};

export type FindCadencesResponses = {
  /**
   * Cadences response
   */
  200: CadenceListResponse;
};

export type FindCadencesResponse =
  FindCadencesResponses[keyof FindCadencesResponses];

export type CreateCadenceData = {
  body?: CreateCadence;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/cadences';
};

export type CreateCadenceResponses = {
  /**
   * Create Cadence response
   */
  200: CadenceResponse;
};

export type CreateCadenceResponse =
  CreateCadenceResponses[keyof CreateCadenceResponses];

export type ArchiveCadenceData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Cadence ID
     */
    cadenceId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/cadences/{cadenceId}';
};

export type ArchiveCadenceResponses = {
  /**
   * Archive Cadence response
   */
  200: CadenceResponse;
};

export type ArchiveCadenceResponse =
  ArchiveCadenceResponses[keyof ArchiveCadenceResponses];

export type UpdateCadenceData = {
  body?: UpdateCadence;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Cadence ID
     */
    cadenceId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/cadences/{cadenceId}';
};

export type UpdateCadenceResponses = {
  /**
   * Update Cadence response
   */
  200: CadenceResponse;
};

export type UpdateCadenceResponse =
  UpdateCadenceResponses[keyof UpdateCadenceResponses];

export type UnarchiveCadenceData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Cadence ID
     */
    cadenceId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/cadences/{cadenceId}/unarchive';
};

export type UnarchiveCadenceResponses = {
  /**
   * Unarchive Cadence response
   */
  200: CadenceResponse;
};

export type UnarchiveCadenceResponse =
  UnarchiveCadenceResponses[keyof UnarchiveCadenceResponses];

export type FindTimeBoxesData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: {
    /**
     * Limit
     */
    limit?: number;
    /**
     * Cursor
     */
    cursor?: string;
    /**
     * Direction
     */
    direction?: 'asc' | 'desc';
    cadenceId?: string;
    endDateGTE?: string;
    endDateLTE?: string;
  };
  url: '/v1/organizations/{organizationId}/time-boxes';
};

export type FindTimeBoxesResponses = {
  /**
   * TimeBox List Response
   */
  200: {
    data: Array<TimeBox>;
    meta: {
      cursor?: string;
      aggregations?: {
        [key: string]: {
          [key: string]: unknown;
        };
      };
      total?: number;
      hasMoreData: boolean;
    };
  };
};

export type FindTimeBoxesResponse =
  FindTimeBoxesResponses[keyof FindTimeBoxesResponses];

export type CreateTimeBoxData = {
  body?: CreateTimeBox;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/time-boxes';
};

export type CreateTimeBoxResponses = {
  /**
   * TimeBox Response
   */
  200: {
    data: TimeBox;
  };
};

export type CreateTimeBoxResponse =
  CreateTimeBoxResponses[keyof CreateTimeBoxResponses];

export type UpdateTimeBoxData = {
  body?: UpdateTimeBox;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    timeBoxId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/time-boxes/{timeBoxId}';
};

export type UpdateTimeBoxResponses = {
  /**
   * TimeBox Response
   */
  200: {
    data: TimeBox;
  };
};

export type UpdateTimeBoxResponse =
  UpdateTimeBoxResponses[keyof UpdateTimeBoxResponses];

export type DeleteTimeBoxData = {
  body?: DeleteTimeBox;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Cadence ID
     */
    cadenceId: string;
    /**
     * Time Box ID
     */
    timeBoxId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/cadences/{cadenceId}/time-boxes/{timeBoxId}';
};

export type DeleteTimeBoxResponses = {
  /**
   * Delete TimeBox response
   */
  200: {
    success: boolean;
  };
};

export type DeleteTimeBoxResponse =
  DeleteTimeBoxResponses[keyof DeleteTimeBoxResponses];

export type FindBoardFoldersData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: {
    /**
     * Limit
     */
    limit?: number;
    /**
     * Cursor
     */
    cursor?: string;
    /**
     * Direction
     */
    direction?: 'asc' | 'desc';
    parentId?: string;
    cadenceId?: string;
    labelContains?: string;
    ids?: Array<string> | Array<string>;
    includeArchived?: boolean;
  };
  url: '/v1/organizations/{organizationId}/board-folders';
};

export type FindBoardFoldersResponses = {
  /**
   * BoardFolders response
   */
  200: BoardFolderListResponse;
};

export type FindBoardFoldersResponse =
  FindBoardFoldersResponses[keyof FindBoardFoldersResponses];

export type CreateBoardFolderData = {
  body?: CreateBoardFolder;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/board-folders';
};

export type CreateBoardFolderResponses = {
  /**
   * Create BoardFolder response
   */
  200: BoardFolderResponse;
};

export type CreateBoardFolderResponse =
  CreateBoardFolderResponses[keyof CreateBoardFolderResponses];

export type ArchiveBoardFolderData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Board Folder ID
     */
    boardFolderId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/board-folders/{boardFolderId}';
};

export type ArchiveBoardFolderResponses = {
  /**
   * Archive BoardFolder response
   */
  200: BoardFolderResponse;
};

export type ArchiveBoardFolderResponse =
  ArchiveBoardFolderResponses[keyof ArchiveBoardFolderResponses];

export type GetBoardFolderByIdData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Board Folder ID
     */
    boardFolderId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/board-folders/{boardFolderId}';
};

export type GetBoardFolderByIdResponses = {
  /**
   * Board Folder response
   */
  200: BoardFolderResponse;
};

export type GetBoardFolderByIdResponse =
  GetBoardFolderByIdResponses[keyof GetBoardFolderByIdResponses];

export type UpdateBoardFolderData = {
  body?: UpdateBoardFolder;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Board Folder ID
     */
    boardFolderId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/board-folders/{boardFolderId}';
};

export type UpdateBoardFolderResponses = {
  /**
   * Update BoardFolder response
   */
  200: BoardFolderResponse;
};

export type UpdateBoardFolderResponse =
  UpdateBoardFolderResponses[keyof UpdateBoardFolderResponses];

export type UnarchiveBoardFolderData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Board Folder ID
     */
    boardFolderId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/board-folders/{boardFolderId}/unarchive';
};

export type UnarchiveBoardFolderResponses = {
  /**
   * Unarchive BoardFolder response
   */
  200: BoardFolderResponse;
};

export type UnarchiveBoardFolderResponse =
  UnarchiveBoardFolderResponses[keyof UnarchiveBoardFolderResponses];

export type FindBoardsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: {
    /**
     * Limit
     */
    limit?: number;
    /**
     * Cursor
     */
    cursor?: string;
    /**
     * Direction
     */
    direction?: 'asc' | 'desc';
    boardFolderId?: string;
    laneCollectionId?: string;
    timeBoxId?: string;
    timeBased?: boolean;
    endDateGTE?: string;
    endDateLTE?: string;
    labelContains?: string;
    ids?: Array<string> | Array<string>;
    all?: boolean;
  };
  url: '/v1/organizations/{organizationId}/boards';
};

export type FindBoardsResponses = {
  /**
   * Boards response
   */
  200: BoardListResponse;
};

export type FindBoardsResponse = FindBoardsResponses[keyof FindBoardsResponses];

export type CreateBoardData = {
  body?: CreateBoard;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/boards';
};

export type CreateBoardResponses = {
  /**
   * Create Board response
   */
  200: BoardResponse;
};

export type CreateBoardResponse =
  CreateBoardResponses[keyof CreateBoardResponses];

export type ArchiveBoardData = {
  body?: ArchiveBoard;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Board ID
     */
    boardId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/boards/{boardId}';
};

export type ArchiveBoardResponses = {
  /**
   * The job that moves the items to the new board
   */
  200: {
    jobId: string;
  };
};

export type ArchiveBoardResponse =
  ArchiveBoardResponses[keyof ArchiveBoardResponses];

export type GetBoardByIdData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Board ID
     */
    boardId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/boards/{boardId}';
};

export type GetBoardByIdResponses = {
  /**
   * Get Board By Id response
   */
  200: BoardResponse;
};

export type GetBoardByIdResponse =
  GetBoardByIdResponses[keyof GetBoardByIdResponses];

export type UpdateBoardData = {
  body?: UpdateBoard;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Board ID
     */
    boardId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/boards/{boardId}';
};

export type UpdateBoardResponses = {
  /**
   * Update Board response
   */
  200: BoardResponse;
};

export type UpdateBoardResponse =
  UpdateBoardResponses[keyof UpdateBoardResponses];

export type FindFavoriteBoardsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/board-favorites';
};

export type FindFavoriteBoardsResponses = {
  /**
   * Favorite Board Response
   */
  200: {
    data: FavoriteBoard;
  };
};

export type FindFavoriteBoardsResponse =
  FindFavoriteBoardsResponses[keyof FindFavoriteBoardsResponses];

export type UpdateFavoriteBoardsData = {
  body?: UpdateFavoriteBoards;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/board-favorites';
};

export type UpdateFavoriteBoardsResponses = {
  /**
   * Favorite Board Response
   */
  200: {
    data: FavoriteBoard;
  };
};

export type UpdateFavoriteBoardsResponse =
  UpdateFavoriteBoardsResponses[keyof UpdateFavoriteBoardsResponses];

export type GetBoardFoldersByIdsData = {
  body?: {
    ids: Array<string>;
  };
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/board-folders/batch';
};

export type GetBoardFoldersByIdsResponses = {
  /**
   * Board Folders batch response
   */
  200: BoardFolderListResponse;
};

export type GetBoardFoldersByIdsResponse =
  GetBoardFoldersByIdsResponses[keyof GetBoardFoldersByIdsResponses];

export type GetBoardsByIdsData = {
  body?: {
    ids: Array<string>;
  };
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/boards/batch';
};

export type GetBoardsByIdsResponses = {
  /**
   * Boards batch response
   */
  200: BoardListResponse;
};

export type GetBoardsByIdsResponse =
  GetBoardsByIdsResponses[keyof GetBoardsByIdsResponses];

export type FindBoardsByRangeData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query: {
    cycleRange: Array<number>;
    boardFolderIds?: Array<string>;
  };
  url: '/v1/organizations/{organizationId}/boards-by-range';
};

export type FindBoardsByRangeResponses = {
  /**
   * Boards By Range response
   */
  200: BoardListResponse;
};

export type FindBoardsByRangeResponse =
  FindBoardsByRangeResponses[keyof FindBoardsByRangeResponses];

export type RemoveCommentFavoriteData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Comment ID
     */
    commentId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/item-comments/{commentId}/favorite';
};

export type RemoveCommentFavoriteResponses = {
  /**
   * Remove comment favorite response
   */
  200: CommentResponse;
};

export type RemoveCommentFavoriteResponse =
  RemoveCommentFavoriteResponses[keyof RemoveCommentFavoriteResponses];

export type AddCommentFavoriteData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Comment ID
     */
    commentId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/item-comments/{commentId}/favorite';
};

export type AddCommentFavoriteResponses = {
  /**
   * Add comment favorite response
   */
  200: CommentResponse;
};

export type AddCommentFavoriteResponse =
  AddCommentFavoriteResponses[keyof AddCommentFavoriteResponses];

export type AddCommentReactionData = {
  body?: AddCommentReaction;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Comment ID
     */
    commentId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/item-comments/{commentId}/reactions';
};

export type AddCommentReactionResponses = {
  /**
   * Add comment reaction response
   */
  200: CommentResponse;
};

export type AddCommentReactionResponse =
  AddCommentReactionResponses[keyof AddCommentReactionResponses];

export type FindCommentRepliesData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Comment ID
     */
    commentId: string;
  };
  query?: {
    /**
     * Limit
     */
    limit?: number;
    /**
     * Cursor
     */
    cursor?: string;
    /**
     * Direction
     */
    direction?: 'asc' | 'desc';
  };
  url: '/v1/organizations/{organizationId}/item-comments/{commentId}/replies';
};

export type FindCommentRepliesResponses = {
  /**
   * Comment replies list response
   */
  200: CommentListResponse;
};

export type FindCommentRepliesResponse =
  FindCommentRepliesResponses[keyof FindCommentRepliesResponses];

export type AddCommentReplyData = {
  body?: CreateComment;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Comment ID
     */
    commentId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/item-comments/{commentId}/replies';
};

export type AddCommentReplyResponses = {
  /**
   * Add comment reply response
   */
  200: CommentResponse;
};

export type AddCommentReplyResponse =
  AddCommentReplyResponses[keyof AddCommentReplyResponses];

export type FindItemCommentsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query: {
    /**
     * Limit
     */
    limit?: number;
    /**
     * Cursor
     */
    cursor?: string;
    /**
     * Direction
     */
    direction?: 'asc' | 'desc';
    /**
     * Item Number
     */
    itemNumber: string;
  };
  url: '/v1/organizations/{organizationId}/item-comments';
};

export type FindItemCommentsResponses = {
  /**
   * Item comments list response
   */
  200: CommentListResponse;
};

export type FindItemCommentsResponse =
  FindItemCommentsResponses[keyof FindItemCommentsResponses];

export type AddItemCommentData = {
  body?: CreateItemComment;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/item-comments';
};

export type AddItemCommentResponses = {
  /**
   * Add item comment response
   */
  200: CommentResponse;
};

export type AddItemCommentResponse =
  AddItemCommentResponses[keyof AddItemCommentResponses];

export type DeleteCommentData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Comment ID
     */
    commentId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/item-comments/{commentId}';
};

export type DeleteCommentResponses = {
  /**
   * Delete comment response
   */
  200: CommentResponse;
};

export type DeleteCommentResponse =
  DeleteCommentResponses[keyof DeleteCommentResponses];

export type GetCommentByIdData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Comment ID
     */
    commentId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/item-comments/{commentId}';
};

export type GetCommentByIdResponses = {
  /**
   * Get comment by id response
   */
  200: CommentResponse;
};

export type GetCommentByIdResponse =
  GetCommentByIdResponses[keyof GetCommentByIdResponses];

export type UpdateCommentData = {
  body?: UpdateComment;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Comment ID
     */
    commentId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/item-comments/{commentId}';
};

export type UpdateCommentResponses = {
  /**
   * Update comment response
   */
  200: CommentResponse;
};

export type UpdateCommentResponse =
  UpdateCommentResponses[keyof UpdateCommentResponses];

export type RemoveCommentReactionData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Comment ID
     */
    commentId: string;
    /**
     * Reaction
     */
    reaction: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/item-comments/{commentId}/reactions/{reaction}';
};

export type RemoveCommentReactionResponses = {
  /**
   * Remove comment reaction response
   */
  200: CommentResponse;
};

export type RemoveCommentReactionResponse =
  RemoveCommentReactionResponses[keyof RemoveCommentReactionResponses];

export type GetCommentMessageHistoryByCommentIdData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Comment ID
     */
    commentId: string;
  };
  query?: {
    /**
     * Limit
     */
    limit?: number;
    /**
     * Cursor
     */
    cursor?: string;
    /**
     * Direction
     */
    direction?: 'asc' | 'desc';
  };
  url: '/v1/organizations/{organizationId}/item-comments/{commentId}/history';
};

export type GetCommentMessageHistoryByCommentIdResponses = {
  /**
   * Comment message history replies list response
   */
  200: CommentMessageHistoryListResponse;
};

export type GetCommentMessageHistoryByCommentIdResponse =
  GetCommentMessageHistoryByCommentIdResponses[keyof GetCommentMessageHistoryByCommentIdResponses];

export type FindGithubInstallationsByOrganizationIdData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/integrations/github/{organizationId}';
};

export type FindGithubInstallationsByOrganizationIdResponses = {
  /**
   * Github Installation List Response
   */
  200: {
    data: Array<GithubInstallation>;
    meta: {
      cursor?: string;
      aggregations?: {
        [key: string]: {
          [key: string]: unknown;
        };
      };
      total?: number;
      hasMoreData: boolean;
    };
  };
};

export type FindGithubInstallationsByOrganizationIdResponse =
  FindGithubInstallationsByOrganizationIdResponses[keyof FindGithubInstallationsByOrganizationIdResponses];

export type CreateGithubInstallationData = {
  body?: CreateGithubInstallation;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/integrations/github/{organizationId}';
};

export type CreateGithubInstallationResponses = {
  /**
   * Create Github Installation response
   */
  200: GithubInstallationResponse;
};

export type CreateGithubInstallationResponse =
  CreateGithubInstallationResponses[keyof CreateGithubInstallationResponses];

export type GetWorkItemBranchesData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
  };
  query?: never;
  url: '/v1/integrations/github/{organizationId}/work-items/{itemNumber}/branches';
};

export type GetWorkItemBranchesResponses = {
  /**
   * WorkItem Branches response
   */
  200: BranchListResponse;
};

export type GetWorkItemBranchesResponse =
  GetWorkItemBranchesResponses[keyof GetWorkItemBranchesResponses];

export type GetWorkItemCommitsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
  };
  query?: never;
  url: '/v1/integrations/github/{organizationId}/work-items/{itemNumber}/commits';
};

export type GetWorkItemCommitsResponses = {
  /**
   * WorkItem Commits response
   */
  200: CommitListResponse;
};

export type GetWorkItemCommitsResponse =
  GetWorkItemCommitsResponses[keyof GetWorkItemCommitsResponses];

export type GetWorkItemPullRequestsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
  };
  query?: never;
  url: '/v1/integrations/github/{organizationId}/work-items/{itemNumber}/pull-requests';
};

export type GetWorkItemPullRequestsResponses = {
  /**
   * WorkItem Pull Requests response
   */
  200: PullRequestListResponse;
};

export type GetWorkItemPullRequestsResponse =
  GetWorkItemPullRequestsResponses[keyof GetWorkItemPullRequestsResponses];

export type FindImportJobsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: {
    /**
     * Limit
     */
    limit?: number;
    /**
     * Cursor
     */
    cursor?: string;
    /**
     * Direction
     */
    direction?: 'asc' | 'desc';
    type?: 'trello' | 'template';
  };
  url: '/v1/organizations/{organizationId}/importer/jobs';
};

export type FindImportJobsResponses = {
  /**
   * Import job list response
   */
  200: ImportJobListResponse;
};

export type FindImportJobsResponse =
  FindImportJobsResponses[keyof FindImportJobsResponses];

export type CreateImportJobData = {
  body?: CreateImportJob;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/importer/jobs';
};

export type CreateImportJobResponses = {
  /**
   * Import job response
   */
  200: ImportJobResponse;
};

export type CreateImportJobResponse =
  CreateImportJobResponses[keyof CreateImportJobResponses];

export type FindImportJobRunsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Import Job ID
     */
    importJobId: string;
  };
  query?: {
    /**
     * Limit
     */
    limit?: number;
    /**
     * Cursor
     */
    cursor?: string;
    /**
     * Direction
     */
    direction?: 'asc' | 'desc';
    type?: 'trello' | 'template';
  };
  url: '/v1/organizations/{organizationId}/importer/jobs/{importJobId}/runs';
};

export type FindImportJobRunsResponses = {
  /**
   * Import job run list response
   */
  200: ImportJobRunListResponse;
};

export type FindImportJobRunsResponse =
  FindImportJobRunsResponses[keyof FindImportJobRunsResponses];

export type CreateImportJobRunData = {
  body?: CreateImportJobRun;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Import Job ID
     */
    importJobId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/importer/jobs/{importJobId}/runs';
};

export type CreateImportJobRunResponses = {
  /**
   * Import job run response
   */
  200: ImportJobRunResponse;
};

export type CreateImportJobRunResponse =
  CreateImportJobRunResponses[keyof CreateImportJobRunResponses];

export type GenerateExportFileData = {
  body?: GenerateExportFile;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/importer/generate-export-file';
};

export type GenerateExportFileResponses = {
  /**
   * Generate export file response
   */
  200: {
    url: string;
  };
};

export type GenerateExportFileResponse =
  GenerateExportFileResponses[keyof GenerateExportFileResponses];

export type GetImportUploadUrlData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query: {
    fileName: string;
    fileType: string;
  };
  url: '/v1/organizations/{organizationId}/importer/upload-url';
};

export type GetImportUploadUrlResponses = {
  /**
   * Pre-signed URL for uploading file
   */
  200: PreSignedUrlResponse;
};

export type GetImportUploadUrlResponse =
  GetImportUploadUrlResponses[keyof GetImportUploadUrlResponses];

export type SyncAdoWorkitemData = {
  body?: {
    adoWorkItemId: number;
    adoProjectId: string;
  };
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    installationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/integrations/{installationId}/ado/sync-workitem';
};

export type SyncAdoWorkitemResponses = {
  /**
   * Sync ADO Workitem response
   */
  200: {
    success: boolean;
  };
};

export type SyncAdoWorkitemResponse =
  SyncAdoWorkitemResponses[keyof SyncAdoWorkitemResponses];

export type FindIntegrationInstallationsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/integrations/installations';
};

export type FindIntegrationInstallationsResponses = {
  /**
   * List of integration installations
   */
  200: IntegrationInstallationListResponse;
};

export type FindIntegrationInstallationsResponse =
  FindIntegrationInstallationsResponses[keyof FindIntegrationInstallationsResponses];

export type CreateIntegrationInstallationData = {
  body?: CreateIntegrationInstallation;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/integrations/installations';
};

export type CreateIntegrationInstallationResponses = {
  /**
   * Integration Installation created successfully
   */
  200: IntegrationInstallationResponse;
};

export type CreateIntegrationInstallationResponse =
  CreateIntegrationInstallationResponses[keyof CreateIntegrationInstallationResponses];

export type CreateOAuthTokenData = {
  body?: never;
  path?: never;
  query: {
    state: string;
    code: string;
  };
  url: '/v1/integrations/oauth2/callback';
};

export type SyncJiraSubitemData = {
  body?: {
    jiraIssueId: string;
    jiraProjectId: string;
  };
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    installationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/integrations/{installationId}/jira/sync-subitem';
};

export type SyncJiraSubitemResponses = {
  /**
   * Jira subitem sync response
   */
  200: {
    success: boolean;
  };
};

export type SyncJiraSubitemResponse =
  SyncJiraSubitemResponses[keyof SyncJiraSubitemResponses];

export type SyncJiraWorkitemData = {
  body?: {
    jiraIssueId: string;
    jiraProjectId: string;
  };
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    installationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/integrations/{installationId}/jira/sync-workitem';
};

export type SyncJiraWorkitemResponses = {
  /**
   * Jira workitem sync response
   */
  200: {
    success: boolean;
  };
};

export type SyncJiraWorkitemResponse =
  SyncJiraWorkitemResponses[keyof SyncJiraWorkitemResponses];

export type ProxyInstallationRequestData = {
  body?: {
    method: 'GET' | 'POST' | 'PUT' | 'DELETE';
    url: string;
    headers?: {
      [key: string]: string;
    };
    body?: unknown;
    queryParams?: {
      [key: string]: string;
    };
  };
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    installationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/integrations/{installationId}/proxy';
};

export type ProxyInstallationRequestResponses = {
  /**
   * Proxy installation request processed successfully
   */
  200: ProxyInstallationRequestResponse;
};

export type ProxyInstallationRequestResponse2 =
  ProxyInstallationRequestResponses[keyof ProxyInstallationRequestResponses];

export type SaveProviderConfigurationData = {
  body?: AdoMappings | JiraMappings;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    installationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/integrations/{installationId}/config';
};

export type SaveProviderConfigurationResponses = {
  /**
   * Provider configuration saved successfully
   */
  200: {
    [key: string]: unknown;
  };
};

export type SaveProviderConfigurationResponse =
  SaveProviderConfigurationResponses[keyof SaveProviderConfigurationResponses];

export type UpdateIntegrationCredentialData = {
  body?: {
    name: string;
  };
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    credentialsId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/integrations/credentials/{credentialsId}';
};

export type UpdateIntegrationCredentialResponses = {
  /**
   * Integration credential updated successfully
   */
  200: IntegrationCredentialsResponse;
};

export type UpdateIntegrationCredentialResponse =
  UpdateIntegrationCredentialResponses[keyof UpdateIntegrationCredentialResponses];

export type FindCredentialsAccountsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    credentialsId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/integrations/credentials/{credentialsId}/accounts';
};

export type FindCredentialsAccountsResponses = {
  /**
   * List of credential accounts
   */
  200: CredentialsAccountsListResponse;
};

export type FindCredentialsAccountsResponse =
  FindCredentialsAccountsResponses[keyof FindCredentialsAccountsResponses];

export type FindIntegrationCredentialsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/integrations/credentials';
};

export type FindIntegrationCredentialsResponses = {
  /**
   * List of integration credentials
   */
  200: IntegrationCredentialsListResponse;
};

export type FindIntegrationCredentialsResponse =
  FindIntegrationCredentialsResponses[keyof FindIntegrationCredentialsResponses];

export type GetIntegrationAuthorizeUrlData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    provider: 'jira' | 'ado';
  };
  query: {
    name: string;
  };
  url: '/v1/organizations/{organizationId}/integrations/{provider}/authorize';
};

export type GetIntegrationAuthorizeUrlResponses = {
  /**
   * Integration authorize URL
   */
  200: {
    url: string;
  };
};

export type GetIntegrationAuthorizeUrlResponse =
  GetIntegrationAuthorizeUrlResponses[keyof GetIntegrationAuthorizeUrlResponses];

export type CreateFolderData = {
  body?: CreateFolder;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/folders';
};

export type CreateFolderResponses = {
  /**
   * Create Folder response
   */
  200: FolderResponse;
};

export type CreateFolderResponse =
  CreateFolderResponses[keyof CreateFolderResponses];

export type DeleteFolderData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/folders/{itemNumber}';
};

export type DeleteFolderResponses = {
  /**
   * Delete Folder response
   */
  200: {
    success: boolean;
  };
};

export type DeleteFolderResponse =
  DeleteFolderResponses[keyof DeleteFolderResponses];

export type GetFolderByIdData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/folders/{itemNumber}';
};

export type GetFolderByIdResponses = {
  /**
   * Folder response
   */
  200: FolderResponse;
};

export type GetFolderByIdResponse =
  GetFolderByIdResponses[keyof GetFolderByIdResponses];

export type UpdateFolderData = {
  body?: UpdateFolder;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/folders/{itemNumber}';
};

export type UpdateFolderResponses = {
  /**
   * Update Folder response
   */
  200: FolderResponse;
};

export type UpdateFolderResponse =
  UpdateFolderResponses[keyof UpdateFolderResponses];

export type ArchiveFolderData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/folders/{itemNumber}/archive';
};

export type ArchiveFolderResponses = {
  /**
   * Archive Folder response
   */
  200: FolderResponse;
};

export type ArchiveFolderResponse =
  ArchiveFolderResponses[keyof ArchiveFolderResponses];

export type UnarchiveFolderData = {
  body?: UnarchiveFolder;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/folders/{itemNumber}/unarchive';
};

export type UnarchiveFolderResponses = {
  /**
   * Unarchive Folder response
   */
  200: FolderResponse;
};

export type UnarchiveFolderResponse =
  UnarchiveFolderResponses[keyof UnarchiveFolderResponses];

export type ArchiveFoldersData = {
  body?: ArchiveFolders;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/folders/archive';
};

export type ArchiveFoldersResponses = {
  /**
   * Archive Folders response
   */
  200: FolderListResponse;
};

export type ArchiveFoldersResponse =
  ArchiveFoldersResponses[keyof ArchiveFoldersResponses];

export type UpdateFolderRelationshipsData = {
  body?: UpdateFolderRelationships;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/folders/{itemNumber}/relationships';
};

export type UpdateFolderRelationshipsResponses = {
  /**
   * Update Folder Relationships response
   */
  200: FolderResponse;
};

export type UpdateFolderRelationshipsResponse =
  UpdateFolderRelationshipsResponses[keyof UpdateFolderRelationshipsResponses];

export type CreateWorkItemData = {
  body?: CreateWorkItem;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/work-items';
};

export type CreateWorkItemResponses = {
  /**
   * Create WorkItem response
   */
  200: WorkItemResponse;
};

export type CreateWorkItemResponse =
  CreateWorkItemResponses[keyof CreateWorkItemResponses];

export type DeleteWorkItemData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/work-items/{itemNumber}';
};

export type DeleteWorkItemResponses = {
  /**
   * Delete WorkItem response
   */
  200: {
    success: boolean;
  };
};

export type DeleteWorkItemResponse =
  DeleteWorkItemResponses[keyof DeleteWorkItemResponses];

export type GetWorkItemByIdData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/work-items/{itemNumber}';
};

export type GetWorkItemByIdResponses = {
  /**
   * WorkItem response
   */
  200: WorkItemResponse;
};

export type GetWorkItemByIdResponse =
  GetWorkItemByIdResponses[keyof GetWorkItemByIdResponses];

export type UpdateWorkItemData = {
  body?: UpdateWorkItem;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/work-items/{itemNumber}';
};

export type UpdateWorkItemResponses = {
  /**
   * Update WorkItem response
   */
  200: WorkItemResponse;
};

export type UpdateWorkItemResponse =
  UpdateWorkItemResponses[keyof UpdateWorkItemResponses];

export type ArchiveWorkItemData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/work-items/{itemNumber}/archive';
};

export type ArchiveWorkItemResponses = {
  /**
   * Archive WorkItem response
   */
  200: WorkItemResponse;
};

export type ArchiveWorkItemResponse =
  ArchiveWorkItemResponses[keyof ArchiveWorkItemResponses];

export type UnarchiveWorkItemData = {
  body?: UnarchiveWorkItem;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/work-items/{itemNumber}/unarchive';
};

export type UnarchiveWorkItemResponses = {
  /**
   * Unarchive WorkItem response
   */
  200: WorkItemResponse;
};

export type UnarchiveWorkItemResponse =
  UnarchiveWorkItemResponses[keyof UnarchiveWorkItemResponses];

export type ArchiveWorkItemsData = {
  body?: ArchiveWorkItems;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/work-items/archive';
};

export type ArchiveWorkItemsResponses = {
  /**
   * Archive WorkItems response
   */
  200: WorkItemListResponse;
};

export type ArchiveWorkItemsResponse =
  ArchiveWorkItemsResponses[keyof ArchiveWorkItemsResponses];

export type UpdateWorkItemRelationshipsData = {
  body?: UpdateWorkItemRelationships;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/work-items/{itemNumber}/relationships';
};

export type UpdateWorkItemRelationshipsResponses = {
  /**
   * Update WorkItem Relationships response
   */
  200: WorkItemResponse;
};

export type UpdateWorkItemRelationshipsResponse =
  UpdateWorkItemRelationshipsResponses[keyof UpdateWorkItemRelationshipsResponses];

export type BulkUpdateItemsData = {
  body?: BulkUpdateItems;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/items/bulk';
};

export type BulkUpdateItemsResponses = {
  /**
   * Bulk Item Update Response
   */
  200: {
    workItems: Array<WorkItem>;
    folders: Array<Folder>;
    errors: Array<{
      itemId: string;
      error: string;
    }>;
  };
};

export type BulkUpdateItemsResponse =
  BulkUpdateItemsResponses[keyof BulkUpdateItemsResponses];

export type CopyWorkItemData = {
  body?: CopyWorkItem;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/work-items/{itemNumber}/copy';
};

export type CopyWorkItemResponses = {
  /**
   * Copy WorkItem response
   */
  200: WorkItemResponse;
};

export type CopyWorkItemResponse =
  CopyWorkItemResponses[keyof CopyWorkItemResponses];

export type BroadcastWorkItemDraftData = {
  body?: BroadcastWorkItemDraft;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/work-items/{itemNumber}/draft';
};

export type BroadcastWorkItemDraftResponses = {
  /**
   * Draft broadcast successfully
   */
  200: BroadcastWorkItemDraftResponse;
};

export type BroadcastWorkItemDraftResponse2 =
  BroadcastWorkItemDraftResponses[keyof BroadcastWorkItemDraftResponses];

export type CreateSubItemData = {
  body?: CreateSubItem;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/work-items/{itemNumber}/sub-items';
};

export type CreateSubItemResponses = {
  /**
   * Create SubItem response
   */
  200: SubItemResponse;
};

export type CreateSubItemResponse =
  CreateSubItemResponses[keyof CreateSubItemResponses];

export type DeleteSubItemData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
    /**
     * Sub Item ID
     */
    subItemId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/work-items/{itemNumber}/sub-items/{subItemId}';
};

export type DeleteSubItemResponses = {
  /**
   * Delete SubItem response
   */
  200: {
    success: boolean;
  };
};

export type DeleteSubItemResponse =
  DeleteSubItemResponses[keyof DeleteSubItemResponses];

export type UpdateSubItemData = {
  body?: UpdateSubItem;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
    /**
     * Sub Item ID
     */
    subItemId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/work-items/{itemNumber}/sub-items/{subItemId}';
};

export type UpdateSubItemResponses = {
  /**
   * Update SubItem response
   */
  200: SubItemResponse;
};

export type UpdateSubItemResponse =
  UpdateSubItemResponses[keyof UpdateSubItemResponses];

export type GetFoldersByIdsData = {
  body?: {
    itemNumbers: Array<string>;
  };
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/folders/batch';
};

export type GetFoldersByIdsResponses = {
  /**
   * Folders batch response
   */
  200: FolderListResponse;
};

export type GetFoldersByIdsResponse =
  GetFoldersByIdsResponses[keyof GetFoldersByIdsResponses];

export type GetWorkItemsByIdsData = {
  body?: {
    itemNumbers: Array<string>;
  };
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/work-items/batch';
};

export type GetWorkItemsByIdsResponses = {
  /**
   * Work items batch response
   */
  200: WorkItemListResponse;
};

export type GetWorkItemsByIdsResponse =
  GetWorkItemsByIdsResponses[keyof GetWorkItemsByIdsResponses];

export type FindItemsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: {
    parentNumber?: Array<string> | Array<string>;
    workTypeId?: Array<string> | Array<string>;
    boardId?: Array<string> | Array<string>;
    rootFolderNumber?: Array<string> | Array<string>;
    teamId?: Array<string> | Array<string>;
    laneId?: Array<string> | Array<string>;
    laneCollectionId?: Array<string> | Array<string>;
    isBacklog?: boolean;
    cycleRange?: Array<number> | Array<number>;
    q?: string;
    isBug?: boolean;
    hasBlocker?: boolean;
    labels?: Array<string> | Array<string>;
    hierarchy?: Array<string> | Array<string>;
    isUnassigned?: boolean;
    hasNoParent?: boolean;
    hasNoTeam?: boolean;
    teamConditions?: ConditionSet;
    hasNoBoard?: boolean;
    boardConditions?: ConditionSet;
    assigneeUsername?: Array<string>;
    assigneeConditions?: ConditionSet;
    authorUsername?: Array<string>;
    assigneeSubItems?: boolean;
    number?: Array<string> | Array<string>;
    color?: Array<string> | Array<string>;
    priority?: Array<string> | Array<string>;
    /**
     * Direction
     */
    direction?: 'asc' | 'desc';
    isDone?: boolean;
    checkChildren?: boolean;
    startDateGTE?: string;
    startDateLTE?: string;
    startDateConditions?: ConditionSet;
    dueDateGTE?: string;
    dueDateLTE?: string;
    dueDateConditions?: ConditionSet;
    timeSpentSecondsGTE?: number | number;
    timeSpentSecondsLTE?: number | number;
    watchers?: Array<string> | Array<string>;
    completedAtGTE?: string;
    completedAtLTE?: string;
    completedAtConditions?: ConditionSet;
    sort?:
      | (
          | 'title'
          | 'authorUsername'
          | 'assigneeUsername'
          | 'boardRank'
          | 'parentRank'
          | 'laneRank'
          | 'workType'
          | 'priority'
          | 'lane'
          | 'team'
          | 'board'
          | 'subItemsCount'
          | 'labelsCount'
          | 'relationshipsCount'
          | 'dateAdded'
          | 'dateUpdated'
          | 'estimate'
          | 'pointEffort'
          | 'timeSpentSeconds'
          | 'startDate'
          | 'dueDate'
          | 'completedAt'
        )
      | string;
    customFields?: CustomFieldConditions | string;
    customFieldExists?: Array<string> | Array<string>;
    advancedFilters?: AdvancedFilterGroup | string;
    itemType?: ItemType;
    aggregations?: Array<string> | Array<string>;
    includeArchived?: boolean;
    withDescription?: boolean;
    /**
     * Limit
     */
    limit?: number;
    /**
     * Cursor
     */
    cursor?: string;
  };
  url: '/v1/organizations/{organizationId}/items';
};

export type FindItemsResponses = {
  /**
   * Find Items response
   */
  200: ItemListResponse;
};

export type FindItemsResponse = FindItemsResponses[keyof FindItemsResponses];

export type GetItemHierarchyData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Number
     */
    itemNumber: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/items/{itemNumber}/hierarchy';
};

export type GetItemHierarchyResponses = {
  /**
   * Item Hierarchy response
   */
  200: ItemListResponse;
};

export type GetItemHierarchyResponse =
  GetItemHierarchyResponses[keyof GetItemHierarchyResponses];

export type GetPublicStoredViewItemsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Stored View ID
     */
    storedViewId: string;
  };
  query?: {
    /**
     * Limit
     */
    limit?: number;
    /**
     * Cursor
     */
    cursor?: string;
    /**
     * Direction
     */
    direction?: 'asc' | 'desc';
    sort?:
      | (
          | 'title'
          | 'authorUsername'
          | 'assigneeUsername'
          | 'boardRank'
          | 'parentRank'
          | 'laneRank'
          | 'workType'
          | 'priority'
          | 'lane'
          | 'team'
          | 'board'
          | 'subItemsCount'
          | 'labelsCount'
          | 'relationshipsCount'
          | 'dateAdded'
          | 'dateUpdated'
          | 'estimate'
          | 'pointEffort'
          | 'timeSpentSeconds'
          | 'startDate'
          | 'dueDate'
          | 'completedAt'
        )
      | string;
    q?: string;
  };
  url: '/v1/organizations/{organizationId}/stored-views/public/{storedViewId}/items';
};

export type GetPublicStoredViewItemsResponses = {
  /**
   * Get Public Stored View Items response
   */
  200: PublicStoredViewItemsResponse;
};

export type GetPublicStoredViewItemsResponse =
  GetPublicStoredViewItemsResponses[keyof GetPublicStoredViewItemsResponses];

export type SubmitBulkCreateItemsJobData = {
  body?: SubmitBulkCreateItemsJob;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/jobs/bulk-create-items';
};

export type SubmitBulkCreateItemsJobResponses = {
  /**
   * Submit Bulk Create Items Job response
   */
  200: JobResponse;
};

export type SubmitBulkCreateItemsJobResponse =
  SubmitBulkCreateItemsJobResponses[keyof SubmitBulkCreateItemsJobResponses];

export type SubmitCopyStreamJobData = {
  body?: SubmitCopyStreamJob;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/jobs/copy-stream';
};

export type SubmitCopyStreamJobResponses = {
  /**
   * Submit Copy Stream Job response
   */
  200: JobResponse;
};

export type SubmitCopyStreamJobResponse =
  SubmitCopyStreamJobResponses[keyof SubmitCopyStreamJobResponses];

export type SubmitCopyItemJobData = {
  body?: SubmitCopyItemJob;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/jobs/copy-item';
};

export type SubmitCopyItemJobResponses = {
  /**
   * Submit Copy Item Job response
   */
  200: JobResponse;
};

export type SubmitCopyItemJobResponse =
  SubmitCopyItemJobResponses[keyof SubmitCopyItemJobResponses];

export type SubmitShiftStartDueDateJobData = {
  body?: SubmitShiftStartDueDateJob;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/jobs/shift-start-due-date';
};

export type SubmitShiftStartDueDateJobResponses = {
  /**
   * Submit Shift Start Due Date Job response
   */
  200: JobResponse;
};

export type SubmitShiftStartDueDateJobResponse =
  SubmitShiftStartDueDateJobResponses[keyof SubmitShiftStartDueDateJobResponses];

export type SubmitUpdateItemsJobData = {
  body?: SubmitUpdateItemsJob;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/jobs/update-items';
};

export type SubmitUpdateItemsJobResponses = {
  /**
   * Submit Update Items Job response
   */
  200: JobResponse;
};

export type SubmitUpdateItemsJobResponse =
  SubmitUpdateItemsJobResponses[keyof SubmitUpdateItemsJobResponses];

export type SubmitUpdateFilteredItemsJobData = {
  body?: SubmitUpdateFilteredItemsJob;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/jobs/update-filtered-items';
};

export type SubmitUpdateFilteredItemsJobResponses = {
  /**
   * Submit Update Filtered Items Job response
   */
  200: JobResponse;
};

export type SubmitUpdateFilteredItemsJobResponse =
  SubmitUpdateFilteredItemsJobResponses[keyof SubmitUpdateFilteredItemsJobResponses];

export type SubmitCreateImportRunData = {
  body?: SubmitImportRunJob;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/jobs/create-import-run';
};

export type SubmitCreateImportRunResponses = {
  /**
   * Submit Create Import Run response
   */
  200: JobResponse;
};

export type SubmitCreateImportRunResponse =
  SubmitCreateImportRunResponses[keyof SubmitCreateImportRunResponses];

export type SubmitDisableInstallationIntegrationJobData = {
  body?: SubmitDisableInstallationIntegrationJob;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/jobs/disable-installation';
};

export type SubmitDisableInstallationIntegrationJobResponses = {
  /**
   * Submit Disable Installation Integration Job response
   */
  200: JobResponse;
};

export type SubmitDisableInstallationIntegrationJobResponse =
  SubmitDisableInstallationIntegrationJobResponses[keyof SubmitDisableInstallationIntegrationJobResponses];

export type SubmitIntegrationJobData = {
  body?: SubmitIntegrationJob;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/jobs/integration';
};

export type SubmitIntegrationJobResponses = {
  /**
   * Submit Integration Job response
   */
  200: JobResponse;
};

export type SubmitIntegrationJobResponse =
  SubmitIntegrationJobResponses[keyof SubmitIntegrationJobResponses];

export type SubmitDisableCredentialIntegrationJobData = {
  body?: SubmitDisableCredentialIntegrationJob;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/jobs/disable-credential';
};

export type SubmitDisableCredentialIntegrationJobResponses = {
  /**
   * Submit Disable Credential Integration Job response
   */
  200: JobResponse;
};

export type SubmitDisableCredentialIntegrationJobResponse =
  SubmitDisableCredentialIntegrationJobResponses[keyof SubmitDisableCredentialIntegrationJobResponses];

export type FindJobsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: {
    /**
     * Limit
     */
    limit?: number;
    /**
     * Cursor
     */
    cursor?: string;
    /**
     * Direction
     */
    direction?: 'asc' | 'desc';
    type?: JobType;
    status?: JobStatus;
  };
  url: '/v1/organizations/{organizationId}/jobs';
};

export type FindJobsResponses = {
  /**
   * Jobs list response
   */
  200: JobListResponse;
};

export type FindJobsResponse = FindJobsResponses[keyof FindJobsResponses];

export type GetJobByIdData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    jobId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/jobs/{jobId}';
};

export type GetJobByIdResponses = {
  /**
   * Jobs list response
   */
  200: JobResponse;
};

export type GetJobByIdResponse = GetJobByIdResponses[keyof GetJobByIdResponses];

export type ActivateReadOnlyAccessData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/database-credentials/activate';
};

export type ActivateReadOnlyAccessResponses = {
  /**
   * Activated credentials response
   */
  200: OrganizationDatabaseCredential;
};

export type ActivateReadOnlyAccessResponse =
  ActivateReadOnlyAccessResponses[keyof ActivateReadOnlyAccessResponses];

export type AdminUpdateOrganizationData = {
  body?: AdminUpdateOrganization;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/admin/organizations/{organizationId}';
};

export type AdminUpdateOrganizationResponses = {
  /**
   * Update Organization response
   */
  200: OrganizationResponse;
};

export type AdminUpdateOrganizationResponse =
  AdminUpdateOrganizationResponses[keyof AdminUpdateOrganizationResponses];

export type DeleteReadOnlyCredentialsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/database-credentials';
};

export type DeleteReadOnlyCredentialsResponses = {
  /**
   * Delete initiated successfully
   */
  200: OrganizationDatabaseCredential;
};

export type DeleteReadOnlyCredentialsResponse =
  DeleteReadOnlyCredentialsResponses[keyof DeleteReadOnlyCredentialsResponses];

export type GetReadOnlyCredentialsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/database-credentials';
};

export type GetReadOnlyCredentialsResponses = {
  /**
   * Read-only credentials response
   */
  200: ReadOnlyCredentialsResponse;
};

export type GetReadOnlyCredentialsResponse =
  GetReadOnlyCredentialsResponses[keyof GetReadOnlyCredentialsResponses];

export type GenerateReadOnlyCredentialsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/database-credentials/generate';
};

export type GenerateReadOnlyCredentialsResponses = {
  /**
   * Generated credentials response
   */
  200: GeneratedCredentialsResponse;
};

export type GenerateReadOnlyCredentialsResponse =
  GenerateReadOnlyCredentialsResponses[keyof GenerateReadOnlyCredentialsResponses];

export type RevokeReadOnlyAccessData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/database-credentials/revoke';
};

export type RevokeReadOnlyAccessResponses = {
  /**
   * Revoked credentials response
   */
  200: OrganizationDatabaseCredential;
};

export type RevokeReadOnlyAccessResponse =
  RevokeReadOnlyAccessResponses[keyof RevokeReadOnlyAccessResponses];

export type RotateReadOnlyPasswordData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/database-credentials/rotate-password';
};

export type RotateReadOnlyPasswordResponses = {
  /**
   * Rotated password response
   */
  200: RotatedPasswordResponse;
};

export type RotateReadOnlyPasswordResponse =
  RotateReadOnlyPasswordResponses[keyof RotateReadOnlyPasswordResponses];

export type SyncReadOnlyAccessData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/database-credentials/sync';
};

export type SyncReadOnlyAccessResponses = {
  /**
   * Sync access response
   */
  200: SyncAccessResponse;
};

export type SyncReadOnlyAccessResponse =
  SyncReadOnlyAccessResponses[keyof SyncReadOnlyAccessResponses];

export type CreateOrganizationData = {
  body?: CreateOrganization;
  path?: never;
  query?: never;
  url: '/v1/organizations';
};

export type CreateOrganizationResponses = {
  /**
   * Create Organization response
   */
  200: OrganizationResponse;
};

export type CreateOrganizationResponse =
  CreateOrganizationResponses[keyof CreateOrganizationResponses];

export type GetOrganizationByIdData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}';
};

export type GetOrganizationByIdResponses = {
  /**
   * Organization response
   */
  200: OrganizationResponse;
};

export type GetOrganizationByIdResponse =
  GetOrganizationByIdResponses[keyof GetOrganizationByIdResponses];

export type UpdateOrganizationData = {
  body?: UpdateOrganization;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}';
};

export type UpdateOrganizationResponses = {
  /**
   * Update Organization response
   */
  200: OrganizationResponse;
};

export type UpdateOrganizationResponse =
  UpdateOrganizationResponses[keyof UpdateOrganizationResponses];

export type CreateUserLabelGroupData = {
  body?: CreateUserLabelGroup;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/user-label-groups';
};

export type CreateUserLabelGroupResponses = {
  /**
   * Create User Label Group response
   */
  200: UserLabelGroupResponse;
};

export type CreateUserLabelGroupResponse =
  CreateUserLabelGroupResponses[keyof CreateUserLabelGroupResponses];

export type DeleteUserLabelGroupData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * User Label Group ID
     */
    userLabelGroupId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/user-label-groups/{userLabelGroupId}';
};

export type DeleteUserLabelGroupResponses = {
  /**
   * Delete User Label Group response
   */
  200: UserLabelGroupResponse;
};

export type DeleteUserLabelGroupResponse =
  DeleteUserLabelGroupResponses[keyof DeleteUserLabelGroupResponses];

export type UpdateUserLabelGroupData = {
  body?: UpdateUserLabelGroup;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * User Label Group ID
     */
    userLabelGroupId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/user-label-groups/{userLabelGroupId}';
};

export type UpdateUserLabelGroupResponses = {
  /**
   * UpdateUserLabelGroup response
   */
  200: UserLabelGroupResponse;
};

export type UpdateUserLabelGroupResponse =
  UpdateUserLabelGroupResponses[keyof UpdateUserLabelGroupResponses];

export type AddCreateWorkTypeData = {
  body?: CreateWorkType;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/work-types';
};

export type AddCreateWorkTypeResponses = {
  /**
   * Add WorkType response
   */
  200: WorkTypeResponse;
};

export type AddCreateWorkTypeResponse =
  AddCreateWorkTypeResponses[keyof AddCreateWorkTypeResponses];

export type ArchiveWorkTypeData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Work Type ID
     */
    workTypeId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/work-types/{workTypeId}';
};

export type ArchiveWorkTypeResponses = {
  /**
   * Archive Work Type response
   */
  200: WorkTypeResponse;
};

export type ArchiveWorkTypeResponse =
  ArchiveWorkTypeResponses[keyof ArchiveWorkTypeResponses];

export type UpdateWorkTypeData = {
  body?: UpdateWorkType;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Work Type ID
     */
    workTypeId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/work-types/{workTypeId}';
};

export type UpdateWorkTypeResponses = {
  /**
   * Update WorkType response
   */
  200: WorkTypeResponse;
};

export type UpdateWorkTypeResponse =
  UpdateWorkTypeResponses[keyof UpdateWorkTypeResponses];

export type FindItemRequestsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: {
    parentNumber?: string;
    workTypeId?: string;
  };
  url: '/v1/organizations/{organizationId}/item-requests';
};

export type FindItemRequestsResponses = {
  /**
   * Find Item Requests response
   */
  200: ItemRequestListResponse;
};

export type FindItemRequestsResponse =
  FindItemRequestsResponses[keyof FindItemRequestsResponses];

export type AddItemRequestData = {
  body?: CreateItemRequest;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/item-requests';
};

export type AddItemRequestResponses = {
  /**
   * Add item request response
   */
  200: ItemRequestResponse;
};

export type AddItemRequestResponse =
  AddItemRequestResponses[keyof AddItemRequestResponses];

export type DeleteItemRequestData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Organization ID
     */
    itemRequestId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/item-requests/{itemRequestId}';
};

export type DeleteItemRequestResponses = {
  /**
   * Delete Item Request response
   */
  200: ItemRequestResponse;
};

export type DeleteItemRequestResponse =
  DeleteItemRequestResponses[keyof DeleteItemRequestResponses];

export type UpdateItemRequestData = {
  body?: UpdateItemRequest;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Organization ID
     */
    itemRequestId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/item-requests/{itemRequestId}';
};

export type UpdateItemRequestResponses = {
  /**
   * Update Item Request response
   */
  200: ItemRequestResponse;
};

export type UpdateItemRequestResponse =
  UpdateItemRequestResponses[keyof UpdateItemRequestResponses];

export type FindStoredViewsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/stored-views';
};

export type FindStoredViewsResponses = {
  /**
   * Stored Views list response
   */
  200: StoredViewListResponse;
};

export type FindStoredViewsResponse =
  FindStoredViewsResponses[keyof FindStoredViewsResponses];

export type CreateStoredViewData = {
  body?: CreateStoredView;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/stored-views';
};

export type CreateStoredViewResponses = {
  /**
   * Create Stored View response
   */
  200: StoredViewResponse;
};

export type CreateStoredViewResponse =
  CreateStoredViewResponses[keyof CreateStoredViewResponses];

export type DeleteStoredViewData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Stored View ID
     */
    storedViewId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/stored-views/{storedViewId}';
};

export type DeleteStoredViewResponses = {
  /**
   * Delete Stored View response
   */
  200: {
    success: boolean;
  };
};

export type DeleteStoredViewResponse =
  DeleteStoredViewResponses[keyof DeleteStoredViewResponses];

export type UpdateStoredViewData = {
  body?: UpdateStoredView;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Stored View ID
     */
    storedViewId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/stored-views/{storedViewId}';
};

export type UpdateStoredViewResponses = {
  /**
   * Update Stored View response
   */
  200: StoredViewResponse;
};

export type UpdateStoredViewResponse =
  UpdateStoredViewResponses[keyof UpdateStoredViewResponses];

export type FindBulkItemTemplatesData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/bulk-item-templates';
};

export type FindBulkItemTemplatesResponses = {
  /**
   * Find Bulk Item Templates response
   */
  200: BulkItemTemplateListResponse;
};

export type FindBulkItemTemplatesResponse =
  FindBulkItemTemplatesResponses[keyof FindBulkItemTemplatesResponses];

export type CreateBulkItemTemplateData = {
  body?: CreateBulkItemTemplate;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/bulk-item-templates';
};

export type CreateBulkItemTemplateResponses = {
  /**
   * Create Bulk Item Template response
   */
  200: BulkItemTemplateResponse;
};

export type CreateBulkItemTemplateResponse =
  CreateBulkItemTemplateResponses[keyof CreateBulkItemTemplateResponses];

export type DeleteBulkItemTemplateData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    bulkItemTemplateId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/bulk-item-templates/{bulkItemTemplateId}';
};

export type DeleteBulkItemTemplateResponses = {
  /**
   * Delete Bulk Item Template response
   */
  200: {
    success: boolean;
  };
};

export type DeleteBulkItemTemplateResponse =
  DeleteBulkItemTemplateResponses[keyof DeleteBulkItemTemplateResponses];

export type UpdateBulkItemTemplateData = {
  body?: UpdateBulkItemTemplate;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    bulkItemTemplateId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/bulk-item-templates/{bulkItemTemplateId}';
};

export type UpdateBulkItemTemplateResponses = {
  /**
   * Update Bulk Item Template response
   */
  200: BulkItemTemplateResponse;
};

export type UpdateBulkItemTemplateResponse =
  UpdateBulkItemTemplateResponses[keyof UpdateBulkItemTemplateResponses];

export type FindDescriptionTemplatesData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/description-templates';
};

export type FindDescriptionTemplatesResponses = {
  /**
   * Description Templates list response
   */
  200: DescriptionTemplateListResponse;
};

export type FindDescriptionTemplatesResponse =
  FindDescriptionTemplatesResponses[keyof FindDescriptionTemplatesResponses];

export type CreateDescriptionTemplateData = {
  body?: CreateDescriptionTemplate;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/description-templates';
};

export type CreateDescriptionTemplateResponses = {
  /**
   * Create Description Template response
   */
  200: DescriptionTemplateResponse;
};

export type CreateDescriptionTemplateResponse =
  CreateDescriptionTemplateResponses[keyof CreateDescriptionTemplateResponses];

export type DeleteDescriptionTemplateData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Description Template ID
     */
    descriptionTemplateId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/description-templates/{descriptionTemplateId}';
};

export type DeleteDescriptionTemplateResponses = {
  /**
   * Delete Description Template response
   */
  200: {
    success: boolean;
  };
};

export type DeleteDescriptionTemplateResponse =
  DeleteDescriptionTemplateResponses[keyof DeleteDescriptionTemplateResponses];

export type UpdateDescriptionTemplateData = {
  body?: UpdateDescriptionTemplate;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Description Template ID
     */
    descriptionTemplateId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/description-templates/{descriptionTemplateId}';
};

export type UpdateDescriptionTemplateResponses = {
  /**
   * Update Description Template response
   */
  200: DescriptionTemplateResponse;
};

export type UpdateDescriptionTemplateResponse =
  UpdateDescriptionTemplateResponses[keyof UpdateDescriptionTemplateResponses];

export type FindItemRequestGroupsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/item-request-groups';
};

export type FindItemRequestGroupsResponses = {
  /**
   * Item Request Group list response
   */
  200: ItemRequestGroupListResponse;
};

export type FindItemRequestGroupsResponse =
  FindItemRequestGroupsResponses[keyof FindItemRequestGroupsResponses];

export type CreateItemRequestGroupData = {
  body?: CreateItemRequestGroup;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/item-request-groups';
};

export type CreateItemRequestGroupResponses = {
  /**
   * Create Item Request Group response
   */
  200: ItemRequestGroupResponse;
};

export type CreateItemRequestGroupResponse =
  CreateItemRequestGroupResponses[keyof CreateItemRequestGroupResponses];

export type DeleteItemRequestGroupData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Request Group ID
     */
    itemRequestGroupId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/item-request-groups/{itemRequestGroupId}';
};

export type DeleteItemRequestGroupResponses = {
  /**
   * Delete Item Request response
   */
  200: ItemRequestGroupResponse;
};

export type DeleteItemRequestGroupResponse =
  DeleteItemRequestGroupResponses[keyof DeleteItemRequestGroupResponses];

export type UpdateItemRequestGroupData = {
  body?: UpdateItemRequestGroup;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Request Group ID
     */
    itemRequestGroupId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/item-request-groups/{itemRequestGroupId}';
};

export type UpdateItemRequestGroupResponses = {
  /**
   * Update Item Request Group response
   */
  200: ItemRequestGroupResponse;
};

export type UpdateItemRequestGroupResponse =
  UpdateItemRequestGroupResponses[keyof UpdateItemRequestGroupResponses];

export type SubmitPublicItemRequestData = {
  body?: {
    title: string;
    description?: {
      html: string;
    };
    priorityId?: string;
    customFields?: CustomFields;
    dueDate?: string | null;
  };
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Organization ID
     */
    itemRequestId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/item-requests/public/{itemRequestId}/submit';
};

export type SubmitPublicItemRequestResponses = {
  /**
   * Create Submit Public Item Request response
   */
  200: {
    success: boolean;
  };
};

export type SubmitPublicItemRequestResponse =
  SubmitPublicItemRequestResponses[keyof SubmitPublicItemRequestResponses];

export type SubmitItemRequestData = {
  body?: SubmitItemRequest;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Organization ID
     */
    itemRequestId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/item-requests/all/{itemRequestId}/submit';
};

export type SubmitItemRequestResponses = {
  /**
   * Create Submit Item Request response
   */
  200: WorkItemResponse;
};

export type SubmitItemRequestResponse =
  SubmitItemRequestResponses[keyof SubmitItemRequestResponses];

export type CreateCustomFieldData = {
  body?: CreateCustomField;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/custom-fields';
};

export type CreateCustomFieldResponses = {
  /**
   * Create Custom Field response
   */
  200: CustomFieldResponse;
};

export type CreateCustomFieldResponse =
  CreateCustomFieldResponses[keyof CreateCustomFieldResponses];

export type CreateCustomFieldCollectionData = {
  body?: CreateCustomFieldCollection;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/custom-field-collections';
};

export type CreateCustomFieldCollectionResponses = {
  /**
   * Create Custom Field Collection response
   */
  200: CustomFieldCollectionResponse;
};

export type CreateCustomFieldCollectionResponse =
  CreateCustomFieldCollectionResponses[keyof CreateCustomFieldCollectionResponses];

export type FindCustomFieldFormGroupsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: {
    customFieldCollectionId?: string;
  };
  url: '/v1/organizations/{organizationId}/custom-field-form-groups';
};

export type FindCustomFieldFormGroupsResponses = {
  /**
   * Find Custom Field Form Groups response
   */
  200: CustomFieldFormGroupListResponse;
};

export type FindCustomFieldFormGroupsResponse =
  FindCustomFieldFormGroupsResponses[keyof FindCustomFieldFormGroupsResponses];

export type CreateCustomFieldFormGroupData = {
  body?: CreateCustomFieldFromGroup;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/custom-field-form-groups';
};

export type CreateCustomFieldFormGroupResponses = {
  /**
   * Create Custom Field Form Group response
   */
  200: CustomFieldFormGroupResponse;
};

export type CreateCustomFieldFormGroupResponse =
  CreateCustomFieldFormGroupResponses[keyof CreateCustomFieldFormGroupResponses];

export type CreateLabelCollectionData = {
  body?: CreateLabelCollection;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/label-collections';
};

export type CreateLabelCollectionResponses = {
  /**
   * Create Label Collection response
   */
  200: LabelCollectionResponse;
};

export type CreateLabelCollectionResponse =
  CreateLabelCollectionResponses[keyof CreateLabelCollectionResponses];

export type CreateLabelData = {
  body?: CreateLabel;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/labels';
};

export type CreateLabelResponses = {
  /**
   * Create Label response
   */
  200: LabelResponse;
};

export type CreateLabelResponse =
  CreateLabelResponses[keyof CreateLabelResponses];

export type CreateLaneCollectionData = {
  body?: CreateLaneCollection;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/lane-collections';
};

export type CreateLaneCollectionResponses = {
  /**
   * Create Lane Collection response
   */
  200: LaneCollectionResponse;
};

export type CreateLaneCollectionResponse =
  CreateLaneCollectionResponses[keyof CreateLaneCollectionResponses];

export type CreateLaneData = {
  body?: CreateLane;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/lanes';
};

export type CreateLaneResponses = {
  /**
   * Create Lane response
   */
  200: LaneResponse;
};

export type CreateLaneResponse = CreateLaneResponses[keyof CreateLaneResponses];

export type CreateEstimateOptionCollectionData = {
  body?: CreateEstimateOptionCollection;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/estimate-option-collections';
};

export type CreateEstimateOptionCollectionResponses = {
  /**
   * Create Estimate Option Collection response
   */
  200: EstimateOptionCollectionResponse;
};

export type CreateEstimateOptionCollectionResponse =
  CreateEstimateOptionCollectionResponses[keyof CreateEstimateOptionCollectionResponses];

export type CreateEstimateOptionData = {
  body?: CreateEstimateOption;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/estimate-options';
};

export type CreateEstimateOptionResponses = {
  /**
   * Create Estimate Option response
   */
  200: EstimateOptionResponse;
};

export type CreateEstimateOptionResponse =
  CreateEstimateOptionResponses[keyof CreateEstimateOptionResponses];

export type CreatePriorityData = {
  body?: CreatePriority;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/priorities';
};

export type CreatePriorityResponses = {
  /**
   * Create Priority response
   */
  200: PriorityResponse;
};

export type CreatePriorityResponse =
  CreatePriorityResponses[keyof CreatePriorityResponses];

export type CreatePriorityCollectionData = {
  body?: CreatePriorityCollection;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/priority-collections';
};

export type CreatePriorityCollectionResponses = {
  /**
   * Create Priority Collection response
   */
  200: PriorityCollectionResponse;
};

export type CreatePriorityCollectionResponse =
  CreatePriorityCollectionResponses[keyof CreatePriorityCollectionResponses];

export type DeleteCustomFieldData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Custom Field ID
     */
    customFieldId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/custom-fields/{customFieldId}';
};

export type DeleteCustomFieldResponses = {
  /**
   * Delete Custom Field response
   */
  200: CustomFieldResponse;
};

export type DeleteCustomFieldResponse =
  DeleteCustomFieldResponses[keyof DeleteCustomFieldResponses];

export type UpdateCustomFieldData = {
  body?: UpdateCustomField;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Custom Field ID
     */
    customFieldId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/custom-fields/{customFieldId}';
};

export type UpdateCustomFieldResponses = {
  /**
   * Update Custom Field response
   */
  200: CustomFieldResponse;
};

export type UpdateCustomFieldResponse =
  UpdateCustomFieldResponses[keyof UpdateCustomFieldResponses];

export type DeleteCustomFieldFormGroupData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Custom Field Form Group ID
     */
    customFieldFormGroupId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/custom-field-form-groups/{customFieldFormGroupId}';
};

export type DeleteCustomFieldFormGroupResponses = {
  /**
   * Delete Custom Field Form Group response
   */
  200: {
    success: boolean;
  };
};

export type DeleteCustomFieldFormGroupResponse =
  DeleteCustomFieldFormGroupResponses[keyof DeleteCustomFieldFormGroupResponses];

export type UpdateCustomFieldFormGroupData = {
  body?: UpdateCustomFieldFormGroup;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Custom Field Form Group ID
     */
    customFieldFormGroupId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/custom-field-form-groups/{customFieldFormGroupId}';
};

export type UpdateCustomFieldFormGroupResponses = {
  /**
   * Update Custom Field Form Group response
   */
  200: CustomFieldFormGroupResponse;
};

export type UpdateCustomFieldFormGroupResponse =
  UpdateCustomFieldFormGroupResponses[keyof UpdateCustomFieldFormGroupResponses];

export type DeleteCustomFieldCollectionData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Custom Field Collection ID
     */
    customFieldCollectionId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/custom-field-collections/{customFieldCollectionId}';
};

export type DeleteCustomFieldCollectionResponses = {
  /**
   * Delete Custom Field Collection response
   */
  200: CustomFieldCollectionResponse;
};

export type DeleteCustomFieldCollectionResponse =
  DeleteCustomFieldCollectionResponses[keyof DeleteCustomFieldCollectionResponses];

export type UpdateCustomFieldCollectionData = {
  body?: UpdateCustomFieldCollection;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Custom Field Collection ID
     */
    customFieldCollectionId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/custom-field-collections/{customFieldCollectionId}';
};

export type UpdateCustomFieldCollectionResponses = {
  /**
   * Update Custom Field Collection response
   */
  200: CustomFieldCollectionResponse;
};

export type UpdateCustomFieldCollectionResponse =
  UpdateCustomFieldCollectionResponses[keyof UpdateCustomFieldCollectionResponses];

export type DeleteEstimateOptionData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Estimate Option ID
     */
    estimateOptionId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/estimate-options/{estimateOptionId}';
};

export type DeleteEstimateOptionResponses = {
  /**
   * Delete Estimate Option response
   */
  200: EstimateOptionResponse;
};

export type DeleteEstimateOptionResponse =
  DeleteEstimateOptionResponses[keyof DeleteEstimateOptionResponses];

export type UpdateEstimateOptionData = {
  body?: UpdateEstimateOption;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Estimate Option ID
     */
    estimateOptionId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/estimate-options/{estimateOptionId}';
};

export type UpdateEstimateOptionResponses = {
  /**
   * Update Estimate Option response
   */
  200: EstimateOptionResponse;
};

export type UpdateEstimateOptionResponse =
  UpdateEstimateOptionResponses[keyof UpdateEstimateOptionResponses];

export type DeleteEstimateOptionCollectionData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Estimate Option Collection ID
     */
    estimateOptionCollectionId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/estimate-option-collections/{estimateOptionCollectionId}';
};

export type DeleteEstimateOptionCollectionResponses = {
  /**
   * Delete Estimate Option Collection response
   */
  200: EstimateOptionCollectionResponse;
};

export type DeleteEstimateOptionCollectionResponse =
  DeleteEstimateOptionCollectionResponses[keyof DeleteEstimateOptionCollectionResponses];

export type UpdateEstimateOptionCollectionData = {
  body?: UpdateEstimateOptionCollection;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Estimate Option Collection ID
     */
    estimateOptionCollectionId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/estimate-option-collections/{estimateOptionCollectionId}';
};

export type UpdateEstimateOptionCollectionResponses = {
  /**
   * Update Estimate Option Collection response
   */
  200: EstimateOptionCollectionResponse;
};

export type UpdateEstimateOptionCollectionResponse =
  UpdateEstimateOptionCollectionResponses[keyof UpdateEstimateOptionCollectionResponses];

export type DeleteLabelData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Label ID
     */
    labelId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/labels/{labelId}';
};

export type DeleteLabelResponses = {
  /**
   * Delete Label response
   */
  200: LabelResponse;
};

export type DeleteLabelResponse =
  DeleteLabelResponses[keyof DeleteLabelResponses];

export type UpdateLabelData = {
  body?: UpdateLabel;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Label ID
     */
    labelId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/labels/{labelId}';
};

export type UpdateLabelResponses = {
  /**
   * Update Label response
   */
  200: LabelResponse;
};

export type UpdateLabelResponse =
  UpdateLabelResponses[keyof UpdateLabelResponses];

export type DeleteLabelCollectionData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Label Collection ID
     */
    labelCollectionId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/label-collections/{labelCollectionId}';
};

export type DeleteLabelCollectionResponses = {
  /**
   * Delete Label Collection response
   */
  200: LabelCollectionResponse;
};

export type DeleteLabelCollectionResponse =
  DeleteLabelCollectionResponses[keyof DeleteLabelCollectionResponses];

export type UpdateLabelCollectionData = {
  body?: UpdateLabelCollection;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Label Collection ID
     */
    labelCollectionId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/label-collections/{labelCollectionId}';
};

export type UpdateLabelCollectionResponses = {
  /**
   * Update Label Collection response
   */
  200: LabelCollectionResponse;
};

export type UpdateLabelCollectionResponse =
  UpdateLabelCollectionResponses[keyof UpdateLabelCollectionResponses];

export type DeleteLaneData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Lane ID
     */
    laneId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/lanes/{laneId}';
};

export type DeleteLaneResponses = {
  /**
   * Delete Lane response
   */
  200: LaneResponse;
};

export type DeleteLaneResponse = DeleteLaneResponses[keyof DeleteLaneResponses];

export type UpdateLaneData = {
  body?: UpdateLane;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Lane ID
     */
    laneId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/lanes/{laneId}';
};

export type UpdateLaneResponses = {
  /**
   * Update Lane response
   */
  200: LaneResponse;
};

export type UpdateLaneResponse = UpdateLaneResponses[keyof UpdateLaneResponses];

export type DeleteLaneCollectionData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Lane Collection ID
     */
    laneCollectionId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/lane-collections/{laneCollectionId}';
};

export type DeleteLaneCollectionResponses = {
  /**
   * Delete Lane Collection response
   */
  200: LaneCollectionResponse;
};

export type DeleteLaneCollectionResponse =
  DeleteLaneCollectionResponses[keyof DeleteLaneCollectionResponses];

export type UpdateLaneCollectionData = {
  body?: UpdateLaneCollection;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Lane Collection ID
     */
    laneCollectionId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/lane-collections/{laneCollectionId}';
};

export type UpdateLaneCollectionResponses = {
  /**
   * Update Lane Collection response
   */
  200: LaneCollectionResponse;
};

export type UpdateLaneCollectionResponse =
  UpdateLaneCollectionResponses[keyof UpdateLaneCollectionResponses];

export type DeletePriorityData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Priority ID
     */
    priorityId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/priorities/{priorityId}';
};

export type DeletePriorityResponses = {
  /**
   * Delete Priority response
   */
  200: PriorityResponse;
};

export type DeletePriorityResponse =
  DeletePriorityResponses[keyof DeletePriorityResponses];

export type UpdatePriorityData = {
  body?: UpdatePriority;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Priority ID
     */
    priorityId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/priorities/{priorityId}';
};

export type UpdatePriorityResponses = {
  /**
   * Update Priority response
   */
  200: PriorityResponse;
};

export type UpdatePriorityResponse =
  UpdatePriorityResponses[keyof UpdatePriorityResponses];

export type DeletePriorityCollectionData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Priority Collection ID
     */
    priorityCollectionId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/priority-collections/{priorityCollectionId}';
};

export type DeletePriorityCollectionResponses = {
  /**
   * Delete Priority Collection response
   */
  200: PriorityCollectionResponse;
};

export type DeletePriorityCollectionResponse =
  DeletePriorityCollectionResponses[keyof DeletePriorityCollectionResponses];

export type UpdatePriorityCollectionData = {
  body?: UpdatePriorityCollection;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Priority Collection ID
     */
    priorityCollectionId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/priority-collections/{priorityCollectionId}';
};

export type UpdatePriorityCollectionResponses = {
  /**
   * Update Priority Collection response
   */
  200: PriorityCollectionResponse;
};

export type UpdatePriorityCollectionResponse =
  UpdatePriorityCollectionResponses[keyof UpdatePriorityCollectionResponses];

export type FindOrganizationsData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/v1/admin/organizations/all';
};

export type FindOrganizationsResponses = {
  /**
   * Find Organizations
   */
  200: OrganizationListResponse;
};

export type FindOrganizationsResponse =
  FindOrganizationsResponses[keyof FindOrganizationsResponses];

export type CheckIfOrganizationExistsData = {
  body?: never;
  path?: never;
  query: {
    name: string;
  };
  url: '/v1/organizations/exists';
};

export type CheckIfOrganizationExistsResponses = {
  /**
   * Exists response
   */
  200: boolean;
};

export type CheckIfOrganizationExistsResponse =
  CheckIfOrganizationExistsResponses[keyof CheckIfOrganizationExistsResponses];

export type FindOrganizationsByDomainData = {
  body?: never;
  path: {
    domain: string;
  };
  query?: never;
  url: '/v1/organizations/domains/{domain}';
};

export type FindOrganizationsByDomainResponses = {
  /**
   * Find Organizations By Domain response
   */
  200: OrganizationSimpleListResponse;
};

export type FindOrganizationsByDomainResponse =
  FindOrganizationsByDomainResponses[keyof FindOrganizationsByDomainResponses];

export type GetItemRequestByIdData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Organization ID
     */
    itemRequestId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/item-requests/all/{itemRequestId}';
};

export type GetItemRequestByIdResponses = {
  /**
   * Get Item Request By Id response
   */
  200: ItemRequestResponse;
};

export type GetItemRequestByIdResponse =
  GetItemRequestByIdResponses[keyof GetItemRequestByIdResponses];

export type GetPublicItemRequestByIdData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Organization ID
     */
    itemRequestId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/item-requests/public/{itemRequestId}';
};

export type GetPublicItemRequestByIdResponses = {
  /**
   * Get Public Item Request By Id response
   */
  200: ItemRequestResponse;
};

export type GetPublicItemRequestByIdResponse =
  GetPublicItemRequestByIdResponses[keyof GetPublicItemRequestByIdResponses];

export type GetPublicItemRequestUploadUrlData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Organization ID
     */
    itemRequestId: string;
  };
  query: {
    fileName: string;
    fileType: string;
  };
  url: '/v1/organizations/{organizationId}/item-requests/public/{itemRequestId}/get-upload-url';
};

export type GetPublicItemRequestUploadUrlResponses = {
  /**
   * Get Public Item Request Upload Url response
   */
  200: PreSignedUrlResponse;
};

export type GetPublicItemRequestUploadUrlResponse =
  GetPublicItemRequestUploadUrlResponses[keyof GetPublicItemRequestUploadUrlResponses];

export type GetPublicStoredViewByIdData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Stored View ID
     */
    storedViewId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/stored-views/public/{storedViewId}';
};

export type GetPublicStoredViewByIdResponses = {
  /**
   * Get Public Stored View By Id response
   */
  200: StoredViewExtendedResponse;
};

export type GetPublicStoredViewByIdResponse =
  GetPublicStoredViewByIdResponses[keyof GetPublicStoredViewByIdResponses];

export type GetConnectionDetailsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/database-credentials/details';
};

export type GetConnectionDetailsResponses = {
  /**
   * Connection details for BI tool configuration
   */
  200: ConnectionDetails;
};

export type GetConnectionDetailsResponse =
  GetConnectionDetailsResponses[keyof GetConnectionDetailsResponses];

export type GetPusherAuthData = {
  body?: never;
  path?: never;
  query: {
    socketId: string;
    channelName: string;
  };
  url: '/v1/pusher/authenticate';
};

export type GetPusherAuthResponses = {
  /**
   * Get Pusher Auth response
   */
  200: PusherAuthResponse;
};

export type GetPusherAuthResponse =
  GetPusherAuthResponses[keyof GetPusherAuthResponses];

export type GetPusherEventByIdData = {
  body?: never;
  path: {
    /**
     * Event ID
     */
    eventId: string;
  };
  query?: never;
  url: '/v1/pusher/events/{eventId}';
};

export type GetPusherEventByIdResponses = {
  /**
   * Pusher Event
   */
  200: {
    /**
     * Pusher Event Base
     */
    data?: {
      [key: string]: unknown;
    };
    metadata?: {
      eventId: string;
    };
  };
};

export type GetPusherEventByIdResponse =
  GetPusherEventByIdResponses[keyof GetPusherEventByIdResponses];

export type FindRoadmapsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: {
    /**
     * Limit
     */
    limit?: number;
    /**
     * Cursor
     */
    cursor?: string;
    /**
     * Direction
     */
    direction?: 'asc' | 'desc';
    roadmapGroupId?: string;
  };
  url: '/v1/organizations/{organizationId}/roadmaps';
};

export type FindRoadmapsResponses = {
  /**
   * Roadmap response
   */
  200: RoadmapListResponse;
};

export type FindRoadmapsResponse =
  FindRoadmapsResponses[keyof FindRoadmapsResponses];

export type CreateRoadmapData = {
  body?: CreateRoadmap;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/roadmaps';
};

export type CreateRoadmapResponses = {
  /**
   * Create Roadmap response
   */
  200: RoadmapResponse;
};

export type CreateRoadmapResponse =
  CreateRoadmapResponses[keyof CreateRoadmapResponses];

export type DeleteRoadmapData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Roadmap ID
     */
    roadmapId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/roadmaps/{roadmapId}';
};

export type DeleteRoadmapResponses = {
  /**
   * Success response
   */
  200: {
    success: boolean;
  };
};

export type DeleteRoadmapResponse =
  DeleteRoadmapResponses[keyof DeleteRoadmapResponses];

export type GetRoadmapByIdData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    roadmapId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/roadmaps/{roadmapId}';
};

export type GetRoadmapByIdResponses = {
  /**
   * Roadmaps response
   */
  200: RoadmapResponse;
};

export type GetRoadmapByIdResponse =
  GetRoadmapByIdResponses[keyof GetRoadmapByIdResponses];

export type UpdateRoadmapData = {
  body?: UpdateRoadmap;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Roadmap ID
     */
    roadmapId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/roadmaps/{roadmapId}';
};

export type UpdateRoadmapResponses = {
  /**
   * Update Roadmap response
   */
  200: RoadmapResponse;
};

export type UpdateRoadmapResponse =
  UpdateRoadmapResponses[keyof UpdateRoadmapResponses];

export type CreateInitiativeData = {
  body?: CreateInitiative;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/initiatives';
};

export type CreateInitiativeResponses = {
  /**
   * Create Initiative response
   */
  200: InitiativeResponse;
};

export type CreateInitiativeResponse =
  CreateInitiativeResponses[keyof CreateInitiativeResponses];

export type DeleteInitiativeData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Initiative ID
     */
    initiativeId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/initiatives/{initiativeId}';
};

export type DeleteInitiativeResponses = {
  /**
   * Success response
   */
  200: {
    success: boolean;
  };
};

export type DeleteInitiativeResponse =
  DeleteInitiativeResponses[keyof DeleteInitiativeResponses];

export type UpdateInitiativeData = {
  body?: UpdateInitiative;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Initiative ID
     */
    initiativeId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/initiatives/{initiativeId}';
};

export type UpdateInitiativeResponses = {
  /**
   * Update Initiative response
   */
  200: InitiativeResponse;
};

export type UpdateInitiativeResponse =
  UpdateInitiativeResponses[keyof UpdateInitiativeResponses];

export type CreateMilestoneData = {
  body?: CreateMilestone;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/milestones';
};

export type CreateMilestoneResponses = {
  /**
   * Create Milestone response
   */
  200: MilestoneResponse;
};

export type CreateMilestoneResponse =
  CreateMilestoneResponses[keyof CreateMilestoneResponses];

export type DeleteMilestoneData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Milestone ID
     */
    milestoneId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/milestones/{milestoneId}';
};

export type DeleteMilestoneResponses = {
  /**
   * Success response
   */
  200: {
    success: boolean;
  };
};

export type DeleteMilestoneResponse =
  DeleteMilestoneResponses[keyof DeleteMilestoneResponses];

export type UpdateMilestoneData = {
  body?: UpdateMilestone;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Milestone ID
     */
    milestoneId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/milestones/{milestoneId}';
};

export type UpdateMilestoneResponses = {
  /**
   * Update Milestone response
   */
  200: MilestoneResponse;
};

export type UpdateMilestoneResponse =
  UpdateMilestoneResponses[keyof UpdateMilestoneResponses];

export type CreateScenarioData = {
  body?: CreateScenario;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/scenarios';
};

export type CreateScenarioResponses = {
  /**
   * Create Scenario response
   */
  200: ScenarioResponse;
};

export type CreateScenarioResponse =
  CreateScenarioResponses[keyof CreateScenarioResponses];

export type DeleteScenarioData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Scenario ID
     */
    scenarioId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/scenarios/{scenarioId}';
};

export type DeleteScenarioResponses = {
  /**
   * Success response
   */
  200: {
    success: boolean;
  };
};

export type DeleteScenarioResponse =
  DeleteScenarioResponses[keyof DeleteScenarioResponses];

export type UpdateScenarioData = {
  body?: UpdateScenario;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Scenario ID
     */
    scenarioId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/scenarios/{scenarioId}';
};

export type UpdateScenarioResponses = {
  /**
   * Update Scenario response
   */
  200: ScenarioResponse;
};

export type UpdateScenarioResponse =
  UpdateScenarioResponses[keyof UpdateScenarioResponses];

export type FindRoadmapGroupsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/roadmap-groups';
};

export type FindRoadmapGroupsResponses = {
  /**
   * Roadmap response
   */
  200: RoadmapGroupListResponse;
};

export type FindRoadmapGroupsResponse =
  FindRoadmapGroupsResponses[keyof FindRoadmapGroupsResponses];

export type CreateRoadmapGroupData = {
  body?: CreateRoadmapGroup;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/roadmap-groups';
};

export type CreateRoadmapGroupResponses = {
  /**
   * Create Roadmap Group response
   */
  200: RoadmapGroupResponse;
};

export type CreateRoadmapGroupResponse =
  CreateRoadmapGroupResponses[keyof CreateRoadmapGroupResponses];

export type DeleteRoadmapGroupData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Request Group ID
     */
    roadmapGroupId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/roadmap-groups/{roadmapGroupId}';
};

export type DeleteRoadmapGroupResponses = {
  /**
   * Success response
   */
  200: {
    success: boolean;
  };
};

export type DeleteRoadmapGroupResponse =
  DeleteRoadmapGroupResponses[keyof DeleteRoadmapGroupResponses];

export type UpdateRoadmapGroupData = {
  body?: UpdateRoadmapGroup;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Request Group ID
     */
    roadmapGroupId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/roadmap-groups/{roadmapGroupId}';
};

export type UpdateRoadmapGroupResponses = {
  /**
   * Update Roadmap Group response
   */
  200: RoadmapGroupResponse;
};

export type UpdateRoadmapGroupResponse =
  UpdateRoadmapGroupResponses[keyof UpdateRoadmapGroupResponses];

export type UpdateRoadmapItemData = {
  body?: UpdateRoadmapItem;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Roadmap ID
     */
    roadmapId: string;
    /**
     * Item Number
     */
    itemNumber: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/roadmaps/{roadmapId}/items/{itemNumber}';
};

export type UpdateRoadmapItemResponses = {
  /**
   * Update Roadmap Item response
   */
  200: RoadmapItemResponse;
};

export type UpdateRoadmapItemResponse =
  UpdateRoadmapItemResponses[keyof UpdateRoadmapItemResponses];

export type DeleteSlackInstallationData = {
  body?: never;
  path: {
    organizationId: string;
    workspaceId: string;
  };
  query?: never;
  url: '/v1/integrations/slack/{organizationId}/{workspaceId}';
};

export type DeleteSlackInstallationResponses = {
  /**
   * Slack installation deleted successfully
   */
  204: void;
};

export type DeleteSlackInstallationResponse =
  DeleteSlackInstallationResponses[keyof DeleteSlackInstallationResponses];

export type InitiateSlackOAuthData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/integrations/slack/{organizationId}/oauth/initiate';
};

export type InitiateSlackOAuthResponses = {
  /**
   * Initiate Slack OAuth response with auth URL
   */
  200: {
    authUrl: string;
  };
};

export type InitiateSlackOAuthResponse =
  InitiateSlackOAuthResponses[keyof InitiateSlackOAuthResponses];

export type SlackOAuthCallbackData = {
  body?: never;
  path?: never;
  query: {
    code: string;
    state: string;
  };
  url: '/v1/integrations/slack/oauth/callback';
};

export type FindSlackInstallationsByOrganizationIdData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/integrations/slack/{organizationId}';
};

export type FindSlackInstallationsByOrganizationIdResponses = {
  /**
   * Slack Installation List Response
   */
  200: {
    data: Array<SlackInstallation>;
    meta: {
      cursor?: string;
      aggregations?: {
        [key: string]: {
          [key: string]: unknown;
        };
      };
      total?: number;
      hasMoreData: boolean;
    };
  };
};

export type FindSlackInstallationsByOrganizationIdResponse =
  FindSlackInstallationsByOrganizationIdResponses[keyof FindSlackInstallationsByOrganizationIdResponses];

export type CheckIfPaymentMethodsExistsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/subscriptions/{organizationId}/payment-methods/exists';
};

export type CheckIfPaymentMethodsExistsResponses = {
  /**
   * Check if Payment Methods exists response
   */
  200: {
    exists: boolean;
  };
};

export type CheckIfPaymentMethodsExistsResponse =
  CheckIfPaymentMethodsExistsResponses[keyof CheckIfPaymentMethodsExistsResponses];

export type GetPaymentMethodsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/subscriptions/{organizationId}/payment-methods';
};

export type GetPaymentMethodsResponses = {
  /**
   * Payment Methods response
   */
  200: PaymentMethodListResponse;
};

export type GetPaymentMethodsResponse =
  GetPaymentMethodsResponses[keyof GetPaymentMethodsResponses];

export type GetSubscriptionInvoicesData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: {
    /**
     * Limit
     */
    limit?: number;
    /**
     * Cursor
     */
    cursor?: string;
    /**
     * Direction
     */
    direction?: 'asc' | 'desc';
  };
  url: '/v1/subscriptions/{organizationId}/invoices';
};

export type GetSubscriptionInvoicesResponses = {
  /**
   * Invoices response
   */
  200: InvoiceListResponse;
};

export type GetSubscriptionInvoicesResponse =
  GetSubscriptionInvoicesResponses[keyof GetSubscriptionInvoicesResponses];

export type GetProductsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/subscriptions/{organizationId}/products';
};

export type GetProductsResponses = {
  /**
   * Products response
   */
  200: ProductListResponse;
};

export type GetProductsResponse =
  GetProductsResponses[keyof GetProductsResponses];

export type GetCustomerData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/subscriptions/{organizationId}/customer';
};

export type GetCustomerResponses = {
  /**
   * Customer response
   */
  200: Customer;
};

export type GetCustomerResponse =
  GetCustomerResponses[keyof GetCustomerResponses];

export type SetupPaymentMethodData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/subscriptions/{organizationId}/setup';
};

export type SetupPaymentMethodResponses = {
  /**
   * Setup Payment Method response
   */
  200: SetupPaymentMethodResponse;
};

export type SetupPaymentMethodResponse2 =
  SetupPaymentMethodResponses[keyof SetupPaymentMethodResponses];

export type SetDefaultPaymentMethodData = {
  body?: SetDefaultPaymentMethod;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/subscriptions/{organizationId}/set-default-payment-method';
};

export type SetDefaultPaymentMethodResponses = {
  /**
   * Set Default Payment Method response
   */
  200: {
    success: true;
  };
};

export type SetDefaultPaymentMethodResponse =
  SetDefaultPaymentMethodResponses[keyof SetDefaultPaymentMethodResponses];

export type DeletePaymentMethodData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Payment Method ID
     */
    paymentMethodId: string;
  };
  query?: never;
  url: '/v1/subscriptions/{organizationId}/payment-methods/{paymentMethodId}';
};

export type DeletePaymentMethodResponses = {
  /**
   * Delete Payment Method response
   */
  200: {
    success: true;
  };
};

export type DeletePaymentMethodResponse =
  DeletePaymentMethodResponses[keyof DeletePaymentMethodResponses];

export type CreateSubscriptionData = {
  body?: CreateSubscription;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: 'v1/subscriptions/{organizationId}';
};

export type CreateSubscriptionResponses = {
  /**
   * Create Subscription response
   */
  200: SubscriptionResponse;
};

export type CreateSubscriptionResponse =
  CreateSubscriptionResponses[keyof CreateSubscriptionResponses];

export type UpdateSubscriptionData = {
  body?: UpdateSubscription;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/subscriptions/{organizationId}';
};

export type UpdateSubscriptionResponses = {
  /**
   * Update Subscription response
   */
  200: SubscriptionResponse;
};

export type UpdateSubscriptionResponse =
  UpdateSubscriptionResponses[keyof UpdateSubscriptionResponses];

export type CreateProductData = {
  body?: CreateProduct;
  path?: never;
  query?: never;
  url: '/v1/admin/subscriptions/products';
};

export type CreateProductResponses = {
  /**
   * Create Product response
   */
  200: Product;
};

export type CreateProductResponse =
  CreateProductResponses[keyof CreateProductResponses];

export type UpdateProductData = {
  body?: UpdateProduct;
  path: {
    /**
     * Product ID
     */
    productId: string;
  };
  query?: never;
  url: '/v1/admin/subscriptions/products/{productId}';
};

export type UpdateProductResponses = {
  /**
   * Update Product response
   */
  200: Product;
};

export type UpdateProductResponse =
  UpdateProductResponses[keyof UpdateProductResponses];

export type FindTimeEntriesData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: {
    itemNumber?: string;
    hierarchy?: string;
    authorUsername?: string;
    startDateGte?: string;
    startDateLte?: string;
    endDateGte?: string;
    endDateLte?: string;
    completed?: boolean;
    lengthGte?: string;
    lengthLte?: string;
    sortBy?:
      | 'itemNumber'
      | 'authorUsername'
      | 'startDate'
      | 'endDate'
      | 'lengthSeconds'
      | 'dateAdded';
    /**
     * Base64 encoded metadata filter
     */
    metadata?: string;
    /**
     * Limit
     */
    limit?: number;
    /**
     * Cursor
     */
    cursor?: string;
    /**
     * Direction
     */
    direction?: 'asc' | 'desc';
  };
  url: '/v1/organizations/{organizationId}/time-entries';
};

export type FindTimeEntriesResponses = {
  /**
   * Time Entries response
   */
  200: TimeEntryListResponse;
};

export type FindTimeEntriesResponse =
  FindTimeEntriesResponses[keyof FindTimeEntriesResponses];

export type CreateTimeEntryData = {
  body?: CreateTimeEntry;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/time-entries';
};

export type CreateTimeEntryResponses = {
  /**
   * Create Time Entry response
   */
  200: TimeEntryResponse;
};

export type CreateTimeEntryResponse =
  CreateTimeEntryResponses[keyof CreateTimeEntryResponses];

export type DeleteTimeEntryData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    timeEntryId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/time-entries/{timeEntryId}';
};

export type DeleteTimeEntryResponses = {
  /**
   * Success response
   */
  204: {
    success: boolean;
  };
};

export type DeleteTimeEntryResponse =
  DeleteTimeEntryResponses[keyof DeleteTimeEntryResponses];

export type UpdateTimeEntryData = {
  body?: UpdateTimeEntry;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    timeEntryId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/time-entries/{timeEntryId}';
};

export type UpdateTimeEntryResponses = {
  /**
   * Update Time Entry response
   */
  200: TimeEntryResponse;
};

export type UpdateTimeEntryResponse =
  UpdateTimeEntryResponses[keyof UpdateTimeEntryResponses];

export type GetActiveTimeEntryData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/time-entries/active';
};

export type GetActiveTimeEntryResponses = {
  /**
   * Active Time Entry response
   */
  200: TimeEntryResponse;
  /**
   * No active time entry found
   */
  204: void;
};

export type GetActiveTimeEntryResponse =
  GetActiveTimeEntryResponses[keyof GetActiveTimeEntryResponses];

export type FindWorkflowsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: {
    /**
     * Limit
     */
    limit?: number;
    /**
     * Cursor
     */
    cursor?: string;
    /**
     * Direction
     */
    direction?: 'asc' | 'desc';
    trigger?:
      | 'schedule'
      | 'due_date_arrived'
      | 'webhook'
      | 'item_created'
      | 'item_updated'
      | 'item_archived'
      | 'folder_created'
      | 'folder_updated'
      | 'folder_archived'
      | 'item_request_submitted';
    workflowGroupId?: string;
    hasNoGroup?: boolean;
  };
  url: '/v1/organizations/{organizationId}/workflows';
};

export type FindWorkflowsResponses = {
  /**
   * Workflow List Response
   */
  200: {
    data: Array<Workflow>;
    meta: {
      cursor?: string;
      aggregations?: {
        [key: string]: {
          [key: string]: unknown;
        };
      };
      total?: number;
      hasMoreData: boolean;
    };
  };
};

export type FindWorkflowsResponse =
  FindWorkflowsResponses[keyof FindWorkflowsResponses];

export type CreateWorkflowData = {
  body?: CreateWorkflow;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/workflows';
};

export type CreateWorkflowResponses = {
  /**
   * Create Workflow response
   */
  200: WorkflowResponse;
};

export type CreateWorkflowResponse =
  CreateWorkflowResponses[keyof CreateWorkflowResponses];

export type FindWorkflowGroupsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/workflow-groups';
};

export type FindWorkflowGroupsResponses = {
  /**
   * WorkflowGroup List Response
   */
  200: {
    data: Array<WorkflowGroup>;
    meta: {
      cursor?: string;
      aggregations?: {
        [key: string]: {
          [key: string]: unknown;
        };
      };
      total?: number;
      hasMoreData: boolean;
    };
  };
};

export type FindWorkflowGroupsResponse =
  FindWorkflowGroupsResponses[keyof FindWorkflowGroupsResponses];

export type CreateWorkflowGroupData = {
  body?: CreateWorkflowGroup;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/workflow-groups';
};

export type CreateWorkflowGroupResponses = {
  /**
   * Create Workflow Group response
   */
  200: WorkflowGroupResponse;
};

export type CreateWorkflowGroupResponse =
  CreateWorkflowGroupResponses[keyof CreateWorkflowGroupResponses];

export type FindWorkflowRunsData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: {
    /**
     * Limit
     */
    limit?: number;
    /**
     * Cursor
     */
    cursor?: string;
    /**
     * Direction
     */
    direction?: 'asc' | 'desc';
    workflowId?: string;
    status?: 'started' | 'skipped' | 'running' | 'completed' | 'failed';
  };
  url: '/v1/organizations/{organizationId}/workflow-runs';
};

export type FindWorkflowRunsResponses = {
  /**
   * Workflow Runs response
   */
  200: WorkflowRunListResponse;
};

export type FindWorkflowRunsResponse =
  FindWorkflowRunsResponses[keyof FindWorkflowRunsResponses];

export type DeleteWorkflowData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    workflowId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/workflows/{workflowId}';
};

export type DeleteWorkflowResponses = {
  /**
   * Delete Workflow response
   */
  200: WorkflowResponse;
};

export type DeleteWorkflowResponse =
  DeleteWorkflowResponses[keyof DeleteWorkflowResponses];

export type UpdateWorkflowData = {
  body?: UpdateWorkflow;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    workflowId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/workflows/{workflowId}';
};

export type UpdateWorkflowResponses = {
  /**
   * Update Workflow response
   */
  200: WorkflowResponse;
};

export type UpdateWorkflowResponse =
  UpdateWorkflowResponses[keyof UpdateWorkflowResponses];

export type DeleteWorkflowGroupData = {
  body?: never;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Request Group ID
     */
    workflowGroupId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/workflow-groups/{workflowGroupId}';
};

export type DeleteWorkflowGroupResponses = {
  /**
   * Delete Workflow Group response
   */
  200: WorkflowGroupResponse;
};

export type DeleteWorkflowGroupResponse =
  DeleteWorkflowGroupResponses[keyof DeleteWorkflowGroupResponses];

export type UpdateWorkflowGroupData = {
  body?: UpdateWorkflowGroup;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
    /**
     * Item Request Group ID
     */
    workflowGroupId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/workflow-groups/{workflowGroupId}';
};

export type UpdateWorkflowGroupResponses = {
  /**
   * Update Workflow Group response
   */
  200: WorkflowGroupResponse;
};

export type UpdateWorkflowGroupResponse =
  UpdateWorkflowGroupResponses[keyof UpdateWorkflowGroupResponses];

export type CreateWebhookData = {
  body?: CreateWebhook;
  path: {
    /**
     * Organization ID
     */
    organizationId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/webhooks';
};

export type CreateWebhookResponses = {
  /**
   * Create Webhook response
   */
  200: WebhookResponse;
};

export type CreateWebhookResponse =
  CreateWebhookResponses[keyof CreateWebhookResponses];

export type TriggerWebhookWorkflowsData = {
  body?: {
    [key: string]: unknown;
  };
  path: {
    organizationId: string;
    webhookId: string;
  };
  query?: never;
  url: '/v1/organizations/{organizationId}/webhooks/{webhookId}';
};

export type TriggerWebhookWorkflowsResponses = {
  /**
   * Trigger Webhook Workflows response
   */
  200: {
    success: boolean;
  };
};

export type TriggerWebhookWorkflowsResponse =
  TriggerWebhookWorkflowsResponses[keyof TriggerWebhookWorkflowsResponses];
